// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PlayerSessionResultsDialog.css - Redesigned Premium iOS Dynamic Bright/Dark Glassmorphic Theme */

.player-session-results__backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background: var(--glass-bg) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  display: flex !important;
  align-items: flex-end !important;
  justify-content: center !important;
  z-index: 9999 !important;
  padding: 0 !important;
  overflow: hidden !important;
  overscroll-behavior: none !important;
  touch-action: none !important;
  transition: background 0.3s ease !important;
  box-sizing: border-box !important;
}

/* Mobile — full-screen iOS page presentation (safe area below browser chrome) */
@media (max-width: 599px) {
  .player-session-results__backdrop {
    align-items: stretch !important;
    justify-content: flex-start !important;
    flex-direction: column !important;
    padding-top: env(safe-area-inset-top, 0px) !important;
    padding-bottom: env(safe-area-inset-bottom, 0px) !important;
    padding-left: env(safe-area-inset-left, 0px) !important;
    padding-right: env(safe-area-inset-right, 0px) !important;
  }

  .player-session-results__sheet {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    max-height: none !important;
    height: auto !important;
    border-radius: 0 !important;
    padding-top: 0 !important;
    box-shadow: none !important;
    border-left: none !important;
    border-right: none !important;
    animation: iosPageSlideUp 0.32s cubic-bezier(0.16, 1, 0.3, 1) !important;
  }

  .player-session-results__sheet--nested {
    animation: iosPageSlideFromRight 0.32s cubic-bezier(0.16, 1, 0.3, 1) !important;
  }

  .player-session-results__sheet--nested,
  .player-session-results__sheet--fullwidth {
    min-height: 0 !important;
    max-height: none !important;
    border-radius: 0 !important;
  }

  .player-session-results__handle {
    display: none !important;
  }

  .player-session-results__close {
    display: none !important;
  }

  .player-session-results__back-btn--ios-nav {
    display: flex !important;
    margin-bottom: 0 !important;
  }

  .player-session-results__header {
    position: sticky !important;
    top: 0 !important;
    z-index: 15 !important;
    padding-right: max(16px, env(safe-area-inset-right, 0px)) !important;
    padding-left: max(16px, env(safe-area-inset-left, 0px)) !important;
  }

  /* Modal sheet: header clears browser/status chrome */
  .player-session-results__backdrop .player-session-results__header {
    padding-top: max(12px, env(safe-area-inset-top, 0px)) !important;
  }

  /* Page mode sits under the app Header — don't double-count safe-area */
  .player-session-results__sheet--page .player-session-results__header {
    padding-top: 12px !important;
  }

  .player-session-results__backdrop {
    /* Header owns top inset; keep sides/bottom */
    padding-top: 0 !important;
  }

  .player-session-results__sheet {
    padding-top: 0 !important;
  }

  .player-session-results__page-shell {
    padding-top: 0 !important;
    padding-left: max(0px, env(safe-area-inset-left, 0px)) !important;
    padding-right: max(0px, env(safe-area-inset-right, 0px)) !important;
    padding-bottom: 0 !important;
  }

  .player-session-results__sheet--page {
    margin-top: 0 !important;
    min-height: 0 !important;
    border-radius: 0 !important;
  }

  .player-session-results__sheet--page .player-session-results__body {
    padding-bottom: max(28px, env(safe-area-inset-bottom, 0px)) !important;
  }

  .player-session-results__close {
    top: max(12px, env(safe-area-inset-top, 0px)) !important;
  }
}

@keyframes iosPageSlideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes iosPageSlideFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

@media (min-width: 600px) {
  .player-session-results__backdrop {
    align-items: center !important;
    padding: 24px !important;
  }

}

.player-session-results__sheet {
  background: var(--surface-color) !important;
  width: 100% !important;
  max-width: 720px !important; /* Slightly wider for the widescreen look */
  border-radius: 36px 36px 0 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
  box-shadow: 0 -8px 30px var(--shadow-color) !important;
  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1) !important;
  min-height: 75vh !important;
  max-height: calc(92dvh - env(safe-area-inset-top, 0px)) !important;
  padding-top: env(safe-area-inset-top, 0px) !important;
  color: var(--text-color) !important;
  border-left: 1px solid var(--border-color) !important;
  border-right: 1px solid var(--border-color) !important;
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease !important;
  touch-action: auto !important;
}

@media (min-width: 600px) {
  .player-session-results__sheet {
    border-radius: 24px !important;
    border: 1px solid var(--border-color) !important;
    min-height: 600px !important;
    max-height: 85vh !important;
    max-width: min(1100px, calc(100vw - 48px)) !important;
    box-shadow: 0 10px 40px var(--shadow-color) !important;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

/* Grab Handle centered like on iOS sheets */
.player-session-results__handle {
  width: 36px !important;
  height: 5px !important;
  background-color: var(--text-secondary) !important;
  opacity: 0.3 !important;
  border-radius: 2.5px !important;
  margin: 10px auto 0 !important;
  flex-shrink: 0 !important;
}

/* Header & Close Button */
.player-session-results__close {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  flex-shrink: 0 !important;
  background: var(--border-color) !important;
  border: none !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--text-color) !important;
  cursor: pointer !important;
  z-index: 20 !important;
  transition: all 0.2s ease !important;
}

.player-session-results__close:hover,
.player-session-results__close:active {
  background: rgba(120, 120, 128, 0.30) !important;
  transform: scale(0.95) !important;
}

.player-session-results__close svg {
  font-size: 18px !important;
}

/* Coach tools live in the header row (not under browser chrome) */
.player-session-results__header-top {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
  min-height: 32px !important;
  margin-bottom: 4px !important;
}

.player-session-results__header-top-spacer {
  width: 1px !important;
  height: 1px !important;
  flex-shrink: 0 !important;
}

.player-session-results__header-actions,
.player-session-results__header-actions--inline {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  z-index: 2 !important;
  flex-shrink: 0 !important;
  margin-left: auto !important;
}

.player-session-results__icon-btn,
.player-session-results__settings {
  position: relative !important;
  top: auto !important;
  right: auto !important;
  background: rgba(120, 120, 128, 0.16) !important;
  border: 1px solid rgba(120, 120, 128, 0.22) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: var(--text-color) !important;
  cursor: pointer !important;
  z-index: 2 !important;
  transition: all 0.2s ease !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  -webkit-tap-highlight-color: transparent !important;
}

.player-session-results__icon-btn:hover,
.player-session-results__icon-btn:active,
.player-session-results__settings:hover,
.player-session-results__settings:active {
  background: rgba(120, 120, 128, 0.30) !important;
  transform: scale(0.95) !important;
}

.player-session-results__icon-btn:focus-visible,
.player-session-results__settings:focus-visible {
  outline: 2px solid rgba(10, 132, 255, 0.55) !important;
  outline-offset: 2px !important;
}

.player-session-results__icon-btn svg,
.player-session-results__settings svg {
  font-size: 20px !important;
  color: inherit !important;
  fill: currentColor !important;
  opacity: 1 !important;
}


.player-session-results__content {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  flex: 1 1 !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.player-session-results__header {
  padding: 8px 24px 20px 24px !important;
  border-bottom: 1px solid var(--border-color) !important;
  background: var(--surface-color) !important;
  flex-shrink: 0 !important;
  transition: background 0.3s ease, border-color 0.3s ease !important;
}

.player-session-results__sheet--page .player-session-results__header {
  padding-top: 12px !important;
}

.player-session-results__title {
  margin: 0 !important;
  font-size: 22px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  letter-spacing: -0.5px !important;
  text-align: left !important;
}

.player-session-results__subtitle {
  margin: 4px 0 0 !important;
  font-size: 14px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
  text-align: left !important;
}

/* Modern iOS Header Layout with badge, title and subtitle */
.player-session-results__header-new {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  width: 100% !important;
}

.player-session-results__ex-nav {
  display: inline-flex !important;
  align-items: center !important;
  gap: 2px !important;
  flex-shrink: 0 !important;
  padding: 2px !important;
  border-radius: 999px !important;
  background: rgba(128, 128, 128, 0.1) !important;
  border: 1px solid rgba(128, 128, 128, 0.14) !important;
}

.player-session-results__ex-nav-btn {
  appearance: none !important;
  width: 30px !important;
  height: 30px !important;
  border: none !important;
  border-radius: 50% !important;
  background: transparent !important;
  color: var(--text-secondary, #64748b) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition:
    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    color 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),
    opacity 0.2s ease !important;
}

.player-session-results__ex-nav-btn:hover:not(:disabled) {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
  color: var(--brand-primary, #0877BC) !important;
}

.player-session-results__ex-nav-btn:active:not(:disabled) {
  transform: scale(0.94) !important;
}

.player-session-results__ex-nav-btn:disabled {
  opacity: 0.28 !important;
  cursor: default !important;
}

.player-session-results__ex-nav-btn:focus-visible {
  outline: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55) !important;
  outline-offset: 1px !important;
}

.player-session-results__ex-nav .player-session-results__badge-circle {
  width: 34px !important;
  height: 34px !important;
  font-size: 14px !important;
  box-shadow: 0 4px 10px rgba(8, 119, 188, 0.22) !important;
}

.player-session-results__ex-nav-count {
  font-weight: 600 !important;
  opacity: 0.8 !important;
}

.player-session-results__badge-circle {
  width: 38px !important;
  height: 38px !important;
  background-color: var(--brand-primary, #0877BC) !important; /* Premium Branding badge */
  color: #FFFFFF !important;
  font-size: 16px !important;
  font-weight: 800 !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
}

.player-session-results__header-text {
  flex: 1 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  text-align: left !important;
}

.player-session-results__title-row {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 0 !important;
}

.player-session-results__ex-change-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  color: var(--brand-primary, #0877bc) !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  line-height: 0 !important;
}

.player-session-results__ex-change-btn--seating {
  width: auto !important;
  height: 32px !important;
  padding: 0 10px 0 8px !important;
  border-radius: 16px !important;
  gap: 4px !important;
  line-height: 1 !important;
}

.player-session-results__ex-change-btn-label {
  font-size: 12px !important;
  font-weight: 700 !important;
  letter-spacing: -0.1px !important;
  white-space: nowrap !important;
}

.player-session-results__ex-change-btn:hover,
.player-session-results__ex-change-btn:focus-visible {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2) !important;
  outline: none !important;
}

.player-session-results__ex-card--disabled .player-session-results__ex-change-btn {
  pointer-events: auto !important;
  opacity: 1 !important;
}

.player-session-results__title-new {
  margin: 0 !important;
  font-size: 20px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  letter-spacing: -0.4px !important;
  line-height: 1.2 !important;
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
}

.player-session-results__title-row .player-session-results__title-new {
  flex: 1 1 !important;
  min-width: 0 !important;
}

.player-session-results__title-brand {
  color: var(--brand-primary, #0877BC) !important;
}

.player-session-results__title-number {
  color: var(--brand-primary, #0877BC) !important;
}

.player-session-results__title-accent {
  color: var(--text-color) !important;
}

.player-session-results__subtitle-new {
  margin: 4px 0 0 !important;
  font-size: 15px !important;
  color: var(--text-secondary) !important;
  font-weight: 400 !important;
  line-height: 1.35 !important;
}

.player-session-results__subtitle-meta {
  margin: 2px 0 0 !important;
  font-size: 15px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
  line-height: 1.35 !important;
}

/* Scrollable Body - Layered Grey/Dark bg */
.player-session-results__body {
  padding: 20px !important;
  flex: 1 1 !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overscroll-behavior: contain !important;
  -webkit-overflow-scrolling: touch !important;
  touch-action: pan-y !important;
  background: var(--bg-color) !important;
  transition: background 0.3s ease !important;
}

/* Details Tabs Bar */
.player-exercise-details__catalog-missing {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px dashed rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);
}

.player-exercise-details__catalog-missing-text {
  flex: 1 1 220px;
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.4;
  color: var(--text-color);
}

.player-exercise-details__catalog-missing-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: 0;
  border-radius: 999px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}

.player-exercise-details__catalog-missing-btn:active {
  transform: scale(0.97);
}

.player-exercise-details__tabs {
  display: flex !important;
  background: transparent !important;
  border: none !important;
  border-bottom: 1px solid var(--border-color) !important;
  padding: 0 !important;
  border-radius: 0 !important;
  margin-bottom: 20px !important;
  gap: 0 !important;
  position: relative !important;
  transition: border-color 0.3s ease !important;
}

.player-exercise-details__tab {
  flex: 1 1 !important;
  border: none !important;
  background: none !important;
  padding: 12px 4px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
  cursor: pointer !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  position: relative !important;
  transition: color 0.2s ease !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.player-exercise-details__tab svg {
  font-size: 16px !important;
}

.player-exercise-details__tab--active {
  background: transparent !important;
  color: var(--brand-primary, #0877BC) !important; /* Highlight brand active tab */
  box-shadow: none !important;
}

/* iOS Active Underscore Indicator */
.player-exercise-details__tab::after {
  content: "" !important;
  position: absolute !important;
  bottom: -1px !important;
  left: 15% !important;
  right: 15% !important;
  height: 3px !important;
  background-color: transparent !important;
  border-radius: 3px 3px 0 0 !important;
  transition: background-color 0.2s ease !important;
}

.player-exercise-details__tab--active::after {
  background-color: var(--brand-primary, #0877BC) !important;
}

/* Sequences Tab List */
.player-exercise-details__seq-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.player-exercise-details__seq-row {
  background: var(--surface-color) !important;
  border-radius: 14px !important;
  padding: 14px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 2px 8px var(--shadow-color) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__seq-num {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  background: var(--border-color) !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__seq-num--active {
  color: #fff !important;
  background: #34C759 !important;
  box-shadow: 0 0 0 3px rgba(52, 199, 89, 0.22) !important;
}

.player-exercise-details__seq-num--sparring {
  color: #fff !important;
  background: #FF9800 !important;
  box-shadow: 0 0 0 3px rgba(255, 152, 0, 0.22) !important;
}

.player-exercise-details__seq-num--neutral {
  color: var(--text-secondary) !important;
  background: color-mix(in srgb, var(--text-color) 10%, var(--surface-color)) !important;
}

.player-exercise-details__seq-content {
  flex: 1 1 !important;
  text-align: left !important;
  min-width: 0 !important;
}

.player-exercise-details__seq-title-row {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 8px !important;
  margin-bottom: 2px !important;
}

.player-exercise-details__seq-header {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: space-between !important;
  gap: 10px !important;
  width: 100% !important;
}

.player-exercise-details__seq-header-main {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

.player-exercise-details__seq-title {
  margin: 0 !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  line-height: 1.3 !important;
}

.player-exercise-details__seq-partner {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  width: 100% !important;
  padding-left: 38px !important;
}

.player-exercise-details__seq-partner-line {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: baseline !important;
  gap: 5px !important;
  line-height: 1.35 !important;
}

.player-exercise-details__seq-partner-meta {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 6px !important;
}

.player-exercise-details__seq-partner-rank {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--text-secondary) !important;
  letter-spacing: 0.01em !important;
}

.player-exercise-details__seq-footer {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 10px !important;
  width: 100% !important;
  padding-left: 38px !important;
  margin-top: 2px !important;
}

.player-exercise-details__seq-role {
  font-size: 11px !important;
  color: var(--text-secondary) !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
}

.player-exercise-details__seq-role--active {
  color: #34C759 !important; /* iOS system green */
  font-weight: 600 !important;
}

.player-exercise-details__seq-role--sparring {
  color: #FF9800 !important; /* Sparring orange */
  font-weight: 600 !important;
}

.player-exercise-details__seq-role-pill {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 3px 9px !important;
  border-radius: 999px !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  text-transform: uppercase !important;
  line-height: 1.2 !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__seq-role-pill--sm {
  padding: 2px 7px !important;
  font-size: 10px !important;
  font-weight: 700 !important;
}

.player-exercise-details__seq-role-pill--active {
  color: #34C759 !important;
  background: rgba(52, 199, 89, 0.18) !important;
  border: 1px solid rgba(52, 199, 89, 0.4) !important;
}

.player-exercise-details__seq-role-pill--sparring {
  color: #FF9800 !important;
  background: rgba(255, 152, 0, 0.18) !important;
  border: 1px solid rgba(255, 152, 0, 0.42) !important;
}

.player-exercise-details__seq-role-pill--neutral {
  color: var(--text-secondary) !important;
  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color)) !important;
  border: 1px solid var(--border-color) !important;
}

.light-mode .player-exercise-details__seq-role-pill--active {
  color: #1b7a35 !important;
}

.light-mode .player-exercise-details__seq-role-pill--sparring {
  color: #9a5a00 !important;
}

.player-exercise-details__seq-camera-sources {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 6px !important;
  margin: 0 0 8px !important;
}

.player-exercise-details__seq-camera-chip {
  display: inline-flex !important;
  align-items: center !important;
  padding: 4px 10px !important;
  border-radius: 999px !important;
  border: 1px solid var(--border-color) !important;
  background: color-mix(in srgb, var(--text-color) 5%, var(--surface-color)) !important;
  color: var(--text-color) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  cursor: pointer !important;
}

.player-exercise-details__seq-camera-chip:hover {
  border-color: color-mix(in srgb, var(--primary-color, #4c8bf5) 50%, var(--border-color)) !important;
  background: color-mix(in srgb, var(--primary-color, #4c8bf5) 12%, var(--surface-color)) !important;
}

.player-exercise-details__seq-opponent {
  margin-top: 4px !important;
  font-size: 12px !important;
  color: var(--text-secondary) !important;
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 4px !important;
  line-height: 1.35 !important;
}

.player-exercise-details__seq-opponent-prefix {
  font-weight: 650 !important;
  text-transform: none !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  opacity: 0.8 !important;
}

.player-exercise-details__seq-opponent-name {
  font-weight: 600 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__seq-opponent-role {
  font-size: 11px !important;
  font-weight: 600 !important;
}

.player-exercise-details__seq-actions {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex-shrink: 0 !important;
  overflow: visible !important;
}

.player-exercise-details__seq-action-btn {
  appearance: none !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 10px !important;
  border: 1px solid var(--border-color) !important;
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  color: var(--text-secondary) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  padding: 0 !important;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease !important;
}

.player-exercise-details__seq-action-btn:hover {
  transform: scale(1.04) !important;
}

.player-exercise-details__seq-action-btn:active {
  transform: scale(0.96) !important;
}

.player-exercise-details__seq-action-btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc) !important;
  outline-offset: 2px !important;
}

.player-exercise-details__seq-action-btn--video {
  position: relative !important;
  color: var(--brand-secondary, #46528b) !important;
  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 28%, transparent) !important;
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 10%, var(--surface-color)) !important;
}

.player-exercise-details__seq-action-btn--video:hover {
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 16%, var(--surface-color)) !important;
}

.player-exercise-details__seq-action-btn--hr {
  color: #FF453A !important;
  border-color: color-mix(in srgb, #FF453A 28%, transparent) !important;
  background: color-mix(in srgb, #FF453A 10%, var(--surface-color)) !important;
}

.player-exercise-details__seq-action-btn--hr:hover {
  background: color-mix(in srgb, #FF453A 16%, var(--surface-color)) !important;
}

.player-exercise-details__seq-video-action {
  position: relative !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__seq-action-btn--video-open {
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 20%, var(--surface-color)) !important;
  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 45%, transparent) !important;
}

.player-exercise-details__seq-video-count {
  position: absolute !important;
  top: -5px !important;
  right: -5px !important;
  min-width: 16px !important;
  height: 16px !important;
  padding: 0 4px !important;
  border-radius: 999px !important;
  background: var(--brand-secondary, #46528b) !important;
  color: #fff !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  line-height: 16px !important;
  text-align: center !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18) !important;
}

.player-exercise-details__seq-camera-menu {
  min-width: 168px !important;
  padding: 6px !important;
  border-radius: 12px !important;
  border: 1px solid var(--border-color) !important;
  background: var(--surface-color) !important;
  box-shadow: 0 10px 28px var(--shadow-color), 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 2px !important;
}

.player-exercise-details__seq-camera-menu:not(.player-exercise-details__seq-camera-menu--portal) {
  position: absolute !important;
  top: calc(100% + 6px) !important;
  right: 0 !important;
  z-index: 40 !important;
}

.player-exercise-details__seq-camera-menu--portal {
  /* Position comes from inline style (fixed top/left/bottom/width/maxHeight). */
  z-index: 12000 !important;
  overflow-y: auto !important;
  overscroll-behavior: contain !important;
  -webkit-overflow-scrolling: touch !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

.player-exercise-details__seq-camera-menu-item {
  appearance: none !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--text-color) !important;
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  width: 100% !important;
  padding: 8px 10px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  text-align: left !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  transition: background 0.12s ease !important;
}

.player-exercise-details__seq-camera-menu-item:hover,
.player-exercise-details__seq-camera-menu-item:focus-visible {
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 10%, transparent) !important;
  outline: none !important;
}

.player-exercise-details__seq-camera-badge {
  width: 26px !important;
  height: 26px !important;
  border-radius: 8px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0 !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  color: #fff !important;
  background: #64748b !important;
}

.player-exercise-details__seq-camera-badge--a {
  background: #0ea5e9 !important;
}

.player-exercise-details__seq-camera-badge--b {
  background: #8b5cf6 !important;
}

.player-exercise-details__seq-camera-badge--c {
  background: #10b981 !important;
}

.player-exercise-details__seq-camera-badge--d {
  background: #f59e0b !important;
}

.player-exercise-details__seq-camera-menu-label {
  flex: 1 1 !important;
  line-height: 1.25 !important;
}

.player-exercise-details__perf-list-heading {
  margin: 0 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  text-transform: uppercase !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__perf-seq-list-wrap {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.player-exercise-details__perf-role-legend {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  gap: 10px !important;
}

.player-exercise-details__perf-role-legend-item {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.player-exercise-details__perf-role-legend-dot {
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__perf-role-legend-item--active {
  color: #34C759 !important;
}

.player-exercise-details__perf-role-legend-item--active
  .player-exercise-details__perf-role-legend-dot {
  background: #34C759 !important;
}

.player-exercise-details__perf-role-legend-item--sparring {
  color: #FF9800 !important;
}

.player-exercise-details__perf-role-legend-item--sparring
  .player-exercise-details__perf-role-legend-dot {
  background: #FF9800 !important;
}

.player-exercise-details__perf-seq-card--active {
  border-left: 4px solid #34C759 !important;
  background: color-mix(in srgb, #34C759 10%, var(--surface-color)) !important;
  border-color: rgba(52, 199, 89, 0.28) !important;
}

.player-exercise-details__perf-seq-card--sparring {
  border-left: 4px solid #FF9800 !important;
  background: color-mix(in srgb, #FF9800 10%, var(--surface-color)) !important;
  border-color: rgba(255, 152, 0, 0.28) !important;
}

.player-exercise-details__perf-seq-card--neutral {
  border-left: 4px solid var(--border-color) !important;
}

.player-exercise-details__seq-dur {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  background: var(--border-color) !important;
  border: 1px solid var(--border-color) !important;
  padding: 4px 8px !important;
  border-radius: 6px !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease !important;
}

/* Performance tab — sequences grouped by participation role */
.player-exercise-details__perf-sequences {
  display: flex !important;
  flex-direction: column !important;
  gap: 18px !important;
}

.player-exercise-details__perf-role-section {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.player-exercise-details__perf-role-heading {
  margin: 0 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  text-transform: uppercase !important;
}

.player-exercise-details__perf-role-heading--active {
  color: #34C759 !important;
}

.player-exercise-details__perf-role-heading--sparring {
  color: #FF9800 !important;
}

.player-exercise-details__perf-seq-grid {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
}

.player-exercise-details__perf-seq-card {
  background: var(--surface-color) !important;
  border-radius: 14px !important;
  padding: 14px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 2px 8px var(--shadow-color) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  justify-content: flex-start !important;
  gap: 8px !important;
  overflow: visible !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__perf-role-section--active .player-exercise-details__perf-seq-card {
  border-left: 3px solid #34C759 !important;
}

.player-exercise-details__perf-role-section--sparring .player-exercise-details__perf-seq-card {
  border-left: 3px solid #FF9800 !important;
}

/* Premium Heart Rate Sections styling */
.player-exercise-details__section-title {
  font-size: 16px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  letter-spacing: -0.3px !important;
  margin: 0 0 12px !important;
  text-align: left !important;
}

.player-exercise-details__section-title--inline {
  margin: 0 !important;
}

.player-exercise-details__zones-title-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
  margin-bottom: 8px !important;
}

.player-exercise-details__zones-info-btn {
  appearance: none !important;
  border: 0 !important;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) !important;
  color: var(--brand-primary, #0877bc) !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  flex-shrink: 0 !important;
  transition: background 0.2s ease, transform 0.15s ease !important;
}

.player-exercise-details__zones-info-btn:hover {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 20%, var(--surface-color)) !important;
}

.player-exercise-details__zones-info-btn--open {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--surface-color)) !important;
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) !important;
}

.player-exercise-details__zones-info-btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc) !important;
  outline-offset: 2px !important;
}

.player-exercise-details__zones-info-card {
  margin: 0 0 12px !important;
  padding: 12px 14px !important;
  border-radius: 12px !important;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, var(--surface-color)) !important;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color)) !important;
}

.player-exercise-details__zones-info-heading {
  margin: 0 0 6px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__zones-info-heading + .player-exercise-details__zones-info-text + .player-exercise-details__zones-info-heading {
  margin-top: 10px !important;
}

.player-exercise-details__zones-info-text {
  margin: 0 !important;
  font-size: 11px !important;
  line-height: 1.45 !important;
  color: var(--text-secondary) !important;
  white-space: pre-line !important;
}

.player-exercise-details__zones-info-meta {
  margin: 8px 0 0 !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  color: var(--brand-primary, #0877bc) !important;
}


.player-exercise-details__hr-summary-card--session {
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}

.player-exercise-details__hr-subcard--duration {
  background-color: rgba(100, 210, 255, 0.08) !important;
  color: #64d2ff !important;
}

.player-exercise-details__hr-subcard--intensity,
.player-exercise-details__hr-subcard--max_intensity {
  background-color: rgba(175, 82, 222, 0.08) !important;
  color: #af52de !important;
}

.player-exercise-details__hr-subcard--avg_intensity {
  background-color: rgba(8, 119, 188, 0.08) !important;
  color: #0877bc !important;
}

.player-exercise-details__hr-subcard--calories {
  background-color: rgba(255, 149, 0, 0.08) !important;
  color: #ff9500 !important;
}

.player-exercise-details__hr-subcard-icon--intensity,
.player-exercise-details__hr-subcard-icon--max_intensity {
  color: #af52de !important;
}

.player-exercise-details__hr-subcard-icon--avg_intensity {
  color: #0877bc !important;
}

.player-exercise-details__hr-subcard-icon--calories {
  color: #ff9500 !important;
}

.player-exercise-details__hr-curve-card--dark,
html[data-theme="dark"] .player-exercise-details__hr-curve-card,
body[data-theme="dark"] .player-exercise-details__hr-curve-card {
  background: #0d1117 !important;
  border-color: rgba(255, 255, 255, 0.08) !important;
}

.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-curve-header,
html[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-curve-header,
body[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-curve-header {
  color: #fff !important;
}

.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-role-toggle,
html[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-toggle,
body[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-toggle {
  background: rgba(255, 255, 255, 0.06) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-role-hint,
html[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-hint,
body[data-theme="dark"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-hint {
  color: rgba(255, 255, 255, 0.65) !important;
}

.session-summary-dialog__chart-wrap {
  min-height: 180px;
}

.session-summary-dialog__metric-footnote {
  display: block;
  margin-top: 2px;
  font-size: 0.62rem;
  font-weight: 500;
  text-align: center;
  color: var(--text-secondary);
  line-height: 1.2;
}

.session-summary-dialog__mhr-caption {
  margin: -4px 0 12px;
  font-size: 0.78rem;
  color: var(--text-secondary);
}

.session-summary-dialog__empty-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 69, 58, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  border: 1px solid rgba(255, 69, 58, 0.2);
}

.session-summary-dialog__empty-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-color);
  text-align: center;
}

.session-summary-dialog__empty-text {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
  max-width: 280px;
  line-height: 1.4;
  text-align: center;
}

/* Three columns layout inside single container card */
.player-exercise-details__hr-summary-card {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 12px !important;
  background: var(--surface-color) !important;
  border-radius: 18px !important;
  padding: 16px 12px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 2px 10px var(--shadow-color) !important;
  margin-bottom: 20px !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__hr-subcard {
  border-radius: 12px !important;
  padding: 12px 6px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 4px !important;
}

/* Colored subcard backgrounds matching system states */
.player-exercise-details__hr-subcard--max {
  background-color: rgba(255, 69, 58, 0.08) !important; /* Max Red */
  color: #FF453A !important;
}

.player-exercise-details__hr-subcard--avg {
  background-color: rgba(52, 199, 89, 0.08) !important; /* Avg Green */
  color: #34C759 !important;
}

.player-exercise-details__hr-subcard--min {
  background-color: rgba(50, 215, 75, 0.08) !important; /* Min Green */
  color: #34C759 !important;
}

.player-exercise-details__hr-subcard-header {
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  color: var(--text-secondary) !important;
  opacity: 0.8 !important;
}

.player-exercise-details__hr-subcard-icon {
  flex-shrink: 0 !important;
}

.player-exercise-details__hr-subcard-icon--max {
  color: #FF453A !important;
}

.player-exercise-details__hr-subcard-icon--avg {
  color: #34C759 !important;
}

.player-exercise-details__hr-subcard-icon--min {
  color: #34C759 !important;
}

.player-exercise-details__hr-subcard-value {
  font-size: 21px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  letter-spacing: -0.5px !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.player-exercise-details__hr-subcard--duration .player-exercise-details__hr-subcard-value {
  font-size: 18px !important;
}

.player-exercise-details__hr-subcard-unit {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__hr-subcard .duration-metric-value {
  display: inline-flex !important;
  align-items: baseline !important;
  flex-wrap: nowrap !important;
  white-space: nowrap !important;
  gap: 0.2em !important;
}

.player-exercise-details__hr-subcard .duration-metric-value__part {
  display: inline-flex !important;
  align-items: baseline !important;
}

.player-exercise-details__hr-subcard .duration-metric-value__num {
  font-size: inherit !important;
  font-weight: inherit !important;
}

.player-exercise-details__hr-subcard .duration-metric-value__unit {
  font-size: 0.52em !important;
  font-weight: 700 !important;
  opacity: 0.72 !important;
  margin-left: 0.08em !important;
  color: var(--text-secondary) !important;
}

/* Gorgeous Performance Curve container */
.player-exercise-details__hr-curve-card {
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  border-radius: 16px !important;
  padding: 10px 14px 8px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 4px 20px var(--shadow-color) !important;
  margin-bottom: 12px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__hr-curve-header-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
  flex-wrap: wrap !important;
  margin-bottom: 0 !important;
}

.player-exercise-details__hr-curve-header {
  font-size: 14px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  text-align: left !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
  letter-spacing: -0.2px !important;
}

html[data-theme="light"] .player-exercise-details__hr-curve-header,
body[data-theme="light"] .player-exercise-details__hr-curve-header,
body.light-mode .player-exercise-details__hr-curve-header,
.player-exercise-details__hr-curve-card:not(.player-exercise-details__hr-curve-card--dark) .player-exercise-details__hr-curve-header {
  color: #0f172a !important;
}

.player-exercise-details__hr-role-toggle {
  display: inline-flex !important;
  align-items: center !important;
  padding: 3px !important;
  border-radius: 10px !important;
  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color)) !important;
  border: 1px solid var(--border-color) !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__hr-role-btn {
  appearance: none !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--text-secondary) !important;
  font-size: 11px !important;
  font-weight: 650 !important;
  line-height: 1 !important;
  padding: 7px 10px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease !important;
}

.player-exercise-details__hr-role-btn:hover {
  color: var(--text-color) !important;
}

.player-exercise-details__hr-role-btn:focus-visible {
  outline: 2px solid #0877bc !important;
  outline-offset: 1px !important;
}

.player-exercise-details__hr-role-btn--both {
  background: color-mix(in srgb, var(--text-color) 10%, var(--surface-color)) !important;
  color: var(--text-color) !important;
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--text-color) 18%, transparent) !important;
}

.player-exercise-details__hr-role-btn--active {
  background: rgba(52, 199, 89, 0.16) !important;
  color: #34C759 !important;
  box-shadow: inset 0 0 0 1px rgba(52, 199, 89, 0.35) !important;
}

.player-exercise-details__hr-role-btn--sparring {
  background: rgba(255, 152, 0, 0.16) !important;
  color: #FF9800 !important;
  box-shadow: inset 0 0 0 1px rgba(255, 152, 0, 0.35) !important;
}

.player-exercise-details__hr-role-btn--empty {
  opacity: 0.55 !important;
}

.player-exercise-details__hr-role-hint {
  margin: 0 !important;
  font-size: 11px !important;
  line-height: 1.25 !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__hr-role-hint--selected {
  color: var(--text-color) !important;
  font-weight: 600 !important;
}

.player-exercise-details__hr-clear-seq {
  appearance: none !important;
  border: 0 !important;
  background: none !important;
  color: var(--brand-primary, #0877bc) !important;
  font: inherit !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  padding: 0 !important;
  text-decoration: underline !important;
  text-underline-offset: 2px !important;
}

.player-exercise-details__hr-clear-seq:hover {
  opacity: 0.85 !important;
}

.player-exercise-details__hr-curve-card--seq-selected {
  box-shadow:
    0 2px 8px var(--shadow-color),
    0 0 0 1px color-mix(in srgb, #FF453A 22%, transparent) !important;
}

.player-exercise-details__hr-seq-band--selected {
  stroke: currentColor !important;
}

@keyframes player-hr-seq-band-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.72;
  }
}

.player-exercise-details__hr-curve-card--seq-selected .player-exercise-details__hr-seq-band--selected {
  animation: player-hr-seq-band-pulse 1.6s ease-in-out 2;
}

.player-exercise-details__hr-curve-body {
  display: flex !important;
  flex-direction: row !important;
  align-items: stretch !important;
  gap: 0 !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.player-exercise-details__hr-curve-body--with-xticks {
  height: auto !important;
}

@media (min-width: 768px) {
  .player-exercise-details__hr-curve-axis {
    width: 32px !important;
    font-size: 11px !important;
    padding: 12px 0 34px !important;
  }
}

.player-exercise-details__hr-curve-axis {
  display: none !important;
}

.player-exercise-details__hr-curve-chart {
  flex: 1 1 100% !important;
  position: relative !important;
  min-width: 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 0 !important;
}

@media (max-width: 640px) {
  .player-exercise-details__hr-curve-card,
  .player-exercise-details__hr-curve-card--mobile {
    padding: 8px 8px 6px !important;
    border-radius: 14px !important;
    gap: 6px !important;
    margin-bottom: 10px !important;
  }

  .player-exercise-details__hr-curve-header-row {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 6px !important;
  }

  .player-exercise-details__hr-curve-header {
    font-size: 14px !important;
    font-weight: 800 !important;
    width: 100% !important;
    line-height: 1.25 !important;
    letter-spacing: -0.2px !important;
    display: block !important;
    color: #0f172a !important;
  }

  .player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-curve-header,
  html[data-theme="dark"] .player-exercise-details__hr-curve-header,
  body[data-theme="dark"] .player-exercise-details__hr-curve-header {
    color: #ffffff !important;
  }

  .player-exercise-details__hr-role-toggle {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
    padding: 2px !important;
    box-sizing: border-box !important;
  }

  .player-exercise-details__hr-role-btn {
    flex: 1 1 !important;
    text-align: center !important;
    padding: 6px 4px !important;
    font-size: 11px !important;
  }

  .player-exercise-details__hr-curve-body {
    gap: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .player-exercise-details__hr-curve-axis {
    display: none !important;
  }

  .player-exercise-details__hr-curve-chart {
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
  }
}

.player-exercise-details__hr-svg {
  display: block !important;
  width: 100% !important;
  height: auto !important;
  overflow: visible !important;
}

.player-exercise-details__hr-line-path {
  filter: drop-shadow(0 0 6px rgba(255, 51, 75, 0.7)) drop-shadow(0 2px 12px rgba(255, 51, 75, 0.35));
}

.player-exercise-details__hr-zone-label {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  letter-spacing: 0.02em !important;
}

.player-exercise-details__hr-xtick-label {
  -webkit-user-select: none !important;
          user-select: none !important;
  fill: #0f172a !important;
  font-weight: 700 !important;
}

html[data-theme="light"] .player-exercise-details__hr-xtick-label,
body[data-theme="light"] .player-exercise-details__hr-xtick-label,
body.light-mode .player-exercise-details__hr-xtick-label,
.player-exercise-details__hr-curve-card:not(.player-exercise-details__hr-curve-card--dark) .player-exercise-details__hr-xtick-label {
  fill: #0f172a !important;
}

.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-xtick-label,
html[data-theme="dark"] .player-exercise-details__hr-xtick-label,
body[data-theme="dark"] .player-exercise-details__hr-xtick-label {
  fill: rgba(255, 255, 255, 0.92) !important;
}

/* Glow Pulse circle ring animation */
@keyframes pulse {
  0% {
    transform: scale(0.6);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

.pulse-ring {
  transform-origin: center !important;
  transform-box: fill-box !important;
  animation: pulse 2.5s infinite ease-out !important;
}

/* Active Training Zones card */
.player-exercise-details__hr-zones-card {
  background: var(--surface-color) !important;
  border-radius: 18px !important;
  padding: 16px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 2px 10px var(--shadow-color) !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__zone-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  margin-top: 12px !important;
}

.player-exercise-details__zone-row {
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  gap: 6px !important;
  width: 100% !important;
}

.player-exercise-details__zone-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  gap: 12px !important;
}

.player-exercise-details__zone-badge {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  color: #FFFFFF !important;
  flex-shrink: 0 !important;
}

/* Zone Badge Colors — match HrPerformanceCurveChart / ZONE_DEFS */
.player-exercise-details__zone-badge--z5 {
  background-color: #FF453A !important;
}

.player-exercise-details__zone-badge--z4 {
  background-color: #FFD93D !important;
  color: #1C1C1E !important;
}

.player-exercise-details__zone-badge--z3 {
  background-color: #34C759 !important;
}

.player-exercise-details__zone-badge--z2 {
  background-color: #4DABF7 !important;
}

.player-exercise-details__zone-badge--z01 {
  background-color: #CED4DA !important;
  color: #1C1C1E !important;
}

.player-exercise-details__zone-info {
  flex: 1 1 !important;
  width: auto !important;
  text-align: left !important;
}

.player-exercise-details__zone-name {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__zone-progress-wrap {
  width: 100% !important;
  height: 8px !important;
  background-color: var(--border-color) !important;
  border-radius: 4px !important;
  overflow: hidden !important;
  transition: background 0.3s ease !important;
}

.player-exercise-details__zone-progress-bar {
  height: 100% !important;
  border-radius: 4px !important;
}

.player-exercise-details__zone-progress-bar--z5 {
  background-color: #FF453A !important;
}

.player-exercise-details__zone-progress-bar--z4 {
  background-color: #FFD93D !important;
}

.player-exercise-details__zone-progress-bar--z3 {
  background-color: #34C759 !important;
}

.player-exercise-details__zone-progress-bar--z2 {
  background-color: #4DABF7 !important;
}

.player-exercise-details__zone-progress-bar--z01 {
  background-color: #CED4DA !important;
}

.player-exercise-details__zone-duration {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
  text-align: right !important;
}

/* Auto-Evaluation Panel Light Theme */
.player-exercise-details__eval-section {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
}

.player-exercise-details__eval-item {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 16px !important;
  padding: 16px !important;
  box-shadow: 0 2px 8px var(--shadow-color) !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__eval-label {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  margin-bottom: 10px !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.player-exercise-details__emoji-eval-block {
  margin-top: 20px !important;
}

.player-exercise-details__emoji-eval-block:first-child {
  margin-top: 0 !important;
}

.player-exercise-details__emoji-eval-row {
  display: flex !important;
  justify-content: space-between !important;
  gap: 8px !important;
}

.player-exercise-details__emoji-eval-tile {
  flex: 1 1 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding: 10px 6px !important;
  border-radius: 16px !important;
  border: 1px solid var(--border-color) !important;
  background: color-mix(in srgb, var(--text-color) 2%, var(--surface-color)) !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

.player-exercise-details__emoji-eval-tile:hover {
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  transform: scale(1.03) !important;
}

.player-exercise-details__emoji-eval-tile--selected {
  border-color: var(--emoji-tile-color, var(--brand-primary, #0877BC)) !important;
  background: color-mix(in srgb, var(--emoji-tile-color, var(--brand-primary, #0877BC)) 12%, var(--surface-color)) !important;
  transform: scale(1.06) !important;
}

.player-exercise-details__emoji-eval-icon {
  font-size: 1.6rem !important;
  line-height: 1.2 !important;
}

.player-exercise-details__emoji-eval-caption {
  margin-top: 4px !important;
  font-size: 0.6rem !important;
  font-weight: 700 !important;
  line-height: 1.1 !important;
  text-align: center !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__emoji-eval-tile--selected .player-exercise-details__emoji-eval-caption {
  color: var(--emoji-tile-color, var(--brand-primary, #0877BC)) !important;
}

.player-exercise-details__emoji-eval-summary-grid {
  display: grid !important;
  grid-template-columns: 1fr 1fr !important;
  gap: 12px !important;
}

.player-exercise-details__emoji-eval-summary-card {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  padding: 16px 12px !important;
  border-radius: 16px !important;
  border: 1px solid var(--border-color) !important;
  background: var(--surface-color) !important;
  box-shadow: 0 2px 8px var(--shadow-color) !important;
}

.player-exercise-details__emoji-eval-summary-caption {
  font-size: 0.65rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  color: var(--text-secondary) !important;
  margin-bottom: 4px !important;
}

.player-exercise-details__emoji-eval-summary-icon {
  font-size: 1.75rem !important;
  line-height: 1.2 !important;
  margin-bottom: 4px !important;
}

.player-exercise-details__emoji-eval-summary-label {
  font-size: 0.75rem !important;
  font-weight: 800 !important;
  text-align: center !important;
}

.player-exercise-details__actions-container {
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  margin-top: 28px !important;
}

.player-exercise-details__submit-btn {
  width: 100% !important;
  padding: 14px 20px !important;
  border-radius: 999px !important;
  border: none !important;
  background: var(--brand-primary, #0877BC) !important;
  color: #ffffff !important;
  font-weight: 800 !important;
  font-size: 0.9rem !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  box-shadow: 0 8px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;
  transition: transform 0.2s ease, filter 0.2s ease, background 0.2s ease, box-shadow 0.2s ease !important;
}

.player-exercise-details__submit-btn:hover:not(:disabled) {
  filter: brightness(1.06) !important;
  transform: translateY(-1px) !important;
}

.player-exercise-details__submit-btn:active:not(:disabled) {
  transform: translateY(1px) scale(0.99) !important;
  filter: brightness(0.94) !important;
  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent) !important;
}

.player-exercise-details__submit-btn:disabled {
  background: var(--border-color) !important;
  color: var(--text-secondary) !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.player-exercise-details__cancel-btn {
  width: 100% !important;
  padding: 12px 20px !important;
  border-radius: 999px !important;
  border: 1px solid var(--border-color) !important;
  background: transparent !important;
  color: var(--text-secondary) !important;
  font-weight: 700 !important;
  font-size: 0.85rem !important;
  cursor: pointer !important;
  transition: background 0.2s ease, color 0.2s ease !important;
}

.player-exercise-details__cancel-btn:hover {
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  color: var(--text-color) !important;
}

.player-exercise-details__edit-eval-btn {
  width: 100% !important;
  padding: 12px 20px !important;
  border-radius: 999px !important;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 35%, var(--border-color)) !important;
  background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--surface-color)) !important;
  color: var(--brand-primary, #0877BC) !important;
  font-weight: 800 !important;
  font-size: 0.85rem !important;
  cursor: pointer !important;
  transition: background 0.2s ease, transform 0.2s ease !important;
}

.player-exercise-details__edit-eval-btn:hover {
  background: color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--surface-color)) !important;
}

.player-exercise-details__edit-eval-btn:active {
  transform: scale(0.99) !important;
}

.player-exercise-details__eval-video-card {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 18px !important;
  padding: 14px 16px !important;
  box-shadow: 0 2px 10px var(--shadow-color) !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
}

.player-exercise-details__eval-video-card--lines {
  gap: 6px !important;
}

.player-exercise-details__eval-video-card--playing {
  border-color: var(--brand-primary, #0877BC) !important;
  box-shadow:
    0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent),
    0 2px 12px var(--shadow-color) !important;
  background: color-mix(
    in srgb,
    var(--brand-primary, #0877BC) 8%,
    var(--surface-color)
  ) !important;
}

.player-exercise-details__eval-video-card--playing .player-exercise-details__eval-video-line-icon {
  color: var(--brand-primary, #0877BC) !important;
}

.player-exercise-details__eval-video-line {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 10px !important;
  min-height: 28px !important;
}

.player-exercise-details__eval-video-line--header {
  min-height: 32px !important;
}

.player-exercise-details__eval-video-line-main {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

.player-exercise-details__eval-video-line-icon {
  flex-shrink: 0 !important;
  color: var(--brand-primary, #0877BC) !important;
}

.player-exercise-details__eval-video-line-summary {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  line-height: 1.35 !important;
  min-width: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.player-exercise-details__eval-video-line--role .player-exercise-details__eval-video-role-slot {
  flex-shrink: 0 !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--text-secondary) !important;
  min-width: 1.25em !important;
}

.player-exercise-details__eval-video-line--role .player-exercise-details__eval-video-role-name {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: var(--text-color) !important;
  line-height: 1.35 !important;
  min-width: 0 !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.player-exercise-details__eval-video-card-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 12px !important;
}

.player-exercise-details__eval-video-card-title {
  display: flex !important;
  align-items: flex-start !important;
  gap: 8px !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  line-height: 1.35 !important;
}

.player-exercise-details__eval-video-card-title span {
  flex: 1 1 !important;
  min-width: 0 !important;
}

.player-exercise-details__eval-video-card-meta {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  padding: 0 2px !important;
}

.player-exercise-details__eval-video-card-actions {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__move-video-btn {
  border: 1px solid rgba(10, 132, 255, 0.35) !important;
  background: rgba(10, 132, 255, 0.1) !important;
  color: #0A84FF !important;
  border-radius: 8px !important;
  padding: 4px 10px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  white-space: nowrap !important;
}

.player-exercise-details__move-video-btn:hover {
  background: rgba(10, 132, 255, 0.18) !important;
}

.player-exercise-details__eval-video-header-actions {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex-shrink: 0 !important;
}

.player-exercise-details__move-video-icon-btn {
  flex-shrink: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 34px !important;
  height: 34px !important;
  border: 1px solid rgba(10, 132, 255, 0.35) !important;
  background: rgba(10, 132, 255, 0.1) !important;
  color: #0A84FF !important;
  border-radius: 10px !important;
  cursor: pointer !important;
  transition: background 0.2s ease, transform 0.15s ease !important;
}

.player-exercise-details__move-video-icon-btn:hover:not(:disabled) {
  background: rgba(10, 132, 255, 0.18) !important;
}

.player-exercise-details__move-video-icon-btn:active:not(:disabled) {
  transform: scale(0.96) !important;
}

.player-exercise-details__move-video-icon-btn:disabled {
  opacity: 0.55 !important;
  cursor: not-allowed !important;
}

.player-exercise-details__video-play-btn--inline {
  width: 40px !important;
  height: 40px !important;
  box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;
}

.player-exercise-details__eval-video-lefty-badge {
  display: inline-flex !important;
  align-items: center !important;
  align-self: center !important;
  flex-shrink: 0 !important;
  padding: 2px 8px !important;
  border-radius: 999px !important;
  background: rgba(255, 149, 0, 0.15) !important;
  color: #c77700 !important;
  font-size: 11px !important;
  font-weight: 700 !important;
}

.player-exercise-details__eval-video-kot-badge {
  display: inline-flex !important;
  align-items: center !important;
  align-self: center !important;
  flex-shrink: 0 !important;
  padding: 2px 8px !important;
  border-radius: 999px !important;
  background: rgba(255, 149, 0, 0.16) !important;
  color: #ff9500 !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em !important;
  text-transform: uppercase !important;
}

.player-exercise-details__eval-video-ready-badge {
  display: inline-flex !important;
  align-items: center !important;
  align-self: center !important;
  flex-shrink: 0 !important;
  padding: 2px 8px !important;
  border-radius: 999px !important;
  background: rgba(34, 197, 94, 0.16) !important;
  color: #16a34a !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
}

.player-exercise-details__eval-video-ready-badge--pending {
  background: rgba(148, 163, 184, 0.2) !important;
  color: #64748b !important;
}

.player-exercise-details__eval-video-card--processing {
  border-color: color-mix(
    in srgb,
    var(--brand-primary, #0877bc) 45%,
    var(--border-color)
  ) !important;
}

.player-exercise-details__eval-video-job {
  margin-top: 4px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  padding-top: 6px !important;
  border-top: 1px solid var(--border-color) !important;
}

.player-exercise-details__eval-video-job-label {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  font-size: 12px !important;
  font-weight: 650 !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__eval-video-job-track {
  height: 6px !important;
  border-radius: 999px !important;
  background: rgba(128, 128, 128, 0.18) !important;
  overflow: hidden !important;
}

.player-exercise-details__eval-video-job-fill {
  height: 100% !important;
  border-radius: inherit !important;
  background: var(--brand-primary, #0877bc) !important;
  transition: width 0.35s cubic-bezier(0.25, 1, 0.5, 1) !important;
}

.player-exercise-details__eval-video-job-error {
  margin: 0 !important;
  font-size: 12.5px !important;
  line-height: 1.35 !important;
  color: #ef4444 !important;
  font-weight: 600 !important;
}

.player-exercise-details__eval-video-job-done {
  margin: 0 !important;
  font-size: 12.5px !important;
  line-height: 1.35 !important;
  color: #34c759 !important;
  font-weight: 650 !important;
}

/* Above session media (13000), exercise sheet (9999/10050), and related coach dialogs */
.MuiDialog-root.move-eval-video-dialog-root {
  z-index: 15000 !important;
}

.move-eval-video-dialog {
  padding: 20px 22px 24px !important;
}

.move-eval-video-dialog__title {
  margin: 0 0 6px !important;
  font-size: 18px !important;
  font-weight: 800 !important;
}

.move-eval-video-dialog__subtitle {
  margin: 0 0 18px !important;
  font-size: 13px !important;
  color: var(--text-secondary, #666) !important;
}

.move-eval-video-dialog__loading {
  display: flex !important;
  justify-content: center !important;
  padding: 28px 0 !important;
}

.move-eval-video-dialog__form {
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important;
}

.move-eval-video-dialog__label {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
}

.move-eval-video-dialog__label select {
  padding: 10px 12px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  background: #fff !important;
}

.move-eval-video-dialog__readonly {
  padding: 10px 12px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  background: rgba(0, 0, 0, 0.04) !important;
  color: var(--text-secondary, #666) !important;
}

.move-eval-video-dialog__hint {
  margin: -4px 0 0 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
  color: #c77700 !important;
}

.move-eval-video-dialog__hint--muted {
  margin: 0 !important;
  font-weight: 500 !important;
  color: var(--text-secondary, #666) !important;
}

.move-eval-video-dialog__segment {
  display: flex !important;
  gap: 8px !important;
}

.move-eval-video-dialog__segment-btn {
  flex: 1 1 !important;
  min-height: 42px !important;
  padding: 10px 12px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  background: #fff !important;
  color: var(--text-primary, #111) !important;
  font-size: 14px !important;
  font-weight: 650 !important;
  cursor: pointer !important;
  transition:
    background 0.18s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.18s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.18s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.18s cubic-bezier(0.25, 1, 0.5, 1) !important;
}

.move-eval-video-dialog__segment-btn:hover:not(:disabled) {
  border-color: rgba(10, 132, 255, 0.45) !important;
  box-shadow: 0 4px 10px -2px rgba(10, 132, 255, 0.12) !important;
}

.move-eval-video-dialog__segment-btn:focus-visible {
  outline: 2px solid #0a84ff !important;
  outline-offset: 2px !important;
}

.move-eval-video-dialog__segment-btn--active {
  border-color: #0a84ff !important;
  background: rgba(10, 132, 255, 0.1) !important;
  color: #0a5fcc !important;
  box-shadow: 0 4px 12px -3px rgba(10, 132, 255, 0.22) !important;
}

.move-eval-video-dialog__segment-btn:disabled {
  opacity: 0.55 !important;
  cursor: default !important;
}

.move-eval-video-dialog__multi {
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  padding: 10px 12px !important;
  border: 1px solid rgba(0, 0, 0, 0.12) !important;
  border-radius: 8px !important;
  background: rgba(0, 0, 0, 0.03) !important;
}

.move-eval-video-dialog__multi .move-eval-video-dialog__hint {
  margin: 0 0 2px !important;
}

.move-eval-video-dialog__check {
  display: flex !important;
  align-items: flex-start !important;
  gap: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--text-primary, #222) !important;
  cursor: pointer !important;
}

.move-eval-video-dialog__check input {
  margin-top: 3px !important;
  flex-shrink: 0 !important;
}

.move-eval-video-dialog__error {
  color: #c62828 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
}

.move-eval-video-dialog__actions {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 10px !important;
  margin-top: 8px !important;
}

.move-eval-video-dialog__actions-right {
  display: flex !important;
  justify-content: flex-end !important;
  gap: 10px !important;
  margin-left: auto !important;
}

.move-eval-video-dialog__delete-btn {
  flex-shrink: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 42px !important;
  height: 42px !important;
  border: 1px solid rgba(198, 40, 40, 0.35) !important;
  background: rgba(198, 40, 40, 0.08) !important;
  color: #c62828 !important;
  border-radius: 10px !important;
  cursor: pointer !important;
  transition: background 0.2s ease, transform 0.15s ease !important;
}

.move-eval-video-dialog__delete-btn:hover:not(:disabled) {
  background: rgba(198, 40, 40, 0.16) !important;
}

.move-eval-video-dialog__delete-btn:active:not(:disabled) {
  transform: scale(0.96) !important;
}

.move-eval-video-dialog__delete-btn:disabled {
  opacity: 0.55 !important;
  cursor: not-allowed !important;
}

.move-eval-video-dialog__btn {
  border-radius: 10px !important;
  padding: 10px 16px !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  border: none !important;
}

.move-eval-video-dialog__btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.move-eval-video-dialog__btn--secondary {
  background: rgba(0, 0, 0, 0.06) !important;
  color: #333 !important;
}

.move-eval-video-dialog__btn--primary {
  background: #0A84FF !important;
  color: #fff !important;
}

.player-exercise-details__eval-video-role-line {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 6px !important;
  font-size: 12px !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__eval-video-role-slot {
  font-weight: 700 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__eval-video-role-name,
.player-exercise-details__eval-video-role-name--viewer {
  font-weight: 600 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__eval-video-role-name--viewer {
  color: var(--brand-primary, #0877BC) !important;
}

.player-exercise-details__eval-video-role-value {
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__eval-video-link {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  width: 100% !important;
  padding: 12px 16px !important;
  border-radius: 999px !important;
  background: var(--brand-primary, #0877BC) !important;
  color: #ffffff !important;
  font-weight: 800 !important;
  font-size: 0.85rem !important;
  text-decoration: none !important;
  box-shadow: 0 8px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;
  transition: transform 0.2s ease, filter 0.2s ease !important;
}

.player-exercise-details__eval-video-link:hover {
  filter: brightness(1.06) !important;
  transform: translateY(-1px) !important;
  color: #ffffff !important;
}

.player-exercise-details__eval-video-link:active {
  transform: translateY(1px) scale(0.99) !important;
  filter: brightness(0.94) !important;
}

.player-exercise-details__video-entry {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 14px !important;
  padding: 12px 14px !important;
  border-radius: 14px !important;
  border: 1px solid var(--border-color) !important;
  background: color-mix(in srgb, var(--brand-primary, #0877BC) 6%, var(--surface-color)) !important;
}

.player-exercise-details__video-entry-body {
  flex: 1 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
}

.player-exercise-details__video-entry-label {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: var(--text-color) !important;
  line-height: 1.3 !important;
}

.player-exercise-details__video-entry-date {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__video-entry-desc {
  margin: 4px 0 0 !important;
  font-size: 13px !important;
  line-height: 1.45 !important;
  color: var(--text-secondary) !important;
  white-space: pre-wrap !important;
}

.player-exercise-details__video-play-btn {
  flex-shrink: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 52px !important;
  height: 52px !important;
  border: none !important;
  border-radius: 50% !important;
  background: var(--brand-primary, #0877BC) !important;
  color: #ffffff !important;
  cursor: pointer !important;
  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent) !important;
  transition: transform 0.2s ease, filter 0.2s ease !important;
  -webkit-tap-highlight-color: transparent !important;
}

.player-exercise-details__video-play-btn:hover {
  filter: brightness(1.06) !important;
}

.player-exercise-details__video-play-btn:active {
  transform: scale(0.96) !important;
  filter: brightness(0.94) !important;
}

.player-exercise-details__stars {
  display: flex !important;
  gap: 4px !important;
}

.player-exercise-details__star {
  color: var(--border-color) !important;
}

.player-exercise-details__star--filled {
  color: #FFD60A !important;
}

/* Exertion Pill List Light Mode */
.player-exercise-details__rpe-pills {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
}

.player-exercise-details__rpe-pill {
  padding: 6px 14px !important;
  border-radius: 9999px !important;
  background: var(--border-color) !important;
  color: var(--text-color) !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  border: 1px solid transparent !important;
  transition: all 0.2s ease !important;
}

.player-exercise-details__rpe-pill--active {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15) !important;
  color: var(--brand-primary, #0877BC) !important;
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3) !important;
}

/* Empty & Loading states adaptive */
.player-session-results__loading,
.player-session-results__empty {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 40px !important;
  color: var(--text-secondary) !important;
  text-align: center !important;
}

.player-session-results__empty-icon {
  font-size: 48px !important;
  color: var(--text-secondary) !important;
  opacity: 0.4 !important;
  margin-bottom: 12px !important;
}

.player-session-results__empty p {
  margin: 0 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--text-secondary) !important;
}

.player-session-results__empty-box {
  padding: 24px 16px !important;
  text-align: center !important;
  border: 1px dashed var(--border-color) !important;
  border-radius: 16px !important;
  background: color-mix(in srgb, var(--text-color) 2%, transparent) !important;
}

.player-session-results__empty-box p {
  margin: 0 !important;
  font-size: 13px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
}

.player-session-results__empty--hr {
  padding: 48px 24px !important;
}

/* KoT Matches — mobile gamification card list */
.kot-match-list {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
}

.kot-match-list__hero {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color)) 0%,
    color-mix(in srgb, var(--brand-primary, #0877bc) 6%, var(--surface-color)) 100%
  );
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color));
  box-shadow: 0 4px 18px color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);
}

.kot-match-list__hero-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
}

.kot-match-list__hero-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kot-match-list__title {
  font-size: 14px;
  font-weight: 800;
  color: var(--text-color);
  letter-spacing: -0.01em;
}

.kot-match-list__subtitle {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
}

.kot-match-list__count-pill {
  min-width: 36px;
  height: 36px;
  padding: 0 10px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 800;
  color: #fff;
  background: var(--brand-primary, #0877bc);
  box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);
  flex-shrink: 0;
}

.kot-match-list__cards {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.kot-match-card {
  position: relative;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 14px 14px 12px;
  border-radius: 16px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 10px var(--shadow-color);
  overflow: hidden;
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  /* Force exactly 4 stacked horizontal lines one below each other */
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
}

.kot-match-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--border-color);
  border-radius: 16px 0 0 16px;
}

.kot-match-card--win::before {
  background: linear-gradient(180deg, #34c759 0%, #22c55e 100%);
}

.kot-match-card--win {
  border-color: color-mix(in srgb, #34c759 35%, var(--border-color));
  background: linear-gradient(
    145deg,
    color-mix(in srgb, #34c759 8%, var(--surface-color)) 0%,
    var(--surface-color) 55%
  );
}

.kot-match-card--loss::before {
  background: linear-gradient(180deg, #ff6b6b 0%, #ff453a 100%);
}

.kot-match-card--loss {
  border-color: color-mix(in srgb, #ff453a 22%, var(--border-color));
}

.kot-match-card--pending::before,
.kot-match-card--unknown::before {
  background: linear-gradient(180deg, #ffcc00 0%, #ff9500 100%);
}

.kot-match-card--abandoned::before {
  background: var(--text-secondary);
}

.kot-match-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.kot-match-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  min-width: 0;
}

.kot-match-card__badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.kot-match-card__badge--round {
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 24%, transparent);
}

.kot-match-card__badge--table {
  color: var(--text-color);
  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color));
  border: 1px solid var(--border-color);
}

.kot-match-card__badge--video {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 26px;
  padding-left: 6px;
  padding-right: 6px;
}

.kot-match-card__badge--video-ready {
  background: color-mix(in srgb, #2ecc71 16%, var(--surface-color));
  color: #1e9e57;
  border: 1px solid color-mix(in srgb, #2ecc71 35%, transparent);
}

.kot-match-card__badge--video-missing {
  background: color-mix(in srgb, var(--text-secondary) 10%, var(--surface-color));
  color: var(--text-secondary);
  border: 1px solid color-mix(in srgb, var(--text-secondary) 18%, transparent);
  opacity: 0.85;
}

.kot-match-card--video-pending {
  opacity: 0.98;
}

.kot-match-card__outcome {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex-shrink: 0;
}

.kot-match-card__outcome--win {
  color: #15803d;
  background: rgba(52, 199, 89, 0.16);
  border: 1px solid rgba(52, 199, 89, 0.28);
}

.kot-match-card__outcome--loss {
  color: #b91c1c;
  background: rgba(255, 69, 58, 0.12);
  border: 1px solid rgba(255, 69, 58, 0.22);
}

.kot-match-card__outcome--pending {
  color: #b45309;
  background: rgba(255, 149, 0, 0.12);
  border: 1px solid rgba(255, 149, 0, 0.22);
}

.kot-match-card__outcome--abandoned,
.kot-match-card__outcome--unknown {
  color: var(--text-secondary);
  background: var(--border-color);
  border: 1px solid var(--border-color);
}

.kot-match-card__score-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.kot-match-card__score {
  font-size: 26px;
  font-weight: 900;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.03em;
  line-height: 1;
  color: var(--text-color);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.kot-match-card__points {
  font-size: 12px;
  font-weight: 800;
  color: #15803d;
  padding: 3px 8px;
  border-radius: 8px;
  background: rgba(52, 199, 89, 0.12);
  border: 1px solid rgba(52, 199, 89, 0.2);
  white-space: nowrap;
}

.kot-match-card__points--loss {
  color: #b91c1c !important;
  background: rgba(255, 69, 58, 0.12) !important;
  border-color: rgba(255, 69, 58, 0.28) !important;
}

.kot-match-card__opponent-block {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  flex: 1 1;
}

.kot-match-card__opponent-rank {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.kot-match-card__opponent-level {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 999px;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  flex-shrink: 0;
}

.kot-match-card__opponent-pts {
  font-size: 10px;
  font-weight: 700;
  color: var(--text-secondary);
}

/* Final KoT classement panels */
.kot-classement {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 16px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
  box-shadow: 0 2px 10px var(--shadow-color);
}

.kot-classement__title {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-secondary);
}

.kot-classement__tags {
  display: flex;
  gap: 6px;
  margin: 0 0 12px;
  padding: 4px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color));
  border: 1px solid var(--border-color);
}

.kot-classement__tag {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  padding: 8px 10px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.kot-classement__tag--active {
  color: var(--text-color);
  background: var(--surface-color);
  box-shadow: 0 1px 4px var(--shadow-color);
}

.kot-classement__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.kot-classement__row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--text-color) 2%, var(--surface-color));
  border: 1px solid var(--border-color);
}

.kot-classement__row--me {
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));
}

.kot-classement__rank {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 800;
  color: var(--text-secondary);
  background: var(--border-color);
}

.kot-classement__rank--1 {
  color: #92400e;
  background: linear-gradient(145deg, #fde68a, #fbbf24);
}

.kot-classement__rank--2 {
  color: #475569;
  background: linear-gradient(145deg, #e2e8f0, #cbd5e1);
}

.kot-classement__rank--3 {
  color: #9a3412;
  background: linear-gradient(145deg, #fdba74, #fb923c);
}

.kot-classement__player {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.kot-classement__name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kot-classement__club {
  font-size: 10px;
  font-weight: 600;
  color: var(--brand-secondary, #46528b) !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kot-classement__value {
  text-align: right;
  flex-shrink: 0;
}

.kot-classement__value-main {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1px;
  font-size: 15px;
  font-weight: 900;
  color: var(--text-color);
  font-variant-numeric: tabular-nums;
}

.kot-classement__value-main--spread {
  color: var(--brand-primary, #0877bc);
}

.kot-classement__value-unit {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--text-secondary);
}

.kot-classement__value-sub {
  font-size: 9px;
  font-weight: 600;
  color: var(--text-secondary);
}

.kot-match-card__versus {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  margin-bottom: 10px;
}

.kot-match-card__vs {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.kot-match-card__opponent {
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}

.kot-match-card--has-video {
  cursor: pointer;
}

.kot-match-card--has-video:active {
  transform: scale(0.985);
}

.kot-match-card--has-video:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.kot-match-card__play-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 2px;
  padding: 10px 12px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  color: var(--brand-primary, #0877bc);
  pointer-events: none;
}

.kot-match-card__play-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--surface-color));
}

.kot-match-card__video-label {
  font-size: 13px;
  font-weight: 700;
}

.kot-match-card__video-pending {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-secondary);
  font-style: italic;
}

.kot-match-card__video {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 2px;
  padding: 10px 12px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  transition: background 0.15s ease, transform 0.1s ease;
}

.kot-match-card__video:hover {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));
}

.kot-match-card__video:active {
  transform: scale(0.98);
}

/* Perf tab — keep KoT list inside phone viewport */
.ios-tab-content .kot-match-list,
.player-session-results__body--nested .kot-match-list,
.player-session-results__body .kot-match-list {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

@media (max-width: 520px) {
  .kot-match-list__hero {
    padding: 12px;
    gap: 8px;
  }

  .kot-match-list__hero-icon {
    width: 34px;
    height: 34px;
  }

  .kot-match-list__title {
    font-size: 13px;
  }

  .kot-match-list__subtitle {
    font-size: 10px;
  }

  .kot-match-list__count-pill {
    min-width: 32px;
    height: 32px;
    font-size: 13px;
  }

  .kot-match-card {
    padding: 12px 12px 10px !important;
    gap: 10px !important; /* Slightly tighter spacing on smaller screens */
  }

  .kot-match-card__line-row {
    margin-bottom: 0 !important;
    gap: 8px !important;
  }

  .kot-match-card__opponent-vs-name {
    font-size: 14px !important;
  }

  .kot-match-card__score-display {
    font-size: 18px !important;
  }

  .kot-match-card__score-title,
  .kot-match-card__points-title {
    font-size: 11px !important;
  }

  .kot-match-card__points-badge-new {
    font-size: 11px !important;
    padding: 3px 8px !important;
  }

  .kot-match-card__video-left-label {
    font-size: 12px !important;
  }

  .kot-match-card__video-ready-text,
  .kot-match-card__video-pending-text {
    font-size: 11px !important;
  }

  /* Extreme small screen support down to 360px width to avoid any text clip/overflow */
  @media (max-width: 380px) {
    .kot-match-card__points-title,
    .kot-match-card__score-title {
      display: none !important;
    }
  }

  .kot-match-card__badge {
    font-size: 9px;
    padding: 3px 7px;
    letter-spacing: 0.02em;
  }

  .kot-match-card__outcome {
    font-size: 9px;
    padding: 3px 7px;
  }

  .kot-match-card__score {
    font-size: 22px;
  }

  .kot-match-card__opponent {
    font-size: 13px;
  }

  .kot-match-card__video {
    font-size: 12px;
    padding: 9px 10px;
  }
}

@media (min-width: 480px) {
  .kot-match-card__score {
    font-size: 28px;
  }
}

/* Legacy table styles (kept for any older views) */
.player-exercise-details__kot-wrap {
  width: 100% !important;
  background: var(--surface-color) !important;
  border-radius: 16px !important;
  border: 1px solid var(--border-color) !important;
  box-shadow: 0 2px 10px var(--shadow-color) !important;
  overflow: hidden !important;
  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;
}

.player-exercise-details__kot-table {
  width: 100% !important;
  border-collapse: collapse !important;
}

.player-exercise-details__kot-table th {
  background: var(--bg-color) !important;
  padding: 12px !important;
  text-align: left !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  color: var(--text-secondary) !important;
  border-bottom: 1px solid var(--border-color) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease !important;
}

.player-exercise-details__kot-table td {
  padding: 12px !important;
  font-size: 13px !important;
  color: var(--text-color) !important;
  border-bottom: 1px solid var(--border-color) !important;
  transition: border-color 0.3s ease, color 0.3s ease !important;
}

.player-exercise-details__kot-table tr:last-child td {
  border-bottom: none !important;
}

.player-exercise-details__outcome {
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  display: inline-block !important;
}

.player-exercise-details__outcome--win {
  background: rgba(50, 215, 75, 0.15) !important;
  color: #34C759 !important;
  border: 1px solid rgba(50, 215, 75, 0.2) !important;
}

.player-exercise-details__outcome--loss {
  background: rgba(255, 69, 58, 0.15) !important;
  color: #FF453A !important;
  border: 1px solid rgba(255, 69, 58, 0.2) !important;
}

.player-exercise-details__outcome--pending {
  background: var(--border-color) !important;
  color: var(--text-secondary) !important;
  border: 1px solid var(--border-color) !important;
}

.player-exercise-details__kot-video-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  padding: 6px 10px !important;
  border: none !important;
  border-radius: 8px !important;
  background: rgba(8, 119, 188, 0.12) !important;
  color: var(--brand-primary, #0877BC) !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  transition: background 0.2s ease !important;
}

.player-exercise-details__kot-video-btn:hover {
  background: rgba(8, 119, 188, 0.2) !important;
}

/* Exercise results dialog — ensure segmented tabs readable in light mode */
.player-session-results__sheet .ios-segmented-control-btn:not(.active),
.player-session-results__sheet--nested .ios-segmented-control-btn:not(.active) {
  color: var(--text-secondary) !important;
}

.player-session-results__sheet .ios-segmented-control-btn.active,
.player-session-results__sheet--nested .ios-segmented-control-btn.active {
  color: #ffffff !important;
}

/* Navigation button (Back) */
.player-session-results__back-btn {
  background: transparent !important;
  border: none !important;
  color: var(--brand-primary, #0877BC) !important; /* Custom Brand color button */
  font-weight: 700 !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  cursor: pointer !important;
  padding: 6px 10px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  transition: background 0.2s ease !important;
}

.player-session-results__back-btn:hover {
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;
}

@media (min-width: 600px) {
  .player-session-results__sheet:not(.player-session-results__sheet--page)
    .player-session-results__back-btn--ios-nav {
    display: none !important;
  }
}

/* Feedback section under Evaluation tab */
.player-exercise-details__feedback-header {
  margin-top: 24px !important;
  margin-bottom: 12px !important;
  border-top: 1px solid var(--border-color) !important;
  padding-top: 20px !important;
  transition: border-color 0.3s ease !important;
}

.player-exercise-details__feedback-title {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--text-secondary) !important;
  margin: 0 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
}

.player-exercise-details__feedback-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important;
  margin-top: 14px !important;
}

.player-exercise-details__feedback-card {
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 16px !important;
  padding: 16px !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 12px !important;
  box-shadow: 0 2px 8px var(--shadow-color) !important;
  transition: all 0.2s ease !important;
}

.player-exercise-details__feedback-card:hover {
  transform: translateY(-2px) !important;
  border-color: var(--brand-primary, #0877BC) !important;
  box-shadow: 0 4px 12px var(--shadow-color) !important;
}

.player-exercise-details__feedback-meta {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
}

.player-exercise-details__feedback-sender {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
}

.player-exercise-details__sender-img {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  object-fit: cover !important;
  border: 1.5px solid var(--brand-primary, #0877BC) !important;
  background: var(--bg-color) !important;
}

.player-exercise-details__sender-avatar-placeholder {
  width: 32px !important;
  height: 32px !important;
  border-radius: 50% !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) !important;
  color: var(--brand-primary, #0877BC) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  border: 1.5px solid var(--brand-primary, #0877BC) !important;
}

.player-exercise-details__sender-info {
  display: flex !important;
  flex-direction: column !important;
  text-align: left !important;
}

.player-exercise-details__sender-name {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
}

.player-exercise-details__sender-role {
  font-size: 11px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
}

.player-exercise-details__feedback-date {
  font-size: 11px !important;
  color: var(--text-secondary) !important;
  font-weight: 500 !important;
  opacity: 0.7 !important;
}

.player-exercise-details__feedback-badge {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 4px 8px !important;
  border-radius: 6px !important;
  font-size: 10px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
}

.player-exercise-details__feedback-badge--evaluation {
  background: rgba(0, 122, 255, 0.1) !important;
  color: #007AFF !important;
}

.player-exercise-details__feedback-badge--video {
  background: rgba(191, 90, 242, 0.1) !important;
  color: #AF52DE !important;
}

.player-exercise-details__feedback-badge--voice {
  background: rgba(52, 199, 89, 0.1) !important;
  color: #34C759 !important;
}

.player-exercise-details__feedback-badge--text {
  background: var(--border-color) !important;
  color: var(--text-secondary) !important;
}

.player-exercise-details__feedback-content {
  width: 100% !important;
}

.player-exercise-details__text-bubble {
  background: var(--bg-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 12px !important;
  padding: 12px 14px !important;
  font-size: 13px !important;
  color: var(--text-color) !important;
  line-height: 1.5 !important;
  font-weight: 500 !important;
  text-align: left !important;
  transition: all 0.3s ease !important;
}

.player-exercise-details__media-wrapper {
  border-radius: 12px !important;
  overflow: hidden !important;
  border: 1px solid var(--border-color) !important;
  background: #000000 !important;
  transition: border-color 0.3s ease !important;
}

.player-exercise-details__media-wrapper video,
.player-exercise-details__media-wrapper .review-video-player {
  width: 100% !important;
  max-height: 280px !important;
  display: block !important;
}

.player-exercise-details__media-wrapper audio {
  width: 100% !important;
  display: block !important;
  padding: 4px !important;
  background: rgba(255, 255, 255, 0.08) !important;
}


/* ==========================================================================
   TrainingSessionResultsDialog Exercise Cards (iOS SessionResults parity)
   ========================================================================== */

.player-session-results__ex-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 16px !important;
  width: 100% !important;
}

.player-session-results__station {
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  width: 100% !important;
}

.player-session-results__station--flat {
  gap: 12px !important;
}

.player-session-results__station-head {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 2px 4px 0 !important;
}

.player-session-results__station-swatch {
  width: 10px !important;
  height: 10px !important;
  border-radius: 999px !important;
  flex: 0 0 auto !important;
}

.player-session-results__station-name {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
}

.player-session-results__station-meta {
  font-size: 12px !important;
  font-weight: 600 !important;
  color: var(--text-secondary, #64748b) !important;
}

.player-exercise-details__seq-table {
  flex: 0 0 auto !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  line-height: 1.2 !important;
  padding: 2px 7px !important;
  border-radius: 999px !important;
  background: rgba(8, 119, 188, 0.12) !important;
  color: #0877bc !important;
}

.player-session-results__ex-card {
  width: 100% !important;
  display: flex !important;
  align-items: stretch !important;
  background: var(--surface-color) !important;
  border: 1px solid var(--border-color) !important;
  border-radius: 16px !important;
  padding: 0 !important;
  cursor: pointer !important;
  text-align: left !important;
  box-shadow: none !important;
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease !important;
  position: relative !important;
  overflow: hidden !important;
}

.player-session-results__ex-card:hover {
  transform: none !important;
  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;
  box-shadow: 0 2px 10px var(--shadow-color) !important;
}

.player-session-results__ex-card:hover .player-session-results__chevron {
  color: var(--brand-primary, #0877BC) !important;
}

.player-session-results__ex-card-accent {
  width: 5px !important;
  flex-shrink: 0 !important;
  background: var(--brand-primary, #0877BC) !important;
  border-radius: 16px 0 0 16px !important;
}

.player-session-results__ex-card--finalized {
  border-color: rgba(220, 53, 69, 0.4) !important;
  box-shadow: 0 2px 10px rgba(220, 53, 69, 0.12) !important;
}

.player-session-results__ex-card--finalized .player-session-results__ex-card-accent {
  background: #dc3545 !important;
}

.player-session-results__ex-card--finalized:hover {
  border-color: rgba(220, 53, 69, 0.55) !important;
  box-shadow: 0 4px 14px rgba(220, 53, 69, 0.18) !important;
}

.player-session-results__ex-card-body {
  flex: 1 1 !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  padding: 14px 16px 14px 18px !important;
}

.player-session-results__ex-title-row {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.player-session-results__ex-name {
  margin: 0 !important;
  flex: 1 1 !important;
  min-width: 0 !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  line-height: 1.3 !important;
  letter-spacing: -0.2px !important;
}

.player-session-results__ex-name-prefix {
  color: var(--brand-primary, #0877BC) !important;
  margin-right: 0 !important;
}

.player-session-results__ex-name-text {
  color: var(--text-color) !important;
}

.player-session-results__ex-subtitle {
  margin: 0 !important;
  font-size: 13px !important;
  color: var(--text-secondary) !important;
  line-height: 1.35 !important;
}

.player-session-results__ex-sparring {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 4px !important;
  font-size: 12px !important;
}

.player-session-results__ex-sparring-label {
  color: var(--brand-primary, #0877BC) !important;
  font-weight: 700 !important;
}

.player-session-results__ex-sparring-name {
  color: var(--text-color) !important;
  font-weight: 500 !important;
}

.player-session-results__ex-sparring-rank {
  display: inline-flex !important;
  align-items: center !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
  color: var(--brand-primary, #0877BC) !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;
  border-radius: 10px !important;
  padding: 2px 8px !important;
  line-height: 1.2 !important;
  white-space: nowrap !important;
}

.player-session-results__ex-hr-container {
  background: rgba(120, 120, 128, 0.08) !important;
  border-radius: 10px !important;
  padding: 8px 10px !important;
}

.player-session-results__ex-hr-empty {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--text-secondary) !important;
}

.player-session-results__ex-hr-empty-icon {
  font-size: 14px !important;
  color: #e74c3c !important;
}

.player-session-results__ex-hr-summary-card {
  margin-bottom: 0 !important;
  padding: 12px 8px !important;
}

.player-session-results__ex-hr-summary-card
  .player-exercise-details__hr-subcard-header {
  font-size: 10px !important;
  line-height: 1.2 !important;
}

.player-session-results__ex-hr-summary-card
  .player-exercise-details__hr-subcard-header span {
  white-space: normal !important;
}

.player-session-results__ex-default-metrics-card {
  margin-top: 8px !important;
  margin-bottom: 0 !important;
  padding: 12px 8px !important;
  grid-template-columns: repeat(2, 1fr) !important;
}

.player-exercise-details__default-metrics-card {
  grid-template-columns: repeat(2, 1fr) !important;
  margin-bottom: 16px !important;
}

.player-exercise-details__default-metrics-card--serve {
  grid-template-columns: repeat(2, 1fr) !important;
}

.player-exercise-details__seq-default-metrics.player-exercise-details__default-metrics-card--serve {
  max-width: 360px !important;
}

.player-exercise-details__seq-default-metrics {
  margin: 8px 0 4px !important;
  padding: 10px 8px !important;
  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  max-width: 280px !important;
  width: 100% !important;
  align-self: flex-start !important;
  box-shadow: none !important;
}

.player-exercise-details__hr-subcard--strokes {
  background-color: rgba(8, 119, 188, 0.08) !important;
  color: #0877bc !important;
}

.player-exercise-details__hr-subcard--max_rally {
  background-color: rgba(175, 82, 222, 0.08) !important;
  color: #af52de !important;
}

.player-session-results__ex-footer {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 8px !important;
  min-height: 22px !important;
}

.player-session-results__ex-badges {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  gap: 6px !important;
}

.player-session-results__ex-pill {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 4px 10px !important;
  border-radius: 11px !important;
  border: 1px solid transparent !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.player-session-results__ex-pill--hr {
  background: rgba(231, 76, 60, 0.08) !important;
  border-color: rgba(231, 76, 60, 0.25) !important;
  color: #e74c3c !important;
}

.player-session-results__ex-pill--kot {
  background: rgba(52, 152, 219, 0.08) !important;
  border-color: rgba(52, 152, 219, 0.25) !important;
  color: #3498db !important;
}

.player-session-results__ex-pill--video {
  background: rgba(8, 119, 188, 0.1) !important;
  border-color: rgba(8, 119, 188, 0.3) !important;
  color: #0877bc !important;
}

.player-session-results__ex-title-trailing {
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex-shrink: 0 !important;
}

.player-session-results__ex-video-indicator {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #0877bc !important;
  line-height: 0 !important;
}

.player-session-results__ex-state {
  flex-shrink: 0 !important;
  padding: 4px 10px !important;
  border-radius: 11px !important;
  font-size: 11px !important;
  font-weight: 800 !important;
  letter-spacing: 0.03em !important;
  line-height: 1 !important;
}

.player-session-results__ex-state--finalized {
  background: rgba(220, 53, 69, 0.12) !important;
  color: #dc3545 !important;
  border: 1px solid rgba(220, 53, 69, 0.28) !important;
}

.player-session-results__ex-state--pending {
  background: rgba(255, 149, 0, 0.12) !important;
  color: #ff9500 !important;
}

.player-session-results__chevron {
  color: #c7c7cc !important;
  transition: color 0.2s ease !important;
  flex-shrink: 0 !important;
  font-size: 20px !important;
}

/* Inline Sequences/Rounds Preview in TrainingSessionResultsDialog */
.player-session-results__ex-sequences-preview {
  margin-top: 12px !important;
  padding: 10px 14px !important;
  border-radius: 12px !important;
  background: var(--border-color) !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  width: 100% !important;
  transition: background 0.3s ease !important;
}

.player-session-results__sequence-preview-item {
  display: flex !important;
  align-items: center !important;
  gap: 10px !important;
  font-size: 13px !important;
  color: var(--text-color) !important;
  width: 100% !important;
}

.player-session-results__seq-dot {
  width: 6px !important;
  height: 6px !important;
  border-radius: 50% !important;
  background-color: var(--brand-primary, #0877BC) !important;
  flex-shrink: 0 !important;
}

.player-session-results__seq-dot--kot {
  background-color: #FFCC00 !important;
}

.player-session-results__seq-text {
  flex: 1 1 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  text-align: left !important;
  color: var(--text-color) !important;
  font-weight: 500 !important;
}

.player-session-results__seq-dur {
  font-size: 11px !important;
  color: var(--text-secondary) !important;
  background: var(--surface-color) !important;
  padding: 2px 6px !important;
  border-radius: 4px !important;
  font-family: monospace !important;
  font-weight: 600 !important;
  transition: background 0.3s ease, color 0.3s ease !important;
}

/* Micro-Screen Responsive Tuning for 320px screens */
@media (max-width: 400px) {
  .player-exercise-details__tabs {
    padding: 2px !important;
    border-radius: 10px !important;
    gap: 2px !important;
  }
  .player-exercise-details__tab {
    padding: 6px 4px !important;
    font-size: 11px !important;
    letter-spacing: -0.2px !important;
  }
}

/* Nested exercise sheet — slides above session results dialog */
.player-session-results__backdrop--nested {
  z-index: 10050 !important;
  background: rgba(0, 0, 0, 0.42) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  align-items: flex-end !important;
  padding: 0 !important;
}

.light-mode .player-session-results__backdrop--nested {
  background: rgba(0, 0, 0, 0.32) !important;
}

.player-session-results__sheet--fullwidth,
.player-session-results__sheet--nested {
  max-width: 100% !important;
  width: 100% !important;
  border-radius: 24px 24px 0 0 !important;
  min-height: 78vh !important;
  max-height: calc(
    100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)
  ) !important;
}

.player-session-results__body--nested {
  padding: 8px 20px 28px !important;
  overflow-y: auto !important;
}

.player-session-results__content--nested {
  height: 100% !important;
}

/* Full-page results route — dialog UI without app Header; body scrolls */
.player-session-results__page-shell {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.player-session-results__sheet--page {
  position: relative !important;
  flex: 1 1 auto !important;
  width: 100% !important;
  max-width: none !important;
  min-height: 0 !important;
  height: 100% !important;
  max-height: none !important;
  border-radius: 0 !important;
  animation: none !important;
  margin-top: 0 !important;
  border: none !important;
  box-shadow: none !important;
  overflow: hidden !important;
  padding-top: env(safe-area-inset-top, 0px) !important;
}

.player-session-results__sheet--page .player-session-results__content {
  height: 100% !important;
  min-height: 0 !important;
  overflow: hidden !important;
}

.player-session-results__sheet--page .player-session-results__body {
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch !important;
}

.player-session-results__coach-hint {
  margin: 0 0 16px !important;
  padding: 12px 14px !important;
  border-radius: 12px !important;
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15) !important;
  color: var(--text-secondary) !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
}

.player-session-results__ex-card--disabled {
  cursor: default !important;
}

.player-session-results__ex-card--disabled:hover {
  border-color: var(--border-color) !important;
  box-shadow: none !important;
}

/* ==========================================================================
   Reorganized KOT Match Card
   ========================================================================== */
.kot-match-card__line-row {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  width: 100% !important;
  gap: 12px !important;
  margin-bottom: 0 !important; /* Managed by parent gap */
  flex-wrap: nowrap !important; /* Forces Left + Right items on a single line */
  box-sizing: border-box !important;
}

.kot-match-card__line-row--4 {
  margin-bottom: 0 !important;
}

.kot-match-card__video-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 10px 12px !important;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) !important;
  border-radius: 12px !important;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color)) !important;
  color: var(--brand-primary, #0877bc) !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  cursor: pointer !important;
  transition: background 0.15s ease, transform 0.1s ease, border-color 0.15s ease !important;
}

.kot-match-card__video-btn:hover {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color)) !important;
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) !important;
}

.kot-match-card__video-btn:active {
  transform: scale(0.985) !important;
}

.kot-match-card__video-btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc) !important;
  outline-offset: 2px !important;
}

.kot-match-card__video-btn-icon {
  flex-shrink: 0 !important;
  color: var(--brand-primary, #0877bc) !important;
}

.kot-match-card__video-btn-label {
  flex: 1 1 !important;
  text-align: left !important;
}

.kot-match-card__round-label {
  font-size: 11px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  color: var(--brand-primary, #0877bc) !important;
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) !important;
  padding: 4px 10px !important;
  border-radius: 8px !important;
  letter-spacing: 0.02em !important;
  white-space: nowrap !important;
}

.kot-match-card__opponent-vs {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  min-width: 0 !important;
  flex: 1 1 !important;
}

.kot-match-card__opponent-vs-prefix {
  font-size: 12px !important;
  font-weight: 800 !important;
  color: var(--text-secondary) !important;
  text-transform: uppercase !important;
  flex-shrink: 0 !important;
}

.kot-match-card__opponent-vs-name {
  font-size: 16px !important;
  font-weight: 900 !important;
  color: var(--text-color) !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.kot-match-card__opponent-ranking {
  font-size: 11px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  color: var(--brand-secondary, #46528b) !important;
  background: color-mix(in srgb, var(--brand-secondary, #46528b) 12%, var(--surface-color)) !important;
  border: 1px solid color-mix(in srgb, var(--brand-secondary, #46528b) 22%, transparent) !important;
  padding: 3px 9px !important;
  border-radius: 999px !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.kot-match-card__score-container {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  min-width: 0 !important;
}

.kot-match-card__score-title {
  font-size: 12px !important;
  font-weight: 800 !important;
  color: var(--text-secondary) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  white-space: nowrap !important;
}

.kot-match-card__score-display {
  font-size: 20px !important;
  font-weight: 900 !important;
  color: var(--text-color) !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;
  white-space: nowrap !important;
}

.kot-match-card__points-container {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  flex-shrink: 0 !important;
}

.kot-match-card__points-title {
  font-size: 12px !important;
  font-weight: 800 !important;
  color: var(--text-secondary) !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  white-space: nowrap !important;
}

.kot-match-card__points-badge-new {
  font-size: 12px !important;
  font-weight: 800 !important;
  color: #15803d !important;
  background: rgba(52, 199, 89, 0.12) !important;
  border: 1px solid rgba(52, 199, 89, 0.2) !important;
  padding: 4px 10px !important;
  border-radius: 8px !important;
  white-space: nowrap !important;
}

.kot-match-card__points-badge-new--loss {
  color: #b91c1c !important;
  background: rgba(255, 69, 58, 0.12) !important;
  border-color: rgba(255, 69, 58, 0.2) !important;
}

.kot-match-card__points-badge-new--none {
  color: var(--text-secondary) !important;
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  border-color: var(--border-color) !important;
}

.kot-match-card__outcome-pill {
  display: inline-flex !important;
  align-items: center !important;
  gap: 4px !important;
  padding: 4px 10px !important;
  border-radius: 999px !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.kot-match-card__outcome-pill--win {
  color: #15803d !important;
  background: rgba(52, 199, 89, 0.16) !important;
  border: 1px solid rgba(52, 199, 89, 0.28) !important;
}

.kot-match-card__outcome-pill--loss {
  color: #b91c1c !important;
  background: rgba(255, 69, 58, 0.12) !important;
  border: 1px solid rgba(255, 69, 58, 0.22) !important;
}

.kot-match-card__outcome-pill--pending {
  color: #b45309 !important;
  background: rgba(255, 149, 0, 0.12) !important;
  border: 1px solid rgba(255, 149, 0, 0.22) !important;
}

.kot-match-card__outcome-pill--abandoned,
.kot-match-card__outcome-pill--unknown {
  color: var(--text-secondary) !important;
  background: var(--border-color) !important;
  border: 1px solid var(--border-color) !important;
}

/* Row 4 Video Highlights Specifics */
.kot-match-card__video-left-label {
  font-size: 13px !important;
  font-weight: 800 !important;
  color: var(--brand-primary, #0877bc) !important;
  transition: color 0.2s ease !important;
  white-space: nowrap !important;
}

.kot-match-card__line-row--no-video .kot-match-card__video-left-label {
  color: var(--text-secondary) !important;
  opacity: 0.75 !important;
}

.kot-match-card__video-right-status {
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.kot-match-card__video-ready-text {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: var(--brand-primary, #0877bc) !important;
}

.kot-match-card__video-play-icon {
  color: var(--brand-primary, #0877bc) !important;
}

.kot-match-card__video-pending-text {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
}

.kot-match-card__video-off-icon {
  color: var(--text-secondary) !important;
  opacity: 0.7 !important;
}

/* Card Hover Interactions */
.kot-match-card--has-video:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 18px var(--shadow-color) !important;
  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color)) !important;
}

.kot-match-card--has-video:hover .kot-match-card__video-left-label {
  color: color-mix(in srgb, var(--brand-primary, #0877bc) 80%, white) !important;
}

/* Message bubble sub-row (at the bottom of cards) */
.kot-match-card__message-bubble {
  font-size: 11px !important;
  font-weight: 600 !important;
  color: var(--text-secondary) !important;
  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;
  padding: 6px 10px !important;
  border-radius: 8px !important;
  text-align: left !important;
  border: 1px solid var(--border-color) !important;
  margin-top: 10px !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

/* ==========================================================================
   INTERACTIVE AUTO-EVALUATIONS, FEEDBACK HUBS, & VIDEOS REQUESTS PANEL
   ========================================================================== */

/* 1. Video Request Control Panel */
.video-request-panel {
  position: relative;
  background: rgba(30, 41, 59, 0.45) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 12px !important;
  padding: 16px 20px !important;
  margin-bottom: 24px !important;
  overflow: hidden !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.video-request-panel__glow {
  position: absolute !important;
  top: -50px !important;
  left: -50px !important;
  width: 150px !important;
  height: 150px !important;
  background: radial-gradient(circle, rgba(10, 132, 255, 0.15) 0%, transparent 70%) !important;
  pointer-events: none !important;
}

.video-request-panel__content {
  position: relative !important;
  z-index: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important;
}

@media (min-width: 640px) {
  .video-request-panel__content {
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
  }
}

.video-request-panel__header-section {
  flex: 1 1 !important;
}

.video-request-panel__title {
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #f8fafc !important;
  margin: 0 0 4px 0 !important;
  letter-spacing: 0.01em !important;
}

.video-request-panel__subtitle {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #94a3b8 !important;
  margin: 0 !important;
  line-height: 1.4 !important;
}

.video-request-panel__actions {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 10px !important;
}

.video-request-panel__btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: inherit !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  padding: 8px 14px !important;
  border-radius: 8px !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  white-space: nowrap !important;
}

.video-request-panel__btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.video-request-panel__btn--exercise {
  background: rgba(10, 132, 255, 0.1) !important;
  color: #0A84FF !important;
  border: 1px solid rgba(10, 132, 255, 0.25) !important;
}

.video-request-panel__btn--exercise:hover:not(:disabled) {
  background: rgba(10, 132, 255, 0.2) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(10, 132, 255, 0.15) !important;
}

.video-request-panel__btn--session {
  background: rgba(139, 92, 246, 0.1) !important;
  color: #a78bfa !important;
  border: 1px solid rgba(139, 92, 246, 0.25) !important;
}

.video-request-panel__btn--session:hover:not(:disabled) {
  background: rgba(139, 92, 246, 0.2) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15) !important;
}

.video-request-panel__status {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 6px 12px !important;
  border-radius: 6px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  width: 100% !important;
}

@media (min-width: 640px) {
  .video-request-panel__status {
    width: auto !important;
    margin-top: 0 !important;
  }
}

.video-request-panel__status--success {
  background: rgba(16, 185, 129, 0.12) !important;
  color: #10b981 !important;
  border: 1px solid rgba(16, 185, 129, 0.2) !important;
}

.video-request-panel__status--error {
  background: rgba(239, 68, 68, 0.12) !important;
  color: #ef4444 !important;
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
}

.video-request-panel__status-dot {
  width: 6px !important;
  height: 6px !important;
  border-radius: 999px !important;
  background-color: currentColor !important;
}

.video-request-panel__status-msg {
  margin: 0 !important;
}

/* 2. Interactive Star Picker & RPE Pills */
.player-exercise-details__star-btn {
  background: none !important;
  border: none !important;
  padding: 0 !important;
  margin-right: 4px !important;
  cursor: pointer !important;
  outline: none !important;
  transition: transform 0.15s ease !important;
}

.player-exercise-details__star-btn:hover {
  transform: scale(1.2) !important;
}

.player-exercise-details__interactive-star {
  color: rgba(255, 255, 255, 0.15) !important;
  font-size: 28px !important;
  transition: color 0.15s ease, filter 0.15s ease !important;
}

.player-exercise-details__interactive-star--filled {
  color: #fbbf24 !important;
  filter: drop-shadow(0 0 6px rgba(251, 191, 36, 0.4)) !important;
}

.player-exercise-details__interactive-label {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: #fbbf24 !important;
  margin-left: 12px !important;
}

.player-exercise-details__rpe-pill-picker {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)) !important;
  gap: 10px !important;
  margin-top: 10px !important;
}

.player-exercise-details__rpe-pill-picker-btn {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 8px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(255, 255, 255, 0.02) !important;
  color: #94a3b8 !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.player-exercise-details__rpe-pill-picker-btn:hover {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
  transform: translateY(-1px) !important;
}

.player-exercise-details__rpe-pill-picker-btn--active {
  background: rgba(10, 132, 255, 0.12) !important;
  border-color: rgba(10, 132, 255, 0.4) !important;
  color: #0A84FF !important;
  box-shadow: 0 4px 12px rgba(10, 132, 255, 0.1) !important;
}

.player-exercise-details__rpe-pill-picker-btn--active .rpe-pill-val {
  color: #0A84FF !important;
}

.rpe-pill-val {
  font-size: 16px !important;
  font-weight: 900 !important;
  color: #f8fafc !important;
  margin-bottom: 2px !important;
}

.rpe-pill-label {
  font-size: 9px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.03em !important;
  text-align: center !important;
}

/* 3. Audio & Voice Recorder Pane */
.voice-recorder-ui {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 12px 0 !important;
}

.voice-recorder-ui__recording-card {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 16px !important;
  background: rgba(239, 68, 68, 0.04) !important;
  border: 1px solid rgba(239, 68, 68, 0.15) !important;
  border-radius: 12px !important;
  width: 100% !important;
  max-width: 320px !important;
  box-sizing: border-box !important;
}

.voice-recorder-ui__mic-indicator {
  width: 48px !important;
  height: 48px !important;
  border-radius: 999px !important;
  background: #ef4444 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative !important;
}

.voice-recorder-ui__mic-indicator::after {
  content: "" !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  border-radius: 999px !important;
  background: rgba(239, 68, 68, 0.4) !important;
  z-index: 0 !important;
}

.voice-recorder-ui__mic-indicator--pulsing::after {
  animation: pulseRed 1.5s infinite ease-out !important;
}

@keyframes pulseRed {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.6);
    opacity: 0;
  }
}

.voice-recorder-ui__timer {
  font-size: 20px !important;
  font-weight: 800 !important;
  color: #ef4444 !important;
  font-family: monospace !important;
  letter-spacing: 0.05em !important;
}

.voice-recorder-ui__btn {
  font-family: inherit !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
}

.voice-recorder-ui__btn--stop {
  background: #ef4444 !important;
  color: #fff !important;
}

.voice-recorder-ui__btn--stop:hover {
  background: #dc2626 !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25) !important;
}

.voice-recorder-ui__btn--start {
  background: rgba(255, 255, 255, 0.04) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  padding: 12px 24px !important;
}

.voice-recorder-ui__btn--start:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.mic-dot {
  width: 8px !important;
  height: 8px !important;
  border-radius: 999px !important;
  background: #ef4444 !important;
}

.voice-recorder-ui__preview-card {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
}

.preview-card-title {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #94a3b8 !important;
  text-transform: uppercase !important;
  margin: 0 0 10px 0 !important;
  letter-spacing: 0.03em !important;
}

.voice-recorder-ui__audio-preview {
  width: 100% !important;
  height: 40px !important;
  outline: none !important;
  margin-bottom: 12px !important;
}

.voice-recorder-ui__preview-actions {
  display: flex !important;
  gap: 10px !important;
}

.voice-recorder-ui__btn--reset {
  background: rgba(255, 255, 255, 0.04) !important;
  color: #94a3b8 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.voice-recorder-ui__btn--reset:hover {
  background: rgba(255, 255, 255, 0.08) !important;
  color: #f8fafc !important;
}

/* 4. Video Selector Dropzone & Details */
.video-uploader-dropzone {
  display: flex !important;
  flex-direction: column !important;
}

.video-uploader-dropzone__label {
  cursor: pointer !important;
  display: block !important;
}

.video-uploader-dropzone__inner {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 24px 16px !important;
  border: 2px dashed rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  text-align: center !important;
  transition: all 0.2s ease !important;
}

.video-uploader-dropzone__inner:hover {
  border-color: rgba(10, 132, 255, 0.4) !important;
  background: rgba(10, 132, 255, 0.02) !important;
}

.video-uploader-dropzone__icon {
  color: #94a3b8 !important;
  margin-bottom: 10px !important;
}

.video-uploader-dropzone__text-main {
  font-size: 13px !important;
  font-weight: 700 !important;
  color: #f8fafc !important;
  margin-bottom: 4px !important;
}

.video-uploader-dropzone__text-sub {
  font-size: 10px !important;
  font-weight: 500 !important;
  color: #64748b !important;
}

.video-uploader-preview-card {
  display: flex !important;
  flex-direction: column !important;
}

.video-selected-details {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 14px !important;
  background: rgba(10, 132, 255, 0.05) !important;
  border: 1px solid rgba(10, 132, 255, 0.15) !important;
  border-radius: 8px !important;
  margin-bottom: 12px !important;
}

.video-selected-filename {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #f8fafc !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  flex: 1 1 !important;
}

.video-selected-filesize {
  font-size: 11px !important;
  font-weight: 500 !important;
  color: #64748b !important;
  flex-shrink: 0 !important;
}

.video-uploader-preview-actions {
  display: flex !important;
  margin-bottom: 12px !important;
}

/* 5. Coach Hub Tabs & Card Layouts */
.coach-feedback-hub__tabs {
  scrollbar-width: none !important;
}

.coach-feedback-hub__tabs::-webkit-scrollbar {
  display: none !important;
}

.coach-feedback-hub__tab {
  display: flex !important;
  align-items: center !important;
  font-family: inherit !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #94a3b8 !important;
  background: none !important;
  border: none !important;
  padding: 6px 12px !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;
  white-space: nowrap !important;
}

.coach-feedback-hub__tab:hover {
  color: #f8fafc !important;
  background: rgba(255, 255, 255, 0.04) !important;
}

.coach-feedback-hub__tab--active {
  color: #0A84FF !important;
  background: rgba(10, 132, 255, 0.08) !important;
}

.coach-feedback-hub__submit-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: inherit !important;
  font-size: 13px !important;
  font-weight: 700 !important;
  width: 100% !important;
  padding: 10px 16px !important;
  border-radius: 8px !important;
  background: #0A84FF !important;
  color: #fff !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.coach-feedback-hub__submit-btn:hover:not(:disabled) {
  background: #0070e3 !important;
  box-shadow: 0 4px 14px rgba(10, 132, 255, 0.25) !important;
}

.coach-feedback-hub__submit-btn:disabled {
  background: rgba(255, 255, 255, 0.03) !important;
  color: #475569 !important;
  cursor: not-allowed !important;
}

/* Feedback hub textareas */
.feedback-hub-pane__textarea {
  width: 100% !important;
  padding: 12px !important;
  border-radius: 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(0, 0, 0, 0.15) !important;
  color: #fff !important;
  outline: none !important;
  font-size: 13px !important;
  font-family: inherit !important;
  resize: vertical !important;
  box-sizing: border-box !important;
}

.feedback-hub-pane__textarea:focus {
  border-color: rgba(10, 132, 255, 0.3) !important;
}

/* General clean margins and sections */
.coach-eval-section-title {
  font-size: 12px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  color: #64748b !important;
  margin: 0 0 12px 0 !important;
}

.coach-player-eval-empty {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  padding: 10px 14px !important;
  background: rgba(255, 255, 255, 0.02) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  border-radius: 8px !important;
}

.coach-player-eval-empty p {
  margin: 0 !important;
  font-size: 12px !important;
  color: #64748b !important;
  font-weight: 600 !important;
}

.info-dot {
  width: 6px !important;
  height: 6px !important;
  border-radius: 999px !important;
  background-color: #64748b !important;
}

.coach-player-eval-card {
  padding: 14px 16px !important;
  background: rgba(255, 255, 255, 0.02) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  border-radius: 10px !important;
}

.coach-player-eval-metric {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

.metric-label {
  font-size: 12px !important;
  font-weight: 700 !important;
  color: #94a3b8 !important;
  width: 80px !important;
}

@keyframes slideInUp {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.player-exercise-details__video-coverage {
  margin: 0 0 14px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 24%, var(--border-color));
  background: color-mix(in srgb, var(--brand-primary, #0877BC) 6%, var(--surface-color));
  font-size: 13px;
  line-height: 1.45;
}

.player-exercise-details__video-coverage p {
  margin: 0 0 6px;
}

.player-exercise-details__video-coverage p:last-child {
  margin-bottom: 0;
}

.player-exercise-details__video-coverage-meta {
  opacity: 0.85;
}

.player-exercise-details__video-coverage-warn {
  color: #b45309;
}

.player-exercise-details__seq-video-groups {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.player-exercise-details__seq-video-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.player-exercise-details__seq-video-group-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--text-color);
}

.player-exercise-details__seq-video-missing {
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px dashed var(--border-color);
  color: color-mix(in srgb, var(--text-color) 70%, transparent);
  font-size: 13px;
}

.session-palmares {
  margin: 0 0 16px;
  border-radius: 18px;
  overflow: hidden;
  background: #07101f;
  min-height: 280px;
  color: #fff;
}

.session-palmares__preparing {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 220px;
  padding: 24px 16px;
  text-align: center;
}

.session-palmares__preparing p {
  margin: 0;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.86);
}

.session-palmares__board {
  padding: 20px 16px 16px;
}

.session-palmares__title {
  margin: 0 0 16px;
  text-align: center;
  font-size: 22px;
  font-weight: 800;
}

.session-palmares__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.session-palmares__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
}

.session-palmares__row.is-highlight {
  outline: 2px solid #f5c518;
}

.session-palmares__rank {
  width: 48px;
  font-weight: 800;
}

.session-palmares__name {
  flex: 1 1;
  font-weight: 650;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.session-palmares__value {
  font-weight: 800;
}

.session-palmares__row.is-pb .session-palmares__value {
  color: #f5c518;
}

.session-palmares__reel {
  position: relative;
  background: #000;
  min-height: 360px;
  max-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.session-palmares__video {
  width: 100%;
  max-height: 70vh;
  object-fit: cover;
  background: #000;
}

.session-palmares__badge {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  font-weight: 800;
  font-size: 15px;
}

.session-palmares__missing {
  padding: 48px 16px;
  text-align: center;
  font-weight: 700;
}

/* ==========================================================================
   Desktop PC results workspace (session + exercise + session-summary)
   Goal: keep the HR curve on-screen, a stable visual frame, and a scannable
   two-pane layout so users are not lost in a mobile-style vertical stack.
   ========================================================================== */

@media (min-width: 768px) {
  .player-session-results__handle {
    display: none !important;
  }

  .player-session-results__backdrop {
    align-items: center !important;
    justify-content: center !important;
    padding: 28px 32px !important;
    background: rgba(15, 23, 42, 0.42) !important;
  }

  .player-session-results__backdrop--nested {
    align-items: center !important;
    justify-content: center !important;
    padding: 28px 32px !important;
    background: rgba(15, 23, 42, 0.5) !important;
    backdrop-filter: blur(14px) !important;
    -webkit-backdrop-filter: blur(14px) !important;
  }

  .light-mode .player-session-results__backdrop,
  .light-mode .player-session-results__backdrop--nested {
    background: rgba(15, 23, 42, 0.28) !important;
  }

  .player-session-results__sheet:not(.player-session-results__sheet--page),
  .player-session-results__sheet--nested,
  .player-session-results__sheet--fullwidth {
    width: min(1120px, calc(100vw - 64px)) !important;
    max-width: min(1120px, calc(100vw - 64px)) !important;
    min-height: 0 !important;
    height: min(88vh, 920px) !important;
    max-height: min(88vh, 920px) !important;
    border-radius: 20px !important;
    border: 1px solid var(--border-color) !important;
    box-shadow:
      0 24px 64px rgba(15, 23, 42, 0.22),
      0 2px 8px rgba(15, 23, 42, 0.08) !important;
    animation: resultsDesktopDialogIn 0.32s cubic-bezier(0.25, 1, 0.5, 1) !important;
  }

  .player-session-results__close {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    width: 36px !important;
    height: 36px !important;
    background: rgba(120, 120, 128, 0.16) !important;
    border: 1px solid rgba(120, 120, 128, 0.22) !important;
  }

  .player-session-results__header {
    padding: 14px 28px 14px 24px !important;
    background: color-mix(in srgb, var(--surface-color) 88%, transparent) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
  }

  .player-session-results__header-top {
    margin-bottom: 2px !important;
    min-height: 28px !important;
  }

  .player-session-results__title-new {
    font-size: 18px !important;
    letter-spacing: -0.35px !important;
  }

  .player-session-results__subtitle-new,
  .player-session-results__subtitle-meta {
    font-size: 13px !important;
    margin-top: 2px !important;
  }

  .player-session-results__body,
  .player-session-results__body--nested {
    padding: 16px 24px 24px !important;
  }

  .player-exercise-details__tabs {
    position: sticky !important;
    top: -16px !important;
    z-index: 8 !important;
    margin: -4px -24px 16px !important;
    padding: 10px 24px 0 !important;
    background: var(--bg-color) !important;
  }

  .player-exercise-details__tab {
    padding: 10px 8px !important;
    font-size: 13px !important;
  }
}

@keyframes resultsDesktopDialogIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (min-width: 900px) {
  .player-session-results__page-shell {
    max-width: 1180px;
    padding: 0 20px;
  }

  .player-session-results__sheet--page {
    border-radius: 0 !important;
    overflow: hidden !important;
  }

  .player-session-results__workspace:has(
      .session-training-summary,
      .session-training-summary--tappable
    ) {
    display: grid;
    grid-template-columns: minmax(292px, 360px) minmax(0, 1fr);
    gap: 20px;
    align-items: start;
  }

  .player-session-results__workspace:has(
      .session-training-summary,
      .session-training-summary--tappable
    )
    > .session-training-summary,
  .player-session-results__workspace:has(
      .session-training-summary,
      .session-training-summary--tappable
    )
    > .session-training-summary--tappable {
    position: sticky;
    top: 0;
    max-height: calc(88vh - 132px);
    overflow-y: auto;
    margin-bottom: 0;
    scrollbar-width: thin;
  }

  .player-session-results__workspace-main {
    min-width: 0;
  }

  .player-session-results__ex-card-body {
    padding: 12px 14px 12px 16px !important;
    gap: 8px !important;
  }

  .player-session-results__ex-name {
    font-size: 15px !important;
  }

  .player-session-results__ex-hr-summary-card {
    padding: 8px 6px !important;
  }

  .player-exercise-details__hr-section > .player-exercise-details__section-title {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .player-exercise-details__hr-dashboard {
    display: grid;
    grid-template-columns: minmax(0, 1.55fr) minmax(280px, 0.92fr);
    grid-template-areas:
      "metrics metrics"
      "chart zones";
    gap: 14px 16px;
    align-items: start;
  }

  .player-exercise-details__hr-dashboard-metrics {
    grid-area: metrics;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: stretch;
  }

  .player-exercise-details__hr-dashboard-metrics > :only-child {
    grid-column: 1 / -1;
  }

  .player-exercise-details__hr-dashboard-metrics
    .player-exercise-details__hr-summary-card {
    margin-bottom: 0 !important;
    padding: 10px 10px !important;
    gap: 8px !important;
  }

  .player-exercise-details__hr-dashboard-metrics
    .player-exercise-details__default-metrics-card {
    margin: 0 !important;
    min-width: 196px;
    max-width: 240px;
    align-self: stretch;
  }

  .player-exercise-details__hr-dashboard-chart {
    grid-area: chart;
    min-width: 0;
    align-self: start;
  }

  .player-exercise-details__hr-dashboard-zones {
    grid-area: zones;
    min-width: 0;
    align-self: start;
  }

  .player-exercise-details__hr-dashboard-zones
    .player-exercise-details__hr-zones-card {
    margin: 0;
    padding: 14px !important;
  }

  .player-exercise-details__hr-curve-card,
  .player-exercise-details__hr-curve-card--desktop {
    margin-bottom: 0 !important;
    padding: 8px 12px 6px !important;
    gap: 4px !important;
    box-sizing: border-box;
  }

  .player-exercise-details__hr-summary-card--session {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .player-exercise-details__hr-curve-header {
    font-size: 13px !important;
  }

  .player-exercise-details__hr-role-hint {
    font-size: 10px !important;
    line-height: 1.3 !important;
  }

  .player-exercise-details__hr-curve-chart,
  .player-exercise-details__hr-svg {
    max-height: 220px !important;
  }

  .player-exercise-details__hr-svg {
    width: 100% !important;
    height: auto !important;
  }

  .player-exercise-details__zone-list {
    gap: 8px !important;
    margin-top: 8px !important;
  }

  .player-exercise-details__zone-row {
    gap: 4px !important;
  }

  .player-exercise-details__perf-seq-grid {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    gap: 12px !important;
  }

  .player-exercise-details__perf-seq-card {
    padding: 12px !important;
  }
}

@media (min-width: 1100px) {
  .player-session-results__sheet:not(.player-session-results__sheet--page),
  .player-session-results__sheet--nested,
  .player-session-results__sheet--fullwidth {
    width: min(1180px, calc(100vw - 72px)) !important;
    max-width: min(1180px, calc(100vw - 72px)) !important;
  }

  .player-exercise-details__hr-summary-card--session {
    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
  }
}

@media (min-width: 900px) and (max-height: 820px) {
  .player-exercise-details__hr-curve-chart,
  .player-exercise-details__hr-svg {
    max-height: 176px !important;
  }

  .player-session-results__workspace:has(
      .session-training-summary,
      .session-training-summary--tappable
    )
    > .session-training-summary,
  .player-session-results__workspace:has(
      .session-training-summary,
      .session-training-summary--tappable
    )
    > .session-training-summary--tappable {
    max-height: calc(88vh - 112px);
  }
}



/* Coach tool results (chrono / counter) on the exercise Perf tab */
.exercise-tool-results {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}

.exercise-tool-results__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
}

.exercise-tool-results__card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 14px;
  background: var(--surface-color);
  border: 1px solid var(--border-color);
}

.exercise-tool-results__icon {
  color: var(--brand-primary, #0877bc);
  font-size: 26px !important;
}

.exercise-tool-results__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.exercise-tool-results__label {
  font-size: 12px;
  font-weight: 700;
  color: var(--text-secondary);
}

.exercise-tool-results__value {
  font-size: 22px;
  font-weight: 800;
  color: var(--text-color);
  font-variant-numeric: tabular-nums;
}

.exercise-tool-results__video-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));
  color: var(--brand-primary, #0877bc);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayerSessionResultsDialog.css"],"names":[],"mappings":"AAAA,mGAAmG;;AAEnG;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;EACtC,sCAAsC;EACtC,8CAA8C;EAC9C,wBAAwB;EACxB,gCAAgC;EAChC,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;EACrB,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,2CAA2C;EAC3C,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;EACE;IACE,+BAA+B;IAC/B,sCAAsC;IACtC,iCAAiC;IACjC,qDAAqD;IACrD,2DAA2D;IAC3D,uDAAuD;IACvD,yDAAyD;EAC3D;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,wEAAwE;EAC1E;;EAEA;IACE,+EAA+E;EACjF;;EAEA;;IAEE,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,sBAAsB;IACtB,oEAAoE;IACpE,kEAAkE;EACpE;;EAEA,qDAAqD;EACrD;IACE,gEAAgE;EAClE;;EAEA,uEAAuE;EACvE;IACE,4BAA4B;EAC9B;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,iEAAiE;IACjE,mEAAmE;IACnE,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,wDAAwD;EAC1D;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;;AAEF;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,2BAA2B,EAAE,2CAA2C;EACxE,uCAAuC;EACvC,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,sDAAsD;EACtD,iEAAiE;EACjE,2BAA2B;EAC3B,kEAAkE;EAClE,qDAAqD;EACrD,mCAAmC;EACnC,qDAAqD;EACrD,sDAAsD;EACtD,oFAAoF;EACpF,6BAA6B;AAC/B;;AAEA;EACE;IACE,8BAA8B;IAC9B,gDAAgD;IAChD,4BAA4B;IAC5B,2BAA2B;IAC3B,qDAAqD;IACrD,sDAAsD;EACxD;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,sBAAsB;EACtB,kDAAkD;EAClD,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,0CAA0C;EAC1C,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kEAAkE;AAClE;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,gDAAgD;EAChD,sDAAsD;EACtD,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;;;;EAIE,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;;EAEE,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;;EAEE,0BAA0B;EAC1B,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;AACvB;;;AAGA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;EACvB,oBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,uDAAuD;EACvD,2CAA2C;EAC3C,yBAAyB;EACzB,mEAAmE;AACrE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,+BAA+B;EAC/B,+CAA+C;EAC/C,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,kCAAkC;EAClC,gDAAgD;EAChD,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B;;;;gCAI8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,+EAA+E;EAC/E,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0DAA0D,EAAE,2BAA2B;EACvF,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+CAA+C;EAC/C,uEAAuE;EACvE,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;;EAEE,uEAAuE;EACvE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,oBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,uCAAuC;EACvC,4CAA4C;EAC5C,8BAA8B;EAC9B,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oEAAoE;EACpE,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,oBAAoB;EACpB,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,uDAAuD;EACvD,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,+CAA+C,EAAE,+BAA+B;EAChF,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,wCAAwC;EACxC,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,0DAA0D;AAC5D;;AAEA,uBAAuB;AACvB;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,wBAAwB;EACxB,gDAAgD;EAChD,oDAAoD;EACpD,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,yFAAyF;AAC3F;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,kFAAkF;AACpF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,uCAAuC;EACvC,sFAAsF;AACxF;;AAEA;EACE,oBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,mDAAmD;AACrD;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,uCAAuC;EACvC,qFAAqF;EACrF,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,gDAAgD;EAChD,qFAAqF;EACrF,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mGAAmG;EACnG,kGAAkG;AACpG;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,uCAAuC;EACvC,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,gDAAgD;EAChD,qFAAqF;EACrF,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,qBAAqB;EACrB,4GAA4G;AAC9G;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iDAAiD;EACjD,6FAA6F;EAC7F,oGAAoG;AACtG;;AAEA;EACE,oGAAoG;AACtG;;AAEA;EACE,yBAAyB;EACzB,qEAAqE;EACrE,4EAA4E;AAC9E;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,oGAAoG;EACpG,6FAA6F;AAC/F;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,sDAAsD;EACtD,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,gDAAgD;EAChD,2CAA2C;EAC3C,qFAAqF;EACrF,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,yBAAyB;EACzB,2BAA2B;EAC3B,uCAAuC;EACvC,4CAA4C;EAC5C,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,2FAA2F;EAC3F,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,yCAAyC;EACzC,4EAA4E;EAC5E,gDAAgD;AAClD;;AAEA;EACE,yCAAyC;EACzC,4EAA4E;EAC5E,gDAAgD;AAClD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gDAAgD;EAChD,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,oFAAoF;AACtF;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,wBAAwB;EACxB,gDAAgD;EAChD,oDAAoD;EACpD,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,4BAA4B;EAC5B,yFAAyF;AAC3F;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,kGAAkG;EAClG,+CAA+C;EAC/C,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,yBAAyB;EACzB,iEAAiE;AACnE;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,kGAAkG;EAClG,yGAAyG;AAC3G;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;AACjD;;;AAGA;EACE,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;;EAEE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;EACxB,gDAAgD;EAChD,oBAAoB;EACpB,2CAA2C;EAC3C,8BAA8B;EAC9B,6BAA6B;EAC7B,gDAAgD;EAChD,qDAAqD;EACrD,8BAA8B;EAC9B,yFAAyF;AAC3F;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,oDAAoD,EAAE,YAAY;EAClE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD,EAAE,cAAc;EACpE,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD,EAAE,cAAc;EACpE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,iCAAiC;EACjC,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA,yCAAyC;AACzC;EACE,qFAAqF;EACrF,8BAA8B;EAC9B,iCAAiC;EACjC,gDAAgD;EAChD,qDAAqD;EACrD,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,yFAAyF;AAC3F;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;EAC9B,qFAAqF;EACrF,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;EAClC,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,kFAAkF;AACpF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,sFAAsF;EACtF,mCAAmC;EACnC,6FAA6F;AAC/F;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,8DAA8D;AAChE;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,+CAA+C;EAC/C,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;qEAEmE;AACrE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,+BAA+B;EACjC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;;IAEE,+BAA+B;IAC/B,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;IACjC,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,yCAAyC;IACzC,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,oBAAsB;IACtB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mGAAmG;AACrG;;AAEA;EACE,yFAAyF;EACzF,iCAAiC;AACnC;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA,qCAAqC;AACrC;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA,+BAA+B;AAC/B;EACE,2CAA2C;EAC3C,8BAA8B;EAC9B,wBAAwB;EACxB,gDAAgD;EAChD,qDAAqD;EACrD,yFAAyF;AAC3F;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,kEAAkE;AAClE;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gDAAgD;EAChD,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,8BAA8B;EAC9B,wBAAwB;EACxB,oDAAoD;EACpD,yFAAyF;AAC3F;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,gDAAgD;EAChD,qFAAqF;EACrF,0BAA0B;EAC1B,uEAAuE;AACzE;;AAEA;EACE,qFAAqF;EACrF,iCAAiC;AACnC;;AAEA;EACE,+EAA+E;EAC/E,2HAA2H;EAC3H,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,gDAAgD;EAChD,2CAA2C;EAC3C,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,uBAAuB;EACvB,oDAAoD;EACpD,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,oGAAoG;EACpG,wGAAwG;AAC1G;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,oGAAoG;AACtG;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,gDAAgD;EAChD,kCAAkC;EAClC,uCAAuC;EACvC,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,qFAAqF;EACrF,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,uGAAuG;EACvG,kGAAkG;EAClG,+CAA+C;EAC/C,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,gEAAgE;AAClE;;AAEA;EACE,kGAAkG;AACpG;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,8BAA8B;EAC9B,6BAA6B;EAC7B,qDAAqD;EACrD,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD;;6CAE2C;EAC3C;;;;cAIY;AACd;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,8CAA8C;EAC9C,yBAAyB;EACzB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,qDAAqD;EACrD,8CAA8C;EAC9C,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,iEAAiE;AACnE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oGAAoG;AACtG;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE;;;;cAIY;AACd;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,oDAAoD;EACpD,gEAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wFAAwF;AACxF;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gDAAgD;EAChD,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,gDAAgD;EAChD,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,gDAAgD;EAChD,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B;;;;4DAI0D;AAC5D;;AAEA;EACE,iDAAiD;EACjD,+DAA+D;AACjE;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;EAC9C,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,6BAA6B;EAC7B,gDAAgD;EAChD,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,oDAAoD;EACpD,8CAA8C;EAC9C,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,iEAAiE;AACnE;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;EAEE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,+BAA+B;EAC/B,oDAAoD;EACpD,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,oGAAoG;EACpG,4DAA4D;AAC9D;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,gDAAgD;EAChD,iGAAiG;AACnG;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,oDAAoD;EACpD,yBAAyB;EACzB,0BAA0B;EAC1B,oGAAoG;EACpG,4DAA4D;EAC5D,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,0CAA0C;EAC1C,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,+CAA+C;EAC/C,yEAAyE;AAC3E;;AAEA,oCAAoC;AACpC;;EAEE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;EACxB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iDAAiD;EACjD,8BAA8B;EAC9B,4EAA4E;AAC9E;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gDAAgD;AAChD;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB;;;;GAIC;EACD,4FAA4F;EAC5F,yFAAyF;AAC3F;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;EACpC,uFAAuF;EACvF,oFAAoF;AACtF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yCAAyC;EACzC,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;EAC1C,gBAAgB;EAChB,uDAAuD;;EAEvD,kEAAkE;EAClE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kEAAkE;EAClE;;;;GAIC;AACH;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kEAAkE;AACpE;;AAEA;;EAEE,6DAA6D;AAC/D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,uFAAuF;EACvF,oFAAoF;AACtF;;AAEA;EACE,wBAAwB;EACxB,0EAA0E;EAC1E,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;EACjE,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,+EAA+E;EAC/E,4BAA4B;EAC5B,4EAA4E;EAC5E,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;;EAEE,4BAA4B;EAC5B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,cAAc;EACd,wBAAwB;EACxB,6EAA6E;AAC/E;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;EACpC,uFAAuF;EACvF,oFAAoF;EACpF,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0EAA0E;EAC1E,qCAAqC;AACvC;;AAEA;EACE,wFAAwF;EACxF,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iDAAiD;EACjD,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uFAAuF;EACvF,oFAAoF;EACpF,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,uFAAuF;EACvF,oFAAoF;EACpF,sDAAsD;AACxD;;AAEA;EACE,uFAAuF;AACzF;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;;;EAGE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,oBAAoB,EAAE,gDAAgD;EACxE;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA,qFAAqF;EACrF;IACE;;MAEE,wBAAwB;IAC1B;EACF;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,8BAA8B;EAC9B,gDAAgD;EAChD,qDAAqD;EACrD,2BAA2B;EAC3B,yFAAyF;AAC3F;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,uDAAuD;EACvD,oCAAoC;EACpC,iCAAiC;EACjC,oFAAoF;AACtF;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,mCAAmC;EACnC,uDAAuD;EACvD,8DAA8D;AAChE;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;EAC7B,8CAA8C;EAC9C,+CAA+C;EAC/C,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,2EAA2E;AAC3E;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,uBAAuB;EACvB,+CAA+C,EAAE,8BAA8B;EAC/E,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,0CAA0C;AAC1C;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oDAAoD;EACpD,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oBAAoB;EACpB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAC3C,gDAAgD;EAChD,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,sDAAsD;EACtD,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,4DAA4D;EAC5D,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,uEAAuE;EACvE,+CAA+C;EAC/C,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,4DAA4D;AAC9D;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gDAAgD;EAChD,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;EAEE,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gDAAgD;AAClD;;;AAGA;;+EAE+E;;AAE/E;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;EAC/B,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B;EAC/B,2CAA2C;EAC3C,gDAAgD;EAChD,8BAA8B;EAC9B,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,wFAAwF;EACxF,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,0EAA0E;EAC1E,qDAAqD;AACvD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,oDAAoD;EACpD,uCAAuC;AACzC;;AAEA;EACE,+CAA+C;EAC/C,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;EACE,oBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,oBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,+CAA+C;EAC/C,wEAAwE;EACxE,8EAA8E;EAC9E,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,2DAA2D;EAC3D,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,oEAAoE;AACpE;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,0CAA0C;EAC1C,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,0DAA0D;EAC1D,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,2CAA2C;EAC3C,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA,qDAAqD;AACrD;EACE;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA,gEAAgE;AAChE;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,sCAAsC;EACtC,8CAA8C;EAC9C,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,uCAAuC;EACvC,2BAA2B;EAC3B;;cAEY;AACd;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,wEAAwE;EACxE,8EAA8E;EAC9E,uCAAuC;EACvC,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B,EAAE,0BAA0B;EACvD,4BAA4B,EAAE,+CAA+C;EAC7E,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;EAC7B,+FAA+F;EAC/F,8BAA8B;EAC9B,kGAAkG;EAClG,+CAA+C;EAC/C,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,0FAA0F;AAC5F;;AAEA;EACE,kGAAkG;EAClG,2FAA2F;AAC7F;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2DAA2D;EAC3D,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,oBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,+CAA+C;EAC/C,kGAAkG;EAClG,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,iDAAiD;EACjD,oGAAoG;EACpG,iGAAiG;EACjG,2BAA2B;EAC3B,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,wFAAwF;EACxF,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,8CAA8C;EAC9C,mDAAmD;EACnD,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;EACvC,qFAAqF;EACrF,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;EAC9C,oDAAoD;AACtD;;AAEA;;EAEE,uCAAuC;EACvC,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;EAC/C,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,sCAAsC;EACtC,qDAAqD;EACrD,mGAAmG;AACrG;;AAEA;EACE,8EAA8E;AAChF;;AAEA,oDAAoD;AACpD;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;EACvC,qFAAqF;EACrF,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,gDAAgD;EAChD,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;+EAE+E;;AAE/E,mCAAmC;AACnC;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,sCAAsC;EACtC,8CAA8C;EAC9C,sDAAsD;EACtD,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,4FAA4F;EAC5F,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,yCAAyC;EAC3C;AACF;;AAEA;EACE,oBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,4DAA4D;EAC5D,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;AACF;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,4BAA4B;EAC5B,0BAA0B;EAC1B,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,sEAAsE;EACtE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,4BAA4B;EAC5B,8BAA8B;EAC9B,sDAAsD;EACtD,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;EAClD,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;EAC/C,gDAAgD;EAChD,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,8CAA8C;EAC9C,oDAAoD;EACpD,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,sDAAsD;EACtD,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,sDAAsD;EACtD,8BAA8B;EAC9B,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;EAC/C,qDAAqD;EACrD,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,qCAAqC;AACrC;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,4DAA4D;AAC9D;;AAEA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,sDAAsD;EACtD,0CAA0C;EAC1C,sBAAsB;EACtB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;AAClD;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gDAAgD;EAChD,sDAAsD;EACtD,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,gDAAgD;EAChD,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,4FAA4F;EAC5F,sFAAsF;EACtF,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;+EAI+E;;AAE/E;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,6CAA6C;EAC/C;;EAEA;IACE,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;IAC7B,4CAA4C;IAC5C,sCAAsC;IACtC,8CAA8C;EAChD;;EAEA;;IAEE,6CAA6C;EAC/C;;EAEA;;;IAGE,iDAAiD;IACjD,qDAAqD;IACrD,wBAAwB;IACxB,mCAAmC;IACnC,uCAAuC;IACvC,8BAA8B;IAC9B,gDAAgD;IAChD;;iDAE6C;IAC7C,gFAAgF;EAClF;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,gDAAgD;IAChD,sDAAsD;EACxD;;EAEA;IACE,uCAAuC;IACvC,gFAAgF;IAChF,sCAAsC;IACtC,8CAA8C;EAChD;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;;IAEE,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,qBAAqB;IACrB,kCAAkC;IAClC,+BAA+B;IAC/B,sCAAsC;EACxC;;EAEA;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;;;IAIE,aAAa;IACb,0DAA0D;IAC1D,SAAS;IACT,kBAAkB;EACpB;;EAEA;;;;;;;;;;IAUE,gBAAgB;IAChB,MAAM;IACN,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uCAAuC;IACvC,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,8DAA8D;IAC9D;;mBAEe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,2BAA2B;IAC3B,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;IAEE,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,SAAS;IACT,wBAAwB;EAC1B;;EAEA;;IAEE,2BAA2B;IAC3B,gCAAgC;IAChC,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,2DAA2D;EAC7D;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,2DAA2D;IAC3D,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,iDAAiD;IACjD,qDAAqD;EACvD;;EAEA;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;;IAEE,4BAA4B;EAC9B;;EAEA;;;;;;;;;;IAUE,8BAA8B;EAChC;AACF;;;;AAIA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,oFAAoF;EACpF,uFAAuF;EACvF,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* PlayerSessionResultsDialog.css - Redesigned Premium iOS Dynamic Bright/Dark Glassmorphic Theme */\n\n.player-session-results__backdrop {\n  position: fixed !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  background: var(--glass-bg) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  display: flex !important;\n  align-items: flex-end !important;\n  justify-content: center !important;\n  z-index: 9999 !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  overscroll-behavior: none !important;\n  touch-action: none !important;\n  transition: background 0.3s ease !important;\n  box-sizing: border-box !important;\n}\n\n/* Mobile — full-screen iOS page presentation (safe area below browser chrome) */\n@media (max-width: 599px) {\n  .player-session-results__backdrop {\n    align-items: stretch !important;\n    justify-content: flex-start !important;\n    flex-direction: column !important;\n    padding-top: env(safe-area-inset-top, 0px) !important;\n    padding-bottom: env(safe-area-inset-bottom, 0px) !important;\n    padding-left: env(safe-area-inset-left, 0px) !important;\n    padding-right: env(safe-area-inset-right, 0px) !important;\n  }\n\n  .player-session-results__sheet {\n    flex: 1 1 auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    height: auto !important;\n    border-radius: 0 !important;\n    padding-top: 0 !important;\n    box-shadow: none !important;\n    border-left: none !important;\n    border-right: none !important;\n    animation: iosPageSlideUp 0.32s cubic-bezier(0.16, 1, 0.3, 1) !important;\n  }\n\n  .player-session-results__sheet--nested {\n    animation: iosPageSlideFromRight 0.32s cubic-bezier(0.16, 1, 0.3, 1) !important;\n  }\n\n  .player-session-results__sheet--nested,\n  .player-session-results__sheet--fullwidth {\n    min-height: 0 !important;\n    max-height: none !important;\n    border-radius: 0 !important;\n  }\n\n  .player-session-results__handle {\n    display: none !important;\n  }\n\n  .player-session-results__close {\n    display: none !important;\n  }\n\n  .player-session-results__back-btn--ios-nav {\n    display: flex !important;\n    margin-bottom: 0 !important;\n  }\n\n  .player-session-results__header {\n    position: sticky !important;\n    top: 0 !important;\n    z-index: 15 !important;\n    padding-right: max(16px, env(safe-area-inset-right, 0px)) !important;\n    padding-left: max(16px, env(safe-area-inset-left, 0px)) !important;\n  }\n\n  /* Modal sheet: header clears browser/status chrome */\n  .player-session-results__backdrop .player-session-results__header {\n    padding-top: max(12px, env(safe-area-inset-top, 0px)) !important;\n  }\n\n  /* Page mode sits under the app Header — don't double-count safe-area */\n  .player-session-results__sheet--page .player-session-results__header {\n    padding-top: 12px !important;\n  }\n\n  .player-session-results__backdrop {\n    /* Header owns top inset; keep sides/bottom */\n    padding-top: 0 !important;\n  }\n\n  .player-session-results__sheet {\n    padding-top: 0 !important;\n  }\n\n  .player-session-results__page-shell {\n    padding-top: 0 !important;\n    padding-left: max(0px, env(safe-area-inset-left, 0px)) !important;\n    padding-right: max(0px, env(safe-area-inset-right, 0px)) !important;\n    padding-bottom: 0 !important;\n  }\n\n  .player-session-results__sheet--page {\n    margin-top: 0 !important;\n    min-height: 0 !important;\n    border-radius: 0 !important;\n  }\n\n  .player-session-results__sheet--page .player-session-results__body {\n    padding-bottom: max(28px, env(safe-area-inset-bottom, 0px)) !important;\n  }\n\n  .player-session-results__close {\n    top: max(12px, env(safe-area-inset-top, 0px)) !important;\n  }\n}\n\n@keyframes iosPageSlideUp {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes iosPageSlideFromRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n@media (min-width: 600px) {\n  .player-session-results__backdrop {\n    align-items: center !important;\n    padding: 24px !important;\n  }\n\n}\n\n.player-session-results__sheet {\n  background: var(--surface-color) !important;\n  width: 100% !important;\n  max-width: 720px !important; /* Slightly wider for the widescreen look */\n  border-radius: 36px 36px 0 0 !important;\n  overflow: hidden !important;\n  display: flex !important;\n  flex-direction: column !important;\n  position: relative !important;\n  box-shadow: 0 -8px 30px var(--shadow-color) !important;\n  animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1) !important;\n  min-height: 75vh !important;\n  max-height: calc(92dvh - env(safe-area-inset-top, 0px)) !important;\n  padding-top: env(safe-area-inset-top, 0px) !important;\n  color: var(--text-color) !important;\n  border-left: 1px solid var(--border-color) !important;\n  border-right: 1px solid var(--border-color) !important;\n  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease !important;\n  touch-action: auto !important;\n}\n\n@media (min-width: 600px) {\n  .player-session-results__sheet {\n    border-radius: 24px !important;\n    border: 1px solid var(--border-color) !important;\n    min-height: 600px !important;\n    max-height: 85vh !important;\n    max-width: min(1100px, calc(100vw - 48px)) !important;\n    box-shadow: 0 10px 40px var(--shadow-color) !important;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n/* Grab Handle centered like on iOS sheets */\n.player-session-results__handle {\n  width: 36px !important;\n  height: 5px !important;\n  background-color: var(--text-secondary) !important;\n  opacity: 0.3 !important;\n  border-radius: 2.5px !important;\n  margin: 10px auto 0 !important;\n  flex-shrink: 0 !important;\n}\n\n/* Header & Close Button */\n.player-session-results__close {\n  position: relative !important;\n  top: auto !important;\n  right: auto !important;\n  flex-shrink: 0 !important;\n  background: var(--border-color) !important;\n  border: none !important;\n  border-radius: 50% !important;\n  width: 36px !important;\n  height: 36px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: var(--text-color) !important;\n  cursor: pointer !important;\n  z-index: 20 !important;\n  transition: all 0.2s ease !important;\n}\n\n.player-session-results__close:hover,\n.player-session-results__close:active {\n  background: rgba(120, 120, 128, 0.30) !important;\n  transform: scale(0.95) !important;\n}\n\n.player-session-results__close svg {\n  font-size: 18px !important;\n}\n\n/* Coach tools live in the header row (not under browser chrome) */\n.player-session-results__header-top {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n  min-height: 32px !important;\n  margin-bottom: 4px !important;\n}\n\n.player-session-results__header-top-spacer {\n  width: 1px !important;\n  height: 1px !important;\n  flex-shrink: 0 !important;\n}\n\n.player-session-results__header-actions,\n.player-session-results__header-actions--inline {\n  position: relative !important;\n  top: auto !important;\n  right: auto !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  z-index: 2 !important;\n  flex-shrink: 0 !important;\n  margin-left: auto !important;\n}\n\n.player-session-results__icon-btn,\n.player-session-results__settings {\n  position: relative !important;\n  top: auto !important;\n  right: auto !important;\n  background: rgba(120, 120, 128, 0.16) !important;\n  border: 1px solid rgba(120, 120, 128, 0.22) !important;\n  border-radius: 50% !important;\n  width: 36px !important;\n  height: 36px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: var(--text-color) !important;\n  cursor: pointer !important;\n  z-index: 2 !important;\n  transition: all 0.2s ease !important;\n  padding: 0 !important;\n  flex-shrink: 0 !important;\n  -webkit-tap-highlight-color: transparent !important;\n}\n\n.player-session-results__icon-btn:hover,\n.player-session-results__icon-btn:active,\n.player-session-results__settings:hover,\n.player-session-results__settings:active {\n  background: rgba(120, 120, 128, 0.30) !important;\n  transform: scale(0.95) !important;\n}\n\n.player-session-results__icon-btn:focus-visible,\n.player-session-results__settings:focus-visible {\n  outline: 2px solid rgba(10, 132, 255, 0.55) !important;\n  outline-offset: 2px !important;\n}\n\n.player-session-results__icon-btn svg,\n.player-session-results__settings svg {\n  font-size: 20px !important;\n  color: inherit !important;\n  fill: currentColor !important;\n  opacity: 1 !important;\n}\n\n\n.player-session-results__content {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  flex: 1 !important;\n  min-height: 0 !important;\n  overflow: hidden !important;\n}\n\n.player-session-results__header {\n  padding: 8px 24px 20px 24px !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  background: var(--surface-color) !important;\n  flex-shrink: 0 !important;\n  transition: background 0.3s ease, border-color 0.3s ease !important;\n}\n\n.player-session-results__sheet--page .player-session-results__header {\n  padding-top: 12px !important;\n}\n\n.player-session-results__title {\n  margin: 0 !important;\n  font-size: 22px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  letter-spacing: -0.5px !important;\n  text-align: left !important;\n}\n\n.player-session-results__subtitle {\n  margin: 4px 0 0 !important;\n  font-size: 14px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n  text-align: left !important;\n}\n\n/* Modern iOS Header Layout with badge, title and subtitle */\n.player-session-results__header-new {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  width: 100% !important;\n}\n\n.player-session-results__ex-nav {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 2px !important;\n  flex-shrink: 0 !important;\n  padding: 2px !important;\n  border-radius: 999px !important;\n  background: rgba(128, 128, 128, 0.1) !important;\n  border: 1px solid rgba(128, 128, 128, 0.14) !important;\n}\n\n.player-session-results__ex-nav-btn {\n  appearance: none !important;\n  width: 30px !important;\n  height: 30px !important;\n  border: none !important;\n  border-radius: 50% !important;\n  background: transparent !important;\n  color: var(--text-secondary, #64748b) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  transition:\n    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    color 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1),\n    opacity 0.2s ease !important;\n}\n\n.player-session-results__ex-nav-btn:hover:not(:disabled) {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-session-results__ex-nav-btn:active:not(:disabled) {\n  transform: scale(0.94) !important;\n}\n\n.player-session-results__ex-nav-btn:disabled {\n  opacity: 0.28 !important;\n  cursor: default !important;\n}\n\n.player-session-results__ex-nav-btn:focus-visible {\n  outline: 2px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55) !important;\n  outline-offset: 1px !important;\n}\n\n.player-session-results__ex-nav .player-session-results__badge-circle {\n  width: 34px !important;\n  height: 34px !important;\n  font-size: 14px !important;\n  box-shadow: 0 4px 10px rgba(8, 119, 188, 0.22) !important;\n}\n\n.player-session-results__ex-nav-count {\n  font-weight: 600 !important;\n  opacity: 0.8 !important;\n}\n\n.player-session-results__badge-circle {\n  width: 38px !important;\n  height: 38px !important;\n  background-color: var(--brand-primary, #0877BC) !important; /* Premium Branding badge */\n  color: #FFFFFF !important;\n  font-size: 16px !important;\n  font-weight: 800 !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n}\n\n.player-session-results__header-text {\n  flex: 1 !important;\n  min-width: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  text-align: left !important;\n}\n\n.player-session-results__title-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  min-width: 0 !important;\n}\n\n.player-session-results__ex-change-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  color: var(--brand-primary, #0877bc) !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) !important;\n  cursor: pointer !important;\n  flex-shrink: 0 !important;\n  line-height: 0 !important;\n}\n\n.player-session-results__ex-change-btn--seating {\n  width: auto !important;\n  height: 32px !important;\n  padding: 0 10px 0 8px !important;\n  border-radius: 16px !important;\n  gap: 4px !important;\n  line-height: 1 !important;\n}\n\n.player-session-results__ex-change-btn-label {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  letter-spacing: -0.1px !important;\n  white-space: nowrap !important;\n}\n\n.player-session-results__ex-change-btn:hover,\n.player-session-results__ex-change-btn:focus-visible {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.2) !important;\n  outline: none !important;\n}\n\n.player-session-results__ex-card--disabled .player-session-results__ex-change-btn {\n  pointer-events: auto !important;\n  opacity: 1 !important;\n}\n\n.player-session-results__title-new {\n  margin: 0 !important;\n  font-size: 20px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  letter-spacing: -0.4px !important;\n  line-height: 1.2 !important;\n  white-space: normal !important;\n  overflow: visible !important;\n  text-overflow: unset !important;\n}\n\n.player-session-results__title-row .player-session-results__title-new {\n  flex: 1 !important;\n  min-width: 0 !important;\n}\n\n.player-session-results__title-brand {\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-session-results__title-number {\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-session-results__title-accent {\n  color: var(--text-color) !important;\n}\n\n.player-session-results__subtitle-new {\n  margin: 4px 0 0 !important;\n  font-size: 15px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 400 !important;\n  line-height: 1.35 !important;\n}\n\n.player-session-results__subtitle-meta {\n  margin: 2px 0 0 !important;\n  font-size: 15px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n  line-height: 1.35 !important;\n}\n\n/* Scrollable Body - Layered Grey/Dark bg */\n.player-session-results__body {\n  padding: 20px !important;\n  flex: 1 !important;\n  min-height: 0 !important;\n  overflow-y: auto !important;\n  overscroll-behavior: contain !important;\n  -webkit-overflow-scrolling: touch !important;\n  touch-action: pan-y !important;\n  background: var(--bg-color) !important;\n  transition: background 0.3s ease !important;\n}\n\n/* Details Tabs Bar */\n.player-exercise-details__catalog-missing {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px dashed rgba(var(--brand-primary-rgb, 8, 119, 188), 0.55);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08);\n}\n\n.player-exercise-details__catalog-missing-text {\n  flex: 1 1 220px;\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  color: var(--text-color);\n}\n\n.player-exercise-details__catalog-missing-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: 0;\n  border-radius: 999px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.player-exercise-details__catalog-missing-btn:active {\n  transform: scale(0.97);\n}\n\n.player-exercise-details__tabs {\n  display: flex !important;\n  background: transparent !important;\n  border: none !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  padding: 0 !important;\n  border-radius: 0 !important;\n  margin-bottom: 20px !important;\n  gap: 0 !important;\n  position: relative !important;\n  transition: border-color 0.3s ease !important;\n}\n\n.player-exercise-details__tab {\n  flex: 1 !important;\n  border: none !important;\n  background: none !important;\n  padding: 12px 4px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n  cursor: pointer !important;\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  position: relative !important;\n  transition: color 0.2s ease !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n}\n\n.player-exercise-details__tab svg {\n  font-size: 16px !important;\n}\n\n.player-exercise-details__tab--active {\n  background: transparent !important;\n  color: var(--brand-primary, #0877BC) !important; /* Highlight brand active tab */\n  box-shadow: none !important;\n}\n\n/* iOS Active Underscore Indicator */\n.player-exercise-details__tab::after {\n  content: \"\" !important;\n  position: absolute !important;\n  bottom: -1px !important;\n  left: 15% !important;\n  right: 15% !important;\n  height: 3px !important;\n  background-color: transparent !important;\n  border-radius: 3px 3px 0 0 !important;\n  transition: background-color 0.2s ease !important;\n}\n\n.player-exercise-details__tab--active::after {\n  background-color: var(--brand-primary, #0877BC) !important;\n}\n\n/* Sequences Tab List */\n.player-exercise-details__seq-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__seq-row {\n  background: var(--surface-color) !important;\n  border-radius: 14px !important;\n  padding: 14px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 2px 8px var(--shadow-color) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 12px !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__seq-num {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  background: var(--border-color) !important;\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n  transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__seq-num--active {\n  color: #fff !important;\n  background: #34C759 !important;\n  box-shadow: 0 0 0 3px rgba(52, 199, 89, 0.22) !important;\n}\n\n.player-exercise-details__seq-num--sparring {\n  color: #fff !important;\n  background: #FF9800 !important;\n  box-shadow: 0 0 0 3px rgba(255, 152, 0, 0.22) !important;\n}\n\n.player-exercise-details__seq-num--neutral {\n  color: var(--text-secondary) !important;\n  background: color-mix(in srgb, var(--text-color) 10%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-content {\n  flex: 1 !important;\n  text-align: left !important;\n  min-width: 0 !important;\n}\n\n.player-exercise-details__seq-title-row {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 8px !important;\n  margin-bottom: 2px !important;\n}\n\n.player-exercise-details__seq-header {\n  display: flex !important;\n  align-items: flex-start !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  width: 100% !important;\n}\n\n.player-exercise-details__seq-header-main {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n.player-exercise-details__seq-title {\n  margin: 0 !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  line-height: 1.3 !important;\n}\n\n.player-exercise-details__seq-partner {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n  width: 100% !important;\n  padding-left: 38px !important;\n}\n\n.player-exercise-details__seq-partner-line {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: baseline !important;\n  gap: 5px !important;\n  line-height: 1.35 !important;\n}\n\n.player-exercise-details__seq-partner-meta {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.player-exercise-details__seq-partner-rank {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: var(--text-secondary) !important;\n  letter-spacing: 0.01em !important;\n}\n\n.player-exercise-details__seq-footer {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  width: 100% !important;\n  padding-left: 38px !important;\n  margin-top: 2px !important;\n}\n\n.player-exercise-details__seq-role {\n  font-size: 11px !important;\n  color: var(--text-secondary) !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n}\n\n.player-exercise-details__seq-role--active {\n  color: #34C759 !important; /* iOS system green */\n  font-weight: 600 !important;\n}\n\n.player-exercise-details__seq-role--sparring {\n  color: #FF9800 !important; /* Sparring orange */\n  font-weight: 600 !important;\n}\n\n.player-exercise-details__seq-role-pill {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 3px 9px !important;\n  border-radius: 999px !important;\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n  text-transform: uppercase !important;\n  line-height: 1.2 !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__seq-role-pill--sm {\n  padding: 2px 7px !important;\n  font-size: 10px !important;\n  font-weight: 700 !important;\n}\n\n.player-exercise-details__seq-role-pill--active {\n  color: #34C759 !important;\n  background: rgba(52, 199, 89, 0.18) !important;\n  border: 1px solid rgba(52, 199, 89, 0.4) !important;\n}\n\n.player-exercise-details__seq-role-pill--sparring {\n  color: #FF9800 !important;\n  background: rgba(255, 152, 0, 0.18) !important;\n  border: 1px solid rgba(255, 152, 0, 0.42) !important;\n}\n\n.player-exercise-details__seq-role-pill--neutral {\n  color: var(--text-secondary) !important;\n  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color)) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.light-mode .player-exercise-details__seq-role-pill--active {\n  color: #1b7a35 !important;\n}\n\n.light-mode .player-exercise-details__seq-role-pill--sparring {\n  color: #9a5a00 !important;\n}\n\n.player-exercise-details__seq-camera-sources {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 6px !important;\n  margin: 0 0 8px !important;\n}\n\n.player-exercise-details__seq-camera-chip {\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 4px 10px !important;\n  border-radius: 999px !important;\n  border: 1px solid var(--border-color) !important;\n  background: color-mix(in srgb, var(--text-color) 5%, var(--surface-color)) !important;\n  color: var(--text-color) !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  line-height: 1.2 !important;\n  cursor: pointer !important;\n}\n\n.player-exercise-details__seq-camera-chip:hover {\n  border-color: color-mix(in srgb, var(--primary-color, #4c8bf5) 50%, var(--border-color)) !important;\n  background: color-mix(in srgb, var(--primary-color, #4c8bf5) 12%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-opponent {\n  margin-top: 4px !important;\n  font-size: 12px !important;\n  color: var(--text-secondary) !important;\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 4px !important;\n  line-height: 1.35 !important;\n}\n\n.player-exercise-details__seq-opponent-prefix {\n  font-weight: 650 !important;\n  text-transform: none !important;\n  font-size: 12px !important;\n  letter-spacing: 0 !important;\n  opacity: 0.8 !important;\n}\n\n.player-exercise-details__seq-opponent-name {\n  font-weight: 600 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__seq-opponent-role {\n  font-size: 11px !important;\n  font-weight: 600 !important;\n}\n\n.player-exercise-details__seq-actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-shrink: 0 !important;\n  overflow: visible !important;\n}\n\n.player-exercise-details__seq-action-btn {\n  appearance: none !important;\n  width: 36px !important;\n  height: 36px !important;\n  border-radius: 10px !important;\n  border: 1px solid var(--border-color) !important;\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  color: var(--text-secondary) !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  padding: 0 !important;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.1s ease !important;\n}\n\n.player-exercise-details__seq-action-btn:hover {\n  transform: scale(1.04) !important;\n}\n\n.player-exercise-details__seq-action-btn:active {\n  transform: scale(0.96) !important;\n}\n\n.player-exercise-details__seq-action-btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc) !important;\n  outline-offset: 2px !important;\n}\n\n.player-exercise-details__seq-action-btn--video {\n  position: relative !important;\n  color: var(--brand-secondary, #46528b) !important;\n  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 28%, transparent) !important;\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 10%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-action-btn--video:hover {\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 16%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-action-btn--hr {\n  color: #FF453A !important;\n  border-color: color-mix(in srgb, #FF453A 28%, transparent) !important;\n  background: color-mix(in srgb, #FF453A 10%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-action-btn--hr:hover {\n  background: color-mix(in srgb, #FF453A 16%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__seq-video-action {\n  position: relative !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__seq-action-btn--video-open {\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 20%, var(--surface-color)) !important;\n  border-color: color-mix(in srgb, var(--brand-secondary, #46528b) 45%, transparent) !important;\n}\n\n.player-exercise-details__seq-video-count {\n  position: absolute !important;\n  top: -5px !important;\n  right: -5px !important;\n  min-width: 16px !important;\n  height: 16px !important;\n  padding: 0 4px !important;\n  border-radius: 999px !important;\n  background: var(--brand-secondary, #46528b) !important;\n  color: #fff !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  line-height: 16px !important;\n  text-align: center !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18) !important;\n}\n\n.player-exercise-details__seq-camera-menu {\n  min-width: 168px !important;\n  padding: 6px !important;\n  border-radius: 12px !important;\n  border: 1px solid var(--border-color) !important;\n  background: var(--surface-color) !important;\n  box-shadow: 0 10px 28px var(--shadow-color), 0 2px 8px rgba(0, 0, 0, 0.08) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 2px !important;\n}\n\n.player-exercise-details__seq-camera-menu:not(.player-exercise-details__seq-camera-menu--portal) {\n  position: absolute !important;\n  top: calc(100% + 6px) !important;\n  right: 0 !important;\n  z-index: 40 !important;\n}\n\n.player-exercise-details__seq-camera-menu--portal {\n  /* Position comes from inline style (fixed top/left/bottom/width/maxHeight). */\n  z-index: 12000 !important;\n  overflow-y: auto !important;\n  overscroll-behavior: contain !important;\n  -webkit-overflow-scrolling: touch !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n\n.player-exercise-details__seq-camera-menu-item {\n  appearance: none !important;\n  border: 0 !important;\n  background: transparent !important;\n  color: var(--text-color) !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  width: 100% !important;\n  padding: 8px 10px !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  text-align: left !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  transition: background 0.12s ease !important;\n}\n\n.player-exercise-details__seq-camera-menu-item:hover,\n.player-exercise-details__seq-camera-menu-item:focus-visible {\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 10%, transparent) !important;\n  outline: none !important;\n}\n\n.player-exercise-details__seq-camera-badge {\n  width: 26px !important;\n  height: 26px !important;\n  border-radius: 8px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  flex-shrink: 0 !important;\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n  color: #fff !important;\n  background: #64748b !important;\n}\n\n.player-exercise-details__seq-camera-badge--a {\n  background: #0ea5e9 !important;\n}\n\n.player-exercise-details__seq-camera-badge--b {\n  background: #8b5cf6 !important;\n}\n\n.player-exercise-details__seq-camera-badge--c {\n  background: #10b981 !important;\n}\n\n.player-exercise-details__seq-camera-badge--d {\n  background: #f59e0b !important;\n}\n\n.player-exercise-details__seq-camera-menu-label {\n  flex: 1 !important;\n  line-height: 1.25 !important;\n}\n\n.player-exercise-details__perf-list-heading {\n  margin: 0 !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n  text-transform: uppercase !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__perf-seq-list-wrap {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__perf-role-legend {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  align-items: center !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__perf-role-legend-item {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  line-height: 1 !important;\n}\n\n.player-exercise-details__perf-role-legend-dot {\n  width: 8px !important;\n  height: 8px !important;\n  border-radius: 50% !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__perf-role-legend-item--active {\n  color: #34C759 !important;\n}\n\n.player-exercise-details__perf-role-legend-item--active\n  .player-exercise-details__perf-role-legend-dot {\n  background: #34C759 !important;\n}\n\n.player-exercise-details__perf-role-legend-item--sparring {\n  color: #FF9800 !important;\n}\n\n.player-exercise-details__perf-role-legend-item--sparring\n  .player-exercise-details__perf-role-legend-dot {\n  background: #FF9800 !important;\n}\n\n.player-exercise-details__perf-seq-card--active {\n  border-left: 4px solid #34C759 !important;\n  background: color-mix(in srgb, #34C759 10%, var(--surface-color)) !important;\n  border-color: rgba(52, 199, 89, 0.28) !important;\n}\n\n.player-exercise-details__perf-seq-card--sparring {\n  border-left: 4px solid #FF9800 !important;\n  background: color-mix(in srgb, #FF9800 10%, var(--surface-color)) !important;\n  border-color: rgba(255, 152, 0, 0.28) !important;\n}\n\n.player-exercise-details__perf-seq-card--neutral {\n  border-left: 4px solid var(--border-color) !important;\n}\n\n.player-exercise-details__seq-dur {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  background: var(--border-color) !important;\n  border: 1px solid var(--border-color) !important;\n  padding: 4px 8px !important;\n  border-radius: 6px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease !important;\n}\n\n/* Performance tab — sequences grouped by participation role */\n.player-exercise-details__perf-sequences {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 18px !important;\n}\n\n.player-exercise-details__perf-role-section {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__perf-role-heading {\n  margin: 0 !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n  text-transform: uppercase !important;\n}\n\n.player-exercise-details__perf-role-heading--active {\n  color: #34C759 !important;\n}\n\n.player-exercise-details__perf-role-heading--sparring {\n  color: #FF9800 !important;\n}\n\n.player-exercise-details__perf-seq-grid {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__perf-seq-card {\n  background: var(--surface-color) !important;\n  border-radius: 14px !important;\n  padding: 14px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 2px 8px var(--shadow-color) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important;\n  justify-content: flex-start !important;\n  gap: 8px !important;\n  overflow: visible !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__perf-role-section--active .player-exercise-details__perf-seq-card {\n  border-left: 3px solid #34C759 !important;\n}\n\n.player-exercise-details__perf-role-section--sparring .player-exercise-details__perf-seq-card {\n  border-left: 3px solid #FF9800 !important;\n}\n\n/* Premium Heart Rate Sections styling */\n.player-exercise-details__section-title {\n  font-size: 16px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  letter-spacing: -0.3px !important;\n  margin: 0 0 12px !important;\n  text-align: left !important;\n}\n\n.player-exercise-details__section-title--inline {\n  margin: 0 !important;\n}\n\n.player-exercise-details__zones-title-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n  margin-bottom: 8px !important;\n}\n\n.player-exercise-details__zones-info-btn {\n  appearance: none !important;\n  border: 0 !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) !important;\n  color: var(--brand-primary, #0877bc) !important;\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  flex-shrink: 0 !important;\n  transition: background 0.2s ease, transform 0.15s ease !important;\n}\n\n.player-exercise-details__zones-info-btn:hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 20%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__zones-info-btn--open {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--surface-color)) !important;\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) !important;\n}\n\n.player-exercise-details__zones-info-btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc) !important;\n  outline-offset: 2px !important;\n}\n\n.player-exercise-details__zones-info-card {\n  margin: 0 0 12px !important;\n  padding: 12px 14px !important;\n  border-radius: 12px !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 6%, var(--surface-color)) !important;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--border-color)) !important;\n}\n\n.player-exercise-details__zones-info-heading {\n  margin: 0 0 6px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__zones-info-heading + .player-exercise-details__zones-info-text + .player-exercise-details__zones-info-heading {\n  margin-top: 10px !important;\n}\n\n.player-exercise-details__zones-info-text {\n  margin: 0 !important;\n  font-size: 11px !important;\n  line-height: 1.45 !important;\n  color: var(--text-secondary) !important;\n  white-space: pre-line !important;\n}\n\n.player-exercise-details__zones-info-meta {\n  margin: 8px 0 0 !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n\n.player-exercise-details__hr-summary-card--session {\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n}\n\n.player-exercise-details__hr-subcard--duration {\n  background-color: rgba(100, 210, 255, 0.08) !important;\n  color: #64d2ff !important;\n}\n\n.player-exercise-details__hr-subcard--intensity,\n.player-exercise-details__hr-subcard--max_intensity {\n  background-color: rgba(175, 82, 222, 0.08) !important;\n  color: #af52de !important;\n}\n\n.player-exercise-details__hr-subcard--avg_intensity {\n  background-color: rgba(8, 119, 188, 0.08) !important;\n  color: #0877bc !important;\n}\n\n.player-exercise-details__hr-subcard--calories {\n  background-color: rgba(255, 149, 0, 0.08) !important;\n  color: #ff9500 !important;\n}\n\n.player-exercise-details__hr-subcard-icon--intensity,\n.player-exercise-details__hr-subcard-icon--max_intensity {\n  color: #af52de !important;\n}\n\n.player-exercise-details__hr-subcard-icon--avg_intensity {\n  color: #0877bc !important;\n}\n\n.player-exercise-details__hr-subcard-icon--calories {\n  color: #ff9500 !important;\n}\n\n.player-exercise-details__hr-curve-card--dark,\nhtml[data-theme=\"dark\"] .player-exercise-details__hr-curve-card,\nbody[data-theme=\"dark\"] .player-exercise-details__hr-curve-card {\n  background: #0d1117 !important;\n  border-color: rgba(255, 255, 255, 0.08) !important;\n}\n\n.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-curve-header,\nhtml[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-curve-header,\nbody[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-curve-header {\n  color: #fff !important;\n}\n\n.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-role-toggle,\nhtml[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-toggle,\nbody[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-toggle {\n  background: rgba(255, 255, 255, 0.06) !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-role-hint,\nhtml[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-hint,\nbody[data-theme=\"dark\"] .player-exercise-details__hr-curve-card .player-exercise-details__hr-role-hint {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\n\n.session-summary-dialog__chart-wrap {\n  min-height: 180px;\n}\n\n.session-summary-dialog__metric-footnote {\n  display: block;\n  margin-top: 2px;\n  font-size: 0.62rem;\n  font-weight: 500;\n  text-align: center;\n  color: var(--text-secondary);\n  line-height: 1.2;\n}\n\n.session-summary-dialog__mhr-caption {\n  margin: -4px 0 12px;\n  font-size: 0.78rem;\n  color: var(--text-secondary);\n}\n\n.session-summary-dialog__empty-icon-wrap {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 69, 58, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  border: 1px solid rgba(255, 69, 58, 0.2);\n}\n\n.session-summary-dialog__empty-title {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-color);\n  text-align: center;\n}\n\n.session-summary-dialog__empty-text {\n  margin: 0;\n  font-size: 13px;\n  color: var(--text-secondary);\n  max-width: 280px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n/* Three columns layout inside single container card */\n.player-exercise-details__hr-summary-card {\n  display: grid !important;\n  grid-template-columns: repeat(3, 1fr) !important;\n  gap: 12px !important;\n  background: var(--surface-color) !important;\n  border-radius: 18px !important;\n  padding: 16px 12px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 2px 10px var(--shadow-color) !important;\n  margin-bottom: 20px !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__hr-subcard {\n  border-radius: 12px !important;\n  padding: 12px 6px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 4px !important;\n}\n\n/* Colored subcard backgrounds matching system states */\n.player-exercise-details__hr-subcard--max {\n  background-color: rgba(255, 69, 58, 0.08) !important; /* Max Red */\n  color: #FF453A !important;\n}\n\n.player-exercise-details__hr-subcard--avg {\n  background-color: rgba(52, 199, 89, 0.08) !important; /* Avg Green */\n  color: #34C759 !important;\n}\n\n.player-exercise-details__hr-subcard--min {\n  background-color: rgba(50, 215, 75, 0.08) !important; /* Min Green */\n  color: #34C759 !important;\n}\n\n.player-exercise-details__hr-subcard-header {\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  color: var(--text-secondary) !important;\n  opacity: 0.8 !important;\n}\n\n.player-exercise-details__hr-subcard-icon {\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__hr-subcard-icon--max {\n  color: #FF453A !important;\n}\n\n.player-exercise-details__hr-subcard-icon--avg {\n  color: #34C759 !important;\n}\n\n.player-exercise-details__hr-subcard-icon--min {\n  color: #34C759 !important;\n}\n\n.player-exercise-details__hr-subcard-value {\n  font-size: 21px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  letter-spacing: -0.5px !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.player-exercise-details__hr-subcard--duration .player-exercise-details__hr-subcard-value {\n  font-size: 18px !important;\n}\n\n.player-exercise-details__hr-subcard-unit {\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__hr-subcard .duration-metric-value {\n  display: inline-flex !important;\n  align-items: baseline !important;\n  flex-wrap: nowrap !important;\n  white-space: nowrap !important;\n  gap: 0.2em !important;\n}\n\n.player-exercise-details__hr-subcard .duration-metric-value__part {\n  display: inline-flex !important;\n  align-items: baseline !important;\n}\n\n.player-exercise-details__hr-subcard .duration-metric-value__num {\n  font-size: inherit !important;\n  font-weight: inherit !important;\n}\n\n.player-exercise-details__hr-subcard .duration-metric-value__unit {\n  font-size: 0.52em !important;\n  font-weight: 700 !important;\n  opacity: 0.72 !important;\n  margin-left: 0.08em !important;\n  color: var(--text-secondary) !important;\n}\n\n/* Gorgeous Performance Curve container */\n.player-exercise-details__hr-curve-card {\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  border-radius: 16px !important;\n  padding: 10px 14px 8px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 4px 20px var(--shadow-color) !important;\n  margin-bottom: 12px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 6px !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__hr-curve-header-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n  flex-wrap: wrap !important;\n  margin-bottom: 0 !important;\n}\n\n.player-exercise-details__hr-curve-header {\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  color: #0f172a !important;\n  text-align: left !important;\n  flex: 1 1 auto !important;\n  min-width: 0 !important;\n  letter-spacing: -0.2px !important;\n}\n\nhtml[data-theme=\"light\"] .player-exercise-details__hr-curve-header,\nbody[data-theme=\"light\"] .player-exercise-details__hr-curve-header,\nbody.light-mode .player-exercise-details__hr-curve-header,\n.player-exercise-details__hr-curve-card:not(.player-exercise-details__hr-curve-card--dark) .player-exercise-details__hr-curve-header {\n  color: #0f172a !important;\n}\n\n.player-exercise-details__hr-role-toggle {\n  display: inline-flex !important;\n  align-items: center !important;\n  padding: 3px !important;\n  border-radius: 10px !important;\n  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color)) !important;\n  border: 1px solid var(--border-color) !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__hr-role-btn {\n  appearance: none !important;\n  border: 0 !important;\n  background: transparent !important;\n  color: var(--text-secondary) !important;\n  font-size: 11px !important;\n  font-weight: 650 !important;\n  line-height: 1 !important;\n  padding: 7px 10px !important;\n  border-radius: 8px !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.player-exercise-details__hr-role-btn:hover {\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__hr-role-btn:focus-visible {\n  outline: 2px solid #0877bc !important;\n  outline-offset: 1px !important;\n}\n\n.player-exercise-details__hr-role-btn--both {\n  background: color-mix(in srgb, var(--text-color) 10%, var(--surface-color)) !important;\n  color: var(--text-color) !important;\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--text-color) 18%, transparent) !important;\n}\n\n.player-exercise-details__hr-role-btn--active {\n  background: rgba(52, 199, 89, 0.16) !important;\n  color: #34C759 !important;\n  box-shadow: inset 0 0 0 1px rgba(52, 199, 89, 0.35) !important;\n}\n\n.player-exercise-details__hr-role-btn--sparring {\n  background: rgba(255, 152, 0, 0.16) !important;\n  color: #FF9800 !important;\n  box-shadow: inset 0 0 0 1px rgba(255, 152, 0, 0.35) !important;\n}\n\n.player-exercise-details__hr-role-btn--empty {\n  opacity: 0.55 !important;\n}\n\n.player-exercise-details__hr-role-hint {\n  margin: 0 !important;\n  font-size: 11px !important;\n  line-height: 1.25 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__hr-role-hint--selected {\n  color: var(--text-color) !important;\n  font-weight: 600 !important;\n}\n\n.player-exercise-details__hr-clear-seq {\n  appearance: none !important;\n  border: 0 !important;\n  background: none !important;\n  color: var(--brand-primary, #0877bc) !important;\n  font: inherit !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  padding: 0 !important;\n  text-decoration: underline !important;\n  text-underline-offset: 2px !important;\n}\n\n.player-exercise-details__hr-clear-seq:hover {\n  opacity: 0.85 !important;\n}\n\n.player-exercise-details__hr-curve-card--seq-selected {\n  box-shadow:\n    0 2px 8px var(--shadow-color),\n    0 0 0 1px color-mix(in srgb, #FF453A 22%, transparent) !important;\n}\n\n.player-exercise-details__hr-seq-band--selected {\n  stroke: currentColor !important;\n}\n\n@keyframes player-hr-seq-band-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.72;\n  }\n}\n\n.player-exercise-details__hr-curve-card--seq-selected .player-exercise-details__hr-seq-band--selected {\n  animation: player-hr-seq-band-pulse 1.6s ease-in-out 2;\n}\n\n.player-exercise-details__hr-curve-body {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: stretch !important;\n  gap: 0 !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n\n.player-exercise-details__hr-curve-body--with-xticks {\n  height: auto !important;\n}\n\n@media (min-width: 768px) {\n  .player-exercise-details__hr-curve-axis {\n    width: 32px !important;\n    font-size: 11px !important;\n    padding: 12px 0 34px !important;\n  }\n}\n\n.player-exercise-details__hr-curve-axis {\n  display: none !important;\n}\n\n.player-exercise-details__hr-curve-chart {\n  flex: 1 1 100% !important;\n  position: relative !important;\n  min-width: 0 !important;\n  width: 100% !important;\n  height: auto !important;\n  min-height: 0 !important;\n}\n\n@media (max-width: 640px) {\n  .player-exercise-details__hr-curve-card,\n  .player-exercise-details__hr-curve-card--mobile {\n    padding: 8px 8px 6px !important;\n    border-radius: 14px !important;\n    gap: 6px !important;\n    margin-bottom: 10px !important;\n  }\n\n  .player-exercise-details__hr-curve-header-row {\n    flex-direction: column !important;\n    align-items: stretch !important;\n    gap: 6px !important;\n  }\n\n  .player-exercise-details__hr-curve-header {\n    font-size: 14px !important;\n    font-weight: 800 !important;\n    width: 100% !important;\n    line-height: 1.25 !important;\n    letter-spacing: -0.2px !important;\n    display: block !important;\n    color: #0f172a !important;\n  }\n\n  .player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-curve-header,\n  html[data-theme=\"dark\"] .player-exercise-details__hr-curve-header,\n  body[data-theme=\"dark\"] .player-exercise-details__hr-curve-header {\n    color: #ffffff !important;\n  }\n\n  .player-exercise-details__hr-role-toggle {\n    width: 100% !important;\n    display: flex !important;\n    justify-content: space-between !important;\n    padding: 2px !important;\n    box-sizing: border-box !important;\n  }\n\n  .player-exercise-details__hr-role-btn {\n    flex: 1 1 0 !important;\n    text-align: center !important;\n    padding: 6px 4px !important;\n    font-size: 11px !important;\n  }\n\n  .player-exercise-details__hr-curve-body {\n    gap: 0 !important;\n    width: 100% !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  .player-exercise-details__hr-curve-axis {\n    display: none !important;\n  }\n\n  .player-exercise-details__hr-curve-chart {\n    width: 100% !important;\n    height: auto !important;\n    min-height: 0 !important;\n  }\n}\n\n.player-exercise-details__hr-svg {\n  display: block !important;\n  width: 100% !important;\n  height: auto !important;\n  overflow: visible !important;\n}\n\n.player-exercise-details__hr-line-path {\n  filter: drop-shadow(0 0 6px rgba(255, 51, 75, 0.7)) drop-shadow(0 2px 12px rgba(255, 51, 75, 0.35));\n}\n\n.player-exercise-details__hr-zone-label {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif !important;\n  letter-spacing: 0.02em !important;\n}\n\n.player-exercise-details__hr-xtick-label {\n  user-select: none !important;\n  fill: #0f172a !important;\n  font-weight: 700 !important;\n}\n\nhtml[data-theme=\"light\"] .player-exercise-details__hr-xtick-label,\nbody[data-theme=\"light\"] .player-exercise-details__hr-xtick-label,\nbody.light-mode .player-exercise-details__hr-xtick-label,\n.player-exercise-details__hr-curve-card:not(.player-exercise-details__hr-curve-card--dark) .player-exercise-details__hr-xtick-label {\n  fill: #0f172a !important;\n}\n\n.player-exercise-details__hr-curve-card--dark .player-exercise-details__hr-xtick-label,\nhtml[data-theme=\"dark\"] .player-exercise-details__hr-xtick-label,\nbody[data-theme=\"dark\"] .player-exercise-details__hr-xtick-label {\n  fill: rgba(255, 255, 255, 0.92) !important;\n}\n\n/* Glow Pulse circle ring animation */\n@keyframes pulse {\n  0% {\n    transform: scale(0.6);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n}\n\n.pulse-ring {\n  transform-origin: center !important;\n  transform-box: fill-box !important;\n  animation: pulse 2.5s infinite ease-out !important;\n}\n\n/* Active Training Zones card */\n.player-exercise-details__hr-zones-card {\n  background: var(--surface-color) !important;\n  border-radius: 18px !important;\n  padding: 16px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 2px 10px var(--shadow-color) !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__zone-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 12px !important;\n  margin-top: 12px !important;\n}\n\n.player-exercise-details__zone-row {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: stretch !important;\n  gap: 6px !important;\n  width: 100% !important;\n}\n\n.player-exercise-details__zone-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  gap: 12px !important;\n}\n\n.player-exercise-details__zone-badge {\n  width: 28px !important;\n  height: 28px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  color: #FFFFFF !important;\n  flex-shrink: 0 !important;\n}\n\n/* Zone Badge Colors — match HrPerformanceCurveChart / ZONE_DEFS */\n.player-exercise-details__zone-badge--z5 {\n  background-color: #FF453A !important;\n}\n\n.player-exercise-details__zone-badge--z4 {\n  background-color: #FFD93D !important;\n  color: #1C1C1E !important;\n}\n\n.player-exercise-details__zone-badge--z3 {\n  background-color: #34C759 !important;\n}\n\n.player-exercise-details__zone-badge--z2 {\n  background-color: #4DABF7 !important;\n}\n\n.player-exercise-details__zone-badge--z01 {\n  background-color: #CED4DA !important;\n  color: #1C1C1E !important;\n}\n\n.player-exercise-details__zone-info {\n  flex: 1 !important;\n  width: auto !important;\n  text-align: left !important;\n}\n\n.player-exercise-details__zone-name {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__zone-progress-wrap {\n  width: 100% !important;\n  height: 8px !important;\n  background-color: var(--border-color) !important;\n  border-radius: 4px !important;\n  overflow: hidden !important;\n  transition: background 0.3s ease !important;\n}\n\n.player-exercise-details__zone-progress-bar {\n  height: 100% !important;\n  border-radius: 4px !important;\n}\n\n.player-exercise-details__zone-progress-bar--z5 {\n  background-color: #FF453A !important;\n}\n\n.player-exercise-details__zone-progress-bar--z4 {\n  background-color: #FFD93D !important;\n}\n\n.player-exercise-details__zone-progress-bar--z3 {\n  background-color: #34C759 !important;\n}\n\n.player-exercise-details__zone-progress-bar--z2 {\n  background-color: #4DABF7 !important;\n}\n\n.player-exercise-details__zone-progress-bar--z01 {\n  background-color: #CED4DA !important;\n}\n\n.player-exercise-details__zone-duration {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n  text-align: right !important;\n}\n\n/* Auto-Evaluation Panel Light Theme */\n.player-exercise-details__eval-section {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n}\n\n.player-exercise-details__eval-item {\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 16px !important;\n  padding: 16px !important;\n  box-shadow: 0 2px 8px var(--shadow-color) !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__eval-label {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  margin-bottom: 10px !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n}\n\n.player-exercise-details__emoji-eval-block {\n  margin-top: 20px !important;\n}\n\n.player-exercise-details__emoji-eval-block:first-child {\n  margin-top: 0 !important;\n}\n\n.player-exercise-details__emoji-eval-row {\n  display: flex !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n}\n\n.player-exercise-details__emoji-eval-tile {\n  flex: 1 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  padding: 10px 6px !important;\n  border-radius: 16px !important;\n  border: 1px solid var(--border-color) !important;\n  background: color-mix(in srgb, var(--text-color) 2%, var(--surface-color)) !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n}\n\n.player-exercise-details__emoji-eval-tile:hover {\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  transform: scale(1.03) !important;\n}\n\n.player-exercise-details__emoji-eval-tile--selected {\n  border-color: var(--emoji-tile-color, var(--brand-primary, #0877BC)) !important;\n  background: color-mix(in srgb, var(--emoji-tile-color, var(--brand-primary, #0877BC)) 12%, var(--surface-color)) !important;\n  transform: scale(1.06) !important;\n}\n\n.player-exercise-details__emoji-eval-icon {\n  font-size: 1.6rem !important;\n  line-height: 1.2 !important;\n}\n\n.player-exercise-details__emoji-eval-caption {\n  margin-top: 4px !important;\n  font-size: 0.6rem !important;\n  font-weight: 700 !important;\n  line-height: 1.1 !important;\n  text-align: center !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__emoji-eval-tile--selected .player-exercise-details__emoji-eval-caption {\n  color: var(--emoji-tile-color, var(--brand-primary, #0877BC)) !important;\n}\n\n.player-exercise-details__emoji-eval-summary-grid {\n  display: grid !important;\n  grid-template-columns: 1fr 1fr !important;\n  gap: 12px !important;\n}\n\n.player-exercise-details__emoji-eval-summary-card {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  padding: 16px 12px !important;\n  border-radius: 16px !important;\n  border: 1px solid var(--border-color) !important;\n  background: var(--surface-color) !important;\n  box-shadow: 0 2px 8px var(--shadow-color) !important;\n}\n\n.player-exercise-details__emoji-eval-summary-caption {\n  font-size: 0.65rem !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  color: var(--text-secondary) !important;\n  margin-bottom: 4px !important;\n}\n\n.player-exercise-details__emoji-eval-summary-icon {\n  font-size: 1.75rem !important;\n  line-height: 1.2 !important;\n  margin-bottom: 4px !important;\n}\n\n.player-exercise-details__emoji-eval-summary-label {\n  font-size: 0.75rem !important;\n  font-weight: 800 !important;\n  text-align: center !important;\n}\n\n.player-exercise-details__actions-container {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 12px !important;\n  margin-top: 28px !important;\n}\n\n.player-exercise-details__submit-btn {\n  width: 100% !important;\n  padding: 14px 20px !important;\n  border-radius: 999px !important;\n  border: none !important;\n  background: var(--brand-primary, #0877BC) !important;\n  color: #ffffff !important;\n  font-weight: 800 !important;\n  font-size: 0.9rem !important;\n  cursor: pointer !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  box-shadow: 0 8px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;\n  transition: transform 0.2s ease, filter 0.2s ease, background 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.player-exercise-details__submit-btn:hover:not(:disabled) {\n  filter: brightness(1.06) !important;\n  transform: translateY(-1px) !important;\n}\n\n.player-exercise-details__submit-btn:active:not(:disabled) {\n  transform: translateY(1px) scale(0.99) !important;\n  filter: brightness(0.94) !important;\n  box-shadow: 0 4px 14px color-mix(in srgb, var(--brand-primary, #0877BC) 22%, transparent) !important;\n}\n\n.player-exercise-details__submit-btn:disabled {\n  background: var(--border-color) !important;\n  color: var(--text-secondary) !important;\n  box-shadow: none !important;\n  cursor: not-allowed !important;\n  transform: none !important;\n}\n\n.player-exercise-details__cancel-btn {\n  width: 100% !important;\n  padding: 12px 20px !important;\n  border-radius: 999px !important;\n  border: 1px solid var(--border-color) !important;\n  background: transparent !important;\n  color: var(--text-secondary) !important;\n  font-weight: 700 !important;\n  font-size: 0.85rem !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease, color 0.2s ease !important;\n}\n\n.player-exercise-details__cancel-btn:hover {\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__edit-eval-btn {\n  width: 100% !important;\n  padding: 12px 20px !important;\n  border-radius: 999px !important;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 35%, var(--border-color)) !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877BC) 10%, var(--surface-color)) !important;\n  color: var(--brand-primary, #0877BC) !important;\n  font-weight: 800 !important;\n  font-size: 0.85rem !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease, transform 0.2s ease !important;\n}\n\n.player-exercise-details__edit-eval-btn:hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877BC) 16%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__edit-eval-btn:active {\n  transform: scale(0.99) !important;\n}\n\n.player-exercise-details__eval-video-card {\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 18px !important;\n  padding: 14px 16px !important;\n  box-shadow: 0 2px 10px var(--shadow-color) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n}\n\n.player-exercise-details__eval-video-card--lines {\n  gap: 6px !important;\n}\n\n.player-exercise-details__eval-video-card--playing {\n  border-color: var(--brand-primary, #0877BC) !important;\n  box-shadow:\n    0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877BC) 35%, transparent),\n    0 2px 12px var(--shadow-color) !important;\n  background: color-mix(\n    in srgb,\n    var(--brand-primary, #0877BC) 8%,\n    var(--surface-color)\n  ) !important;\n}\n\n.player-exercise-details__eval-video-card--playing .player-exercise-details__eval-video-line-icon {\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-exercise-details__eval-video-line {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  min-height: 28px !important;\n}\n\n.player-exercise-details__eval-video-line--header {\n  min-height: 32px !important;\n}\n\n.player-exercise-details__eval-video-line-main {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n.player-exercise-details__eval-video-line-icon {\n  flex-shrink: 0 !important;\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-exercise-details__eval-video-line-summary {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  line-height: 1.35 !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.player-exercise-details__eval-video-line--role .player-exercise-details__eval-video-role-slot {\n  flex-shrink: 0 !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  color: var(--text-secondary) !important;\n  min-width: 1.25em !important;\n}\n\n.player-exercise-details__eval-video-line--role .player-exercise-details__eval-video-role-name {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: var(--text-color) !important;\n  line-height: 1.35 !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.player-exercise-details__eval-video-card-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 12px !important;\n}\n\n.player-exercise-details__eval-video-card-title {\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 8px !important;\n  font-size: 14px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  line-height: 1.35 !important;\n}\n\n.player-exercise-details__eval-video-card-title span {\n  flex: 1 !important;\n  min-width: 0 !important;\n}\n\n.player-exercise-details__eval-video-card-meta {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 6px !important;\n  padding: 0 2px !important;\n}\n\n.player-exercise-details__eval-video-card-actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__move-video-btn {\n  border: 1px solid rgba(10, 132, 255, 0.35) !important;\n  background: rgba(10, 132, 255, 0.1) !important;\n  color: #0A84FF !important;\n  border-radius: 8px !important;\n  padding: 4px 10px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  white-space: nowrap !important;\n}\n\n.player-exercise-details__move-video-btn:hover {\n  background: rgba(10, 132, 255, 0.18) !important;\n}\n\n.player-exercise-details__eval-video-header-actions {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-shrink: 0 !important;\n}\n\n.player-exercise-details__move-video-icon-btn {\n  flex-shrink: 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 34px !important;\n  height: 34px !important;\n  border: 1px solid rgba(10, 132, 255, 0.35) !important;\n  background: rgba(10, 132, 255, 0.1) !important;\n  color: #0A84FF !important;\n  border-radius: 10px !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease, transform 0.15s ease !important;\n}\n\n.player-exercise-details__move-video-icon-btn:hover:not(:disabled) {\n  background: rgba(10, 132, 255, 0.18) !important;\n}\n\n.player-exercise-details__move-video-icon-btn:active:not(:disabled) {\n  transform: scale(0.96) !important;\n}\n\n.player-exercise-details__move-video-icon-btn:disabled {\n  opacity: 0.55 !important;\n  cursor: not-allowed !important;\n}\n\n.player-exercise-details__video-play-btn--inline {\n  width: 40px !important;\n  height: 40px !important;\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;\n}\n\n.player-exercise-details__eval-video-lefty-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  align-self: center !important;\n  flex-shrink: 0 !important;\n  padding: 2px 8px !important;\n  border-radius: 999px !important;\n  background: rgba(255, 149, 0, 0.15) !important;\n  color: #c77700 !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n}\n\n.player-exercise-details__eval-video-kot-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  align-self: center !important;\n  flex-shrink: 0 !important;\n  padding: 2px 8px !important;\n  border-radius: 999px !important;\n  background: rgba(255, 149, 0, 0.16) !important;\n  color: #ff9500 !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.03em !important;\n  text-transform: uppercase !important;\n}\n\n.player-exercise-details__eval-video-ready-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  align-self: center !important;\n  flex-shrink: 0 !important;\n  padding: 2px 8px !important;\n  border-radius: 999px !important;\n  background: rgba(34, 197, 94, 0.16) !important;\n  color: #16a34a !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n}\n\n.player-exercise-details__eval-video-ready-badge--pending {\n  background: rgba(148, 163, 184, 0.2) !important;\n  color: #64748b !important;\n}\n\n.player-exercise-details__eval-video-card--processing {\n  border-color: color-mix(\n    in srgb,\n    var(--brand-primary, #0877bc) 45%,\n    var(--border-color)\n  ) !important;\n}\n\n.player-exercise-details__eval-video-job {\n  margin-top: 4px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 6px !important;\n  padding-top: 6px !important;\n  border-top: 1px solid var(--border-color) !important;\n}\n\n.player-exercise-details__eval-video-job-label {\n  display: flex !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  font-size: 12px !important;\n  font-weight: 650 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__eval-video-job-track {\n  height: 6px !important;\n  border-radius: 999px !important;\n  background: rgba(128, 128, 128, 0.18) !important;\n  overflow: hidden !important;\n}\n\n.player-exercise-details__eval-video-job-fill {\n  height: 100% !important;\n  border-radius: inherit !important;\n  background: var(--brand-primary, #0877bc) !important;\n  transition: width 0.35s cubic-bezier(0.25, 1, 0.5, 1) !important;\n}\n\n.player-exercise-details__eval-video-job-error {\n  margin: 0 !important;\n  font-size: 12.5px !important;\n  line-height: 1.35 !important;\n  color: #ef4444 !important;\n  font-weight: 600 !important;\n}\n\n.player-exercise-details__eval-video-job-done {\n  margin: 0 !important;\n  font-size: 12.5px !important;\n  line-height: 1.35 !important;\n  color: #34c759 !important;\n  font-weight: 650 !important;\n}\n\n/* Above session media (13000), exercise sheet (9999/10050), and related coach dialogs */\n.MuiDialog-root.move-eval-video-dialog-root {\n  z-index: 15000 !important;\n}\n\n.move-eval-video-dialog {\n  padding: 20px 22px 24px !important;\n}\n\n.move-eval-video-dialog__title {\n  margin: 0 0 6px !important;\n  font-size: 18px !important;\n  font-weight: 800 !important;\n}\n\n.move-eval-video-dialog__subtitle {\n  margin: 0 0 18px !important;\n  font-size: 13px !important;\n  color: var(--text-secondary, #666) !important;\n}\n\n.move-eval-video-dialog__loading {\n  display: flex !important;\n  justify-content: center !important;\n  padding: 28px 0 !important;\n}\n\n.move-eval-video-dialog__form {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 14px !important;\n}\n\n.move-eval-video-dialog__label {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 6px !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n}\n\n.move-eval-video-dialog__label select {\n  padding: 10px 12px !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  background: #fff !important;\n}\n\n.move-eval-video-dialog__readonly {\n  padding: 10px 12px !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  background: rgba(0, 0, 0, 0.04) !important;\n  color: var(--text-secondary, #666) !important;\n}\n\n.move-eval-video-dialog__hint {\n  margin: -4px 0 0 !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  line-height: 1.4 !important;\n  color: #c77700 !important;\n}\n\n.move-eval-video-dialog__hint--muted {\n  margin: 0 !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary, #666) !important;\n}\n\n.move-eval-video-dialog__segment {\n  display: flex !important;\n  gap: 8px !important;\n}\n\n.move-eval-video-dialog__segment-btn {\n  flex: 1 !important;\n  min-height: 42px !important;\n  padding: 10px 12px !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  background: #fff !important;\n  color: var(--text-primary, #111) !important;\n  font-size: 14px !important;\n  font-weight: 650 !important;\n  cursor: pointer !important;\n  transition:\n    background 0.18s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.18s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.18s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.18s cubic-bezier(0.25, 1, 0.5, 1) !important;\n}\n\n.move-eval-video-dialog__segment-btn:hover:not(:disabled) {\n  border-color: rgba(10, 132, 255, 0.45) !important;\n  box-shadow: 0 4px 10px -2px rgba(10, 132, 255, 0.12) !important;\n}\n\n.move-eval-video-dialog__segment-btn:focus-visible {\n  outline: 2px solid #0a84ff !important;\n  outline-offset: 2px !important;\n}\n\n.move-eval-video-dialog__segment-btn--active {\n  border-color: #0a84ff !important;\n  background: rgba(10, 132, 255, 0.1) !important;\n  color: #0a5fcc !important;\n  box-shadow: 0 4px 12px -3px rgba(10, 132, 255, 0.22) !important;\n}\n\n.move-eval-video-dialog__segment-btn:disabled {\n  opacity: 0.55 !important;\n  cursor: default !important;\n}\n\n.move-eval-video-dialog__multi {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  padding: 10px 12px !important;\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n  border-radius: 8px !important;\n  background: rgba(0, 0, 0, 0.03) !important;\n}\n\n.move-eval-video-dialog__multi .move-eval-video-dialog__hint {\n  margin: 0 0 2px !important;\n}\n\n.move-eval-video-dialog__check {\n  display: flex !important;\n  align-items: flex-start !important;\n  gap: 8px !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: var(--text-primary, #222) !important;\n  cursor: pointer !important;\n}\n\n.move-eval-video-dialog__check input {\n  margin-top: 3px !important;\n  flex-shrink: 0 !important;\n}\n\n.move-eval-video-dialog__error {\n  color: #c62828 !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n}\n\n.move-eval-video-dialog__actions {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  gap: 10px !important;\n  margin-top: 8px !important;\n}\n\n.move-eval-video-dialog__actions-right {\n  display: flex !important;\n  justify-content: flex-end !important;\n  gap: 10px !important;\n  margin-left: auto !important;\n}\n\n.move-eval-video-dialog__delete-btn {\n  flex-shrink: 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 42px !important;\n  height: 42px !important;\n  border: 1px solid rgba(198, 40, 40, 0.35) !important;\n  background: rgba(198, 40, 40, 0.08) !important;\n  color: #c62828 !important;\n  border-radius: 10px !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease, transform 0.15s ease !important;\n}\n\n.move-eval-video-dialog__delete-btn:hover:not(:disabled) {\n  background: rgba(198, 40, 40, 0.16) !important;\n}\n\n.move-eval-video-dialog__delete-btn:active:not(:disabled) {\n  transform: scale(0.96) !important;\n}\n\n.move-eval-video-dialog__delete-btn:disabled {\n  opacity: 0.55 !important;\n  cursor: not-allowed !important;\n}\n\n.move-eval-video-dialog__btn {\n  border-radius: 10px !important;\n  padding: 10px 16px !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  border: none !important;\n}\n\n.move-eval-video-dialog__btn:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n.move-eval-video-dialog__btn--secondary {\n  background: rgba(0, 0, 0, 0.06) !important;\n  color: #333 !important;\n}\n\n.move-eval-video-dialog__btn--primary {\n  background: #0A84FF !important;\n  color: #fff !important;\n}\n\n.player-exercise-details__eval-video-role-line {\n  display: flex !important;\n  align-items: center !important;\n  flex-wrap: wrap !important;\n  gap: 6px !important;\n  font-size: 12px !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__eval-video-role-slot {\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__eval-video-role-name,\n.player-exercise-details__eval-video-role-name--viewer {\n  font-weight: 600 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__eval-video-role-name--viewer {\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-exercise-details__eval-video-role-value {\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__eval-video-link {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n  padding: 12px 16px !important;\n  border-radius: 999px !important;\n  background: var(--brand-primary, #0877BC) !important;\n  color: #ffffff !important;\n  font-weight: 800 !important;\n  font-size: 0.85rem !important;\n  text-decoration: none !important;\n  box-shadow: 0 8px 24px color-mix(in srgb, var(--brand-primary, #0877BC) 28%, transparent) !important;\n  transition: transform 0.2s ease, filter 0.2s ease !important;\n}\n\n.player-exercise-details__eval-video-link:hover {\n  filter: brightness(1.06) !important;\n  transform: translateY(-1px) !important;\n  color: #ffffff !important;\n}\n\n.player-exercise-details__eval-video-link:active {\n  transform: translateY(1px) scale(0.99) !important;\n  filter: brightness(0.94) !important;\n}\n\n.player-exercise-details__video-entry {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 14px !important;\n  padding: 12px 14px !important;\n  border-radius: 14px !important;\n  border: 1px solid var(--border-color) !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877BC) 6%, var(--surface-color)) !important;\n}\n\n.player-exercise-details__video-entry-body {\n  flex: 1 !important;\n  min-width: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n}\n\n.player-exercise-details__video-entry-label {\n  font-size: 14px !important;\n  font-weight: 800 !important;\n  color: var(--text-color) !important;\n  line-height: 1.3 !important;\n}\n\n.player-exercise-details__video-entry-date {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__video-entry-desc {\n  margin: 4px 0 0 !important;\n  font-size: 13px !important;\n  line-height: 1.45 !important;\n  color: var(--text-secondary) !important;\n  white-space: pre-wrap !important;\n}\n\n.player-exercise-details__video-play-btn {\n  flex-shrink: 0 !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 52px !important;\n  height: 52px !important;\n  border: none !important;\n  border-radius: 50% !important;\n  background: var(--brand-primary, #0877BC) !important;\n  color: #ffffff !important;\n  cursor: pointer !important;\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--brand-primary, #0877BC) 32%, transparent) !important;\n  transition: transform 0.2s ease, filter 0.2s ease !important;\n  -webkit-tap-highlight-color: transparent !important;\n}\n\n.player-exercise-details__video-play-btn:hover {\n  filter: brightness(1.06) !important;\n}\n\n.player-exercise-details__video-play-btn:active {\n  transform: scale(0.96) !important;\n  filter: brightness(0.94) !important;\n}\n\n.player-exercise-details__stars {\n  display: flex !important;\n  gap: 4px !important;\n}\n\n.player-exercise-details__star {\n  color: var(--border-color) !important;\n}\n\n.player-exercise-details__star--filled {\n  color: #FFD60A !important;\n}\n\n/* Exertion Pill List Light Mode */\n.player-exercise-details__rpe-pills {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 8px !important;\n}\n\n.player-exercise-details__rpe-pill {\n  padding: 6px 14px !important;\n  border-radius: 9999px !important;\n  background: var(--border-color) !important;\n  color: var(--text-color) !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  border: 1px solid transparent !important;\n  transition: all 0.2s ease !important;\n}\n\n.player-exercise-details__rpe-pill--active {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15) !important;\n  color: var(--brand-primary, #0877BC) !important;\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.3) !important;\n}\n\n/* Empty & Loading states adaptive */\n.player-session-results__loading,\n.player-session-results__empty {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 40px !important;\n  color: var(--text-secondary) !important;\n  text-align: center !important;\n}\n\n.player-session-results__empty-icon {\n  font-size: 48px !important;\n  color: var(--text-secondary) !important;\n  opacity: 0.4 !important;\n  margin-bottom: 12px !important;\n}\n\n.player-session-results__empty p {\n  margin: 0 !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-session-results__empty-box {\n  padding: 24px 16px !important;\n  text-align: center !important;\n  border: 1px dashed var(--border-color) !important;\n  border-radius: 16px !important;\n  background: color-mix(in srgb, var(--text-color) 2%, transparent) !important;\n}\n\n.player-session-results__empty-box p {\n  margin: 0 !important;\n  font-size: 13px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n}\n\n.player-session-results__empty--hr {\n  padding: 48px 24px !important;\n}\n\n/* KoT Matches — mobile gamification card list */\n.kot-match-list {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  overflow-x: hidden;\n}\n\n.kot-match-list__hero {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color)) 0%,\n    color-mix(in srgb, var(--brand-primary, #0877bc) 6%, var(--surface-color)) 100%\n  );\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, var(--border-color));\n  box-shadow: 0 4px 18px color-mix(in srgb, var(--brand-primary, #0877bc) 12%, transparent);\n}\n\n.kot-match-list__hero-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n}\n\n.kot-match-list__hero-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kot-match-list__title {\n  font-size: 14px;\n  font-weight: 800;\n  color: var(--text-color);\n  letter-spacing: -0.01em;\n}\n\n.kot-match-list__subtitle {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.kot-match-list__count-pill {\n  min-width: 36px;\n  height: 36px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  font-weight: 800;\n  color: #fff;\n  background: var(--brand-primary, #0877bc);\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);\n  flex-shrink: 0;\n}\n\n.kot-match-list__cards {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.kot-match-card {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 14px 14px 12px;\n  border-radius: 16px;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 10px var(--shadow-color);\n  overflow: hidden;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n\n  /* Force exactly 4 stacked horizontal lines one below each other */\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 12px !important;\n}\n\n.kot-match-card::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  background: var(--border-color);\n  border-radius: 16px 0 0 16px;\n}\n\n.kot-match-card--win::before {\n  background: linear-gradient(180deg, #34c759 0%, #22c55e 100%);\n}\n\n.kot-match-card--win {\n  border-color: color-mix(in srgb, #34c759 35%, var(--border-color));\n  background: linear-gradient(\n    145deg,\n    color-mix(in srgb, #34c759 8%, var(--surface-color)) 0%,\n    var(--surface-color) 55%\n  );\n}\n\n.kot-match-card--loss::before {\n  background: linear-gradient(180deg, #ff6b6b 0%, #ff453a 100%);\n}\n\n.kot-match-card--loss {\n  border-color: color-mix(in srgb, #ff453a 22%, var(--border-color));\n}\n\n.kot-match-card--pending::before,\n.kot-match-card--unknown::before {\n  background: linear-gradient(180deg, #ffcc00 0%, #ff9500 100%);\n}\n\n.kot-match-card--abandoned::before {\n  background: var(--text-secondary);\n}\n\n.kot-match-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.kot-match-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  min-width: 0;\n}\n\n.kot-match-card__badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.kot-match-card__badge--round {\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 14%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 24%, transparent);\n}\n\n.kot-match-card__badge--table {\n  color: var(--text-color);\n  background: color-mix(in srgb, var(--text-color) 6%, var(--surface-color));\n  border: 1px solid var(--border-color);\n}\n\n.kot-match-card__badge--video {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 26px;\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.kot-match-card__badge--video-ready {\n  background: color-mix(in srgb, #2ecc71 16%, var(--surface-color));\n  color: #1e9e57;\n  border: 1px solid color-mix(in srgb, #2ecc71 35%, transparent);\n}\n\n.kot-match-card__badge--video-missing {\n  background: color-mix(in srgb, var(--text-secondary) 10%, var(--surface-color));\n  color: var(--text-secondary);\n  border: 1px solid color-mix(in srgb, var(--text-secondary) 18%, transparent);\n  opacity: 0.85;\n}\n\n.kot-match-card--video-pending {\n  opacity: 0.98;\n}\n\n.kot-match-card__outcome {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  flex-shrink: 0;\n}\n\n.kot-match-card__outcome--win {\n  color: #15803d;\n  background: rgba(52, 199, 89, 0.16);\n  border: 1px solid rgba(52, 199, 89, 0.28);\n}\n\n.kot-match-card__outcome--loss {\n  color: #b91c1c;\n  background: rgba(255, 69, 58, 0.12);\n  border: 1px solid rgba(255, 69, 58, 0.22);\n}\n\n.kot-match-card__outcome--pending {\n  color: #b45309;\n  background: rgba(255, 149, 0, 0.12);\n  border: 1px solid rgba(255, 149, 0, 0.22);\n}\n\n.kot-match-card__outcome--abandoned,\n.kot-match-card__outcome--unknown {\n  color: var(--text-secondary);\n  background: var(--border-color);\n  border: 1px solid var(--border-color);\n}\n\n.kot-match-card__score-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.kot-match-card__score {\n  font-size: 26px;\n  font-weight: 900;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.03em;\n  line-height: 1;\n  color: var(--text-color);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.kot-match-card__points {\n  font-size: 12px;\n  font-weight: 800;\n  color: #15803d;\n  padding: 3px 8px;\n  border-radius: 8px;\n  background: rgba(52, 199, 89, 0.12);\n  border: 1px solid rgba(52, 199, 89, 0.2);\n  white-space: nowrap;\n}\n\n.kot-match-card__points--loss {\n  color: #b91c1c !important;\n  background: rgba(255, 69, 58, 0.12) !important;\n  border-color: rgba(255, 69, 58, 0.28) !important;\n}\n\n.kot-match-card__opponent-block {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n  flex: 1;\n}\n\n.kot-match-card__opponent-rank {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.kot-match-card__opponent-level {\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 2px 7px;\n  border-radius: 999px;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  flex-shrink: 0;\n}\n\n.kot-match-card__opponent-pts {\n  font-size: 10px;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n/* Final KoT classement panels */\n.kot-classement {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 12px;\n  border-radius: 16px;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n  box-shadow: 0 2px 10px var(--shadow-color);\n}\n\n.kot-classement__title {\n  margin: 0 0 10px;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-secondary);\n}\n\n.kot-classement__tags {\n  display: flex;\n  gap: 6px;\n  margin: 0 0 12px;\n  padding: 4px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color));\n  border: 1px solid var(--border-color);\n}\n\n.kot-classement__tag {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  padding: 8px 10px;\n  border: none;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.kot-classement__tag--active {\n  color: var(--text-color);\n  background: var(--surface-color);\n  box-shadow: 0 1px 4px var(--shadow-color);\n}\n\n.kot-classement__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.kot-classement__row {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--text-color) 2%, var(--surface-color));\n  border: 1px solid var(--border-color);\n}\n\n.kot-classement__row--me {\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 8%, var(--surface-color));\n}\n\n.kot-classement__rank {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--text-secondary);\n  background: var(--border-color);\n}\n\n.kot-classement__rank--1 {\n  color: #92400e;\n  background: linear-gradient(145deg, #fde68a, #fbbf24);\n}\n\n.kot-classement__rank--2 {\n  color: #475569;\n  background: linear-gradient(145deg, #e2e8f0, #cbd5e1);\n}\n\n.kot-classement__rank--3 {\n  color: #9a3412;\n  background: linear-gradient(145deg, #fdba74, #fb923c);\n}\n\n.kot-classement__player {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.kot-classement__name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-color);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kot-classement__club {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--brand-secondary, #46528b) !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kot-classement__value {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.kot-classement__value-main {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1px;\n  font-size: 15px;\n  font-weight: 900;\n  color: var(--text-color);\n  font-variant-numeric: tabular-nums;\n}\n\n.kot-classement__value-main--spread {\n  color: var(--brand-primary, #0877bc);\n}\n\n.kot-classement__value-unit {\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n}\n\n.kot-classement__value-sub {\n  font-size: 9px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.kot-match-card__versus {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  margin-bottom: 10px;\n}\n\n.kot-match-card__vs {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.kot-match-card__opponent {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-color);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex-shrink: 1;\n}\n\n.kot-match-card--has-video {\n  cursor: pointer;\n}\n\n.kot-match-card--has-video:active {\n  transform: scale(0.985);\n}\n\n.kot-match-card--has-video:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.kot-match-card__play-overlay {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 2px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  color: var(--brand-primary, #0877bc);\n  pointer-events: none;\n}\n\n.kot-match-card__play-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--surface-color));\n}\n\n.kot-match-card__video-label {\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.kot-match-card__video-pending {\n  display: block;\n  margin-top: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n.kot-match-card__video {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 2px;\n  padding: 10px 12px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.kot-match-card__video:hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color));\n}\n\n.kot-match-card__video:active {\n  transform: scale(0.98);\n}\n\n/* Perf tab — keep KoT list inside phone viewport */\n.ios-tab-content .kot-match-list,\n.player-session-results__body--nested .kot-match-list,\n.player-session-results__body .kot-match-list {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n@media (max-width: 520px) {\n  .kot-match-list__hero {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .kot-match-list__hero-icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .kot-match-list__title {\n    font-size: 13px;\n  }\n\n  .kot-match-list__subtitle {\n    font-size: 10px;\n  }\n\n  .kot-match-list__count-pill {\n    min-width: 32px;\n    height: 32px;\n    font-size: 13px;\n  }\n\n  .kot-match-card {\n    padding: 12px 12px 10px !important;\n    gap: 10px !important; /* Slightly tighter spacing on smaller screens */\n  }\n\n  .kot-match-card__line-row {\n    margin-bottom: 0 !important;\n    gap: 8px !important;\n  }\n\n  .kot-match-card__opponent-vs-name {\n    font-size: 14px !important;\n  }\n\n  .kot-match-card__score-display {\n    font-size: 18px !important;\n  }\n\n  .kot-match-card__score-title,\n  .kot-match-card__points-title {\n    font-size: 11px !important;\n  }\n\n  .kot-match-card__points-badge-new {\n    font-size: 11px !important;\n    padding: 3px 8px !important;\n  }\n\n  .kot-match-card__video-left-label {\n    font-size: 12px !important;\n  }\n\n  .kot-match-card__video-ready-text,\n  .kot-match-card__video-pending-text {\n    font-size: 11px !important;\n  }\n\n  /* Extreme small screen support down to 360px width to avoid any text clip/overflow */\n  @media (max-width: 380px) {\n    .kot-match-card__points-title,\n    .kot-match-card__score-title {\n      display: none !important;\n    }\n  }\n\n  .kot-match-card__badge {\n    font-size: 9px;\n    padding: 3px 7px;\n    letter-spacing: 0.02em;\n  }\n\n  .kot-match-card__outcome {\n    font-size: 9px;\n    padding: 3px 7px;\n  }\n\n  .kot-match-card__score {\n    font-size: 22px;\n  }\n\n  .kot-match-card__opponent {\n    font-size: 13px;\n  }\n\n  .kot-match-card__video {\n    font-size: 12px;\n    padding: 9px 10px;\n  }\n}\n\n@media (min-width: 480px) {\n  .kot-match-card__score {\n    font-size: 28px;\n  }\n}\n\n/* Legacy table styles (kept for any older views) */\n.player-exercise-details__kot-wrap {\n  width: 100% !important;\n  background: var(--surface-color) !important;\n  border-radius: 16px !important;\n  border: 1px solid var(--border-color) !important;\n  box-shadow: 0 2px 10px var(--shadow-color) !important;\n  overflow: hidden !important;\n  transition: background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease !important;\n}\n\n.player-exercise-details__kot-table {\n  width: 100% !important;\n  border-collapse: collapse !important;\n}\n\n.player-exercise-details__kot-table th {\n  background: var(--bg-color) !important;\n  padding: 12px !important;\n  text-align: left !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  color: var(--text-secondary) !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.03em !important;\n  transition: background 0.3s ease, border-color 0.3s ease, color 0.3s ease !important;\n}\n\n.player-exercise-details__kot-table td {\n  padding: 12px !important;\n  font-size: 13px !important;\n  color: var(--text-color) !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  transition: border-color 0.3s ease, color 0.3s ease !important;\n}\n\n.player-exercise-details__kot-table tr:last-child td {\n  border-bottom: none !important;\n}\n\n.player-exercise-details__outcome {\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n  font-size: 10px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  display: inline-block !important;\n}\n\n.player-exercise-details__outcome--win {\n  background: rgba(50, 215, 75, 0.15) !important;\n  color: #34C759 !important;\n  border: 1px solid rgba(50, 215, 75, 0.2) !important;\n}\n\n.player-exercise-details__outcome--loss {\n  background: rgba(255, 69, 58, 0.15) !important;\n  color: #FF453A !important;\n  border: 1px solid rgba(255, 69, 58, 0.2) !important;\n}\n\n.player-exercise-details__outcome--pending {\n  background: var(--border-color) !important;\n  color: var(--text-secondary) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n.player-exercise-details__kot-video-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  padding: 6px 10px !important;\n  border: none !important;\n  border-radius: 8px !important;\n  background: rgba(8, 119, 188, 0.12) !important;\n  color: var(--brand-primary, #0877BC) !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  transition: background 0.2s ease !important;\n}\n\n.player-exercise-details__kot-video-btn:hover {\n  background: rgba(8, 119, 188, 0.2) !important;\n}\n\n/* Exercise results dialog — ensure segmented tabs readable in light mode */\n.player-session-results__sheet .ios-segmented-control-btn:not(.active),\n.player-session-results__sheet--nested .ios-segmented-control-btn:not(.active) {\n  color: var(--text-secondary) !important;\n}\n\n.player-session-results__sheet .ios-segmented-control-btn.active,\n.player-session-results__sheet--nested .ios-segmented-control-btn.active {\n  color: #ffffff !important;\n}\n\n/* Navigation button (Back) */\n.player-session-results__back-btn {\n  background: transparent !important;\n  border: none !important;\n  color: var(--brand-primary, #0877BC) !important; /* Custom Brand color button */\n  font-weight: 700 !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  cursor: pointer !important;\n  padding: 6px 10px !important;\n  border-radius: 8px !important;\n  font-size: 13px !important;\n  transition: background 0.2s ease !important;\n}\n\n.player-session-results__back-btn:hover {\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;\n}\n\n@media (min-width: 600px) {\n  .player-session-results__sheet:not(.player-session-results__sheet--page)\n    .player-session-results__back-btn--ios-nav {\n    display: none !important;\n  }\n}\n\n/* Feedback section under Evaluation tab */\n.player-exercise-details__feedback-header {\n  margin-top: 24px !important;\n  margin-bottom: 12px !important;\n  border-top: 1px solid var(--border-color) !important;\n  padding-top: 20px !important;\n  transition: border-color 0.3s ease !important;\n}\n\n.player-exercise-details__feedback-title {\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  color: var(--text-secondary) !important;\n  margin: 0 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n}\n\n.player-exercise-details__feedback-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 14px !important;\n  margin-top: 14px !important;\n}\n\n.player-exercise-details__feedback-card {\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 16px !important;\n  padding: 16px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 12px !important;\n  box-shadow: 0 2px 8px var(--shadow-color) !important;\n  transition: all 0.2s ease !important;\n}\n\n.player-exercise-details__feedback-card:hover {\n  transform: translateY(-2px) !important;\n  border-color: var(--brand-primary, #0877BC) !important;\n  box-shadow: 0 4px 12px var(--shadow-color) !important;\n}\n\n.player-exercise-details__feedback-meta {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n}\n\n.player-exercise-details__feedback-sender {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n}\n\n.player-exercise-details__sender-img {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  object-fit: cover !important;\n  border: 1.5px solid var(--brand-primary, #0877BC) !important;\n  background: var(--bg-color) !important;\n}\n\n.player-exercise-details__sender-avatar-placeholder {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 50% !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1) !important;\n  color: var(--brand-primary, #0877BC) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  border: 1.5px solid var(--brand-primary, #0877BC) !important;\n}\n\n.player-exercise-details__sender-info {\n  display: flex !important;\n  flex-direction: column !important;\n  text-align: left !important;\n}\n\n.player-exercise-details__sender-name {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n}\n\n.player-exercise-details__sender-role {\n  font-size: 11px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n}\n\n.player-exercise-details__feedback-date {\n  font-size: 11px !important;\n  color: var(--text-secondary) !important;\n  font-weight: 500 !important;\n  opacity: 0.7 !important;\n}\n\n.player-exercise-details__feedback-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 4px 8px !important;\n  border-radius: 6px !important;\n  font-size: 10px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.03em !important;\n}\n\n.player-exercise-details__feedback-badge--evaluation {\n  background: rgba(0, 122, 255, 0.1) !important;\n  color: #007AFF !important;\n}\n\n.player-exercise-details__feedback-badge--video {\n  background: rgba(191, 90, 242, 0.1) !important;\n  color: #AF52DE !important;\n}\n\n.player-exercise-details__feedback-badge--voice {\n  background: rgba(52, 199, 89, 0.1) !important;\n  color: #34C759 !important;\n}\n\n.player-exercise-details__feedback-badge--text {\n  background: var(--border-color) !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-exercise-details__feedback-content {\n  width: 100% !important;\n}\n\n.player-exercise-details__text-bubble {\n  background: var(--bg-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 12px !important;\n  padding: 12px 14px !important;\n  font-size: 13px !important;\n  color: var(--text-color) !important;\n  line-height: 1.5 !important;\n  font-weight: 500 !important;\n  text-align: left !important;\n  transition: all 0.3s ease !important;\n}\n\n.player-exercise-details__media-wrapper {\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  border: 1px solid var(--border-color) !important;\n  background: #000000 !important;\n  transition: border-color 0.3s ease !important;\n}\n\n.player-exercise-details__media-wrapper video,\n.player-exercise-details__media-wrapper .review-video-player {\n  width: 100% !important;\n  max-height: 280px !important;\n  display: block !important;\n}\n\n.player-exercise-details__media-wrapper audio {\n  width: 100% !important;\n  display: block !important;\n  padding: 4px !important;\n  background: rgba(255, 255, 255, 0.08) !important;\n}\n\n\n/* ==========================================================================\n   TrainingSessionResultsDialog Exercise Cards (iOS SessionResults parity)\n   ========================================================================== */\n\n.player-session-results__ex-list {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 16px !important;\n  width: 100% !important;\n}\n\n.player-session-results__station {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n  width: 100% !important;\n}\n\n.player-session-results__station--flat {\n  gap: 12px !important;\n}\n\n.player-session-results__station-head {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 2px 4px 0 !important;\n}\n\n.player-session-results__station-swatch {\n  width: 10px !important;\n  height: 10px !important;\n  border-radius: 999px !important;\n  flex: 0 0 auto !important;\n}\n\n.player-session-results__station-name {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n}\n\n.player-session-results__station-meta {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary, #64748b) !important;\n}\n\n.player-exercise-details__seq-table {\n  flex: 0 0 auto !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  line-height: 1.2 !important;\n  padding: 2px 7px !important;\n  border-radius: 999px !important;\n  background: rgba(8, 119, 188, 0.12) !important;\n  color: #0877bc !important;\n}\n\n.player-session-results__ex-card {\n  width: 100% !important;\n  display: flex !important;\n  align-items: stretch !important;\n  background: var(--surface-color) !important;\n  border: 1px solid var(--border-color) !important;\n  border-radius: 16px !important;\n  padding: 0 !important;\n  cursor: pointer !important;\n  text-align: left !important;\n  box-shadow: none !important;\n  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease !important;\n  position: relative !important;\n  overflow: hidden !important;\n}\n\n.player-session-results__ex-card:hover {\n  transform: none !important;\n  border-color: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) !important;\n  box-shadow: 0 2px 10px var(--shadow-color) !important;\n}\n\n.player-session-results__ex-card:hover .player-session-results__chevron {\n  color: var(--brand-primary, #0877BC) !important;\n}\n\n.player-session-results__ex-card-accent {\n  width: 5px !important;\n  flex-shrink: 0 !important;\n  background: var(--brand-primary, #0877BC) !important;\n  border-radius: 16px 0 0 16px !important;\n}\n\n.player-session-results__ex-card--finalized {\n  border-color: rgba(220, 53, 69, 0.4) !important;\n  box-shadow: 0 2px 10px rgba(220, 53, 69, 0.12) !important;\n}\n\n.player-session-results__ex-card--finalized .player-session-results__ex-card-accent {\n  background: #dc3545 !important;\n}\n\n.player-session-results__ex-card--finalized:hover {\n  border-color: rgba(220, 53, 69, 0.55) !important;\n  box-shadow: 0 4px 14px rgba(220, 53, 69, 0.18) !important;\n}\n\n.player-session-results__ex-card-body {\n  flex: 1 !important;\n  min-width: 0 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n  padding: 14px 16px 14px 18px !important;\n}\n\n.player-session-results__ex-title-row {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n}\n\n.player-session-results__ex-name {\n  margin: 0 !important;\n  flex: 1 !important;\n  min-width: 0 !important;\n  font-size: 17px !important;\n  font-weight: 700 !important;\n  line-height: 1.3 !important;\n  letter-spacing: -0.2px !important;\n}\n\n.player-session-results__ex-name-prefix {\n  color: var(--brand-primary, #0877BC) !important;\n  margin-right: 0 !important;\n}\n\n.player-session-results__ex-name-text {\n  color: var(--text-color) !important;\n}\n\n.player-session-results__ex-subtitle {\n  margin: 0 !important;\n  font-size: 13px !important;\n  color: var(--text-secondary) !important;\n  line-height: 1.35 !important;\n}\n\n.player-session-results__ex-sparring {\n  display: flex !important;\n  align-items: center !important;\n  flex-wrap: wrap !important;\n  gap: 4px !important;\n  font-size: 12px !important;\n}\n\n.player-session-results__ex-sparring-label {\n  color: var(--brand-primary, #0877BC) !important;\n  font-weight: 700 !important;\n}\n\n.player-session-results__ex-sparring-name {\n  color: var(--text-color) !important;\n  font-weight: 500 !important;\n}\n\n.player-session-results__ex-sparring-rank {\n  display: inline-flex !important;\n  align-items: center !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.02em !important;\n  color: var(--brand-primary, #0877BC) !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12) !important;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.22) !important;\n  border-radius: 10px !important;\n  padding: 2px 8px !important;\n  line-height: 1.2 !important;\n  white-space: nowrap !important;\n}\n\n.player-session-results__ex-hr-container {\n  background: rgba(120, 120, 128, 0.08) !important;\n  border-radius: 10px !important;\n  padding: 8px 10px !important;\n}\n\n.player-session-results__ex-hr-empty {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: var(--text-secondary) !important;\n}\n\n.player-session-results__ex-hr-empty-icon {\n  font-size: 14px !important;\n  color: #e74c3c !important;\n}\n\n.player-session-results__ex-hr-summary-card {\n  margin-bottom: 0 !important;\n  padding: 12px 8px !important;\n}\n\n.player-session-results__ex-hr-summary-card\n  .player-exercise-details__hr-subcard-header {\n  font-size: 10px !important;\n  line-height: 1.2 !important;\n}\n\n.player-session-results__ex-hr-summary-card\n  .player-exercise-details__hr-subcard-header span {\n  white-space: normal !important;\n}\n\n.player-session-results__ex-default-metrics-card {\n  margin-top: 8px !important;\n  margin-bottom: 0 !important;\n  padding: 12px 8px !important;\n  grid-template-columns: repeat(2, 1fr) !important;\n}\n\n.player-exercise-details__default-metrics-card {\n  grid-template-columns: repeat(2, 1fr) !important;\n  margin-bottom: 16px !important;\n}\n\n.player-exercise-details__default-metrics-card--serve {\n  grid-template-columns: repeat(2, 1fr) !important;\n}\n\n.player-exercise-details__seq-default-metrics.player-exercise-details__default-metrics-card--serve {\n  max-width: 360px !important;\n}\n\n.player-exercise-details__seq-default-metrics {\n  margin: 8px 0 4px !important;\n  padding: 10px 8px !important;\n  grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n  max-width: 280px !important;\n  width: 100% !important;\n  align-self: flex-start !important;\n  box-shadow: none !important;\n}\n\n.player-exercise-details__hr-subcard--strokes {\n  background-color: rgba(8, 119, 188, 0.08) !important;\n  color: #0877bc !important;\n}\n\n.player-exercise-details__hr-subcard--max_rally {\n  background-color: rgba(175, 82, 222, 0.08) !important;\n  color: #af52de !important;\n}\n\n.player-session-results__ex-footer {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 8px !important;\n  min-height: 22px !important;\n}\n\n.player-session-results__ex-badges {\n  display: flex !important;\n  align-items: center !important;\n  flex-wrap: wrap !important;\n  gap: 6px !important;\n}\n\n.player-session-results__ex-pill {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 4px 10px !important;\n  border-radius: 11px !important;\n  border: 1px solid transparent !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  line-height: 1 !important;\n}\n\n.player-session-results__ex-pill--hr {\n  background: rgba(231, 76, 60, 0.08) !important;\n  border-color: rgba(231, 76, 60, 0.25) !important;\n  color: #e74c3c !important;\n}\n\n.player-session-results__ex-pill--kot {\n  background: rgba(52, 152, 219, 0.08) !important;\n  border-color: rgba(52, 152, 219, 0.25) !important;\n  color: #3498db !important;\n}\n\n.player-session-results__ex-pill--video {\n  background: rgba(8, 119, 188, 0.1) !important;\n  border-color: rgba(8, 119, 188, 0.3) !important;\n  color: #0877bc !important;\n}\n\n.player-session-results__ex-title-trailing {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-shrink: 0 !important;\n}\n\n.player-session-results__ex-video-indicator {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #0877bc !important;\n  line-height: 0 !important;\n}\n\n.player-session-results__ex-state {\n  flex-shrink: 0 !important;\n  padding: 4px 10px !important;\n  border-radius: 11px !important;\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.03em !important;\n  line-height: 1 !important;\n}\n\n.player-session-results__ex-state--finalized {\n  background: rgba(220, 53, 69, 0.12) !important;\n  color: #dc3545 !important;\n  border: 1px solid rgba(220, 53, 69, 0.28) !important;\n}\n\n.player-session-results__ex-state--pending {\n  background: rgba(255, 149, 0, 0.12) !important;\n  color: #ff9500 !important;\n}\n\n.player-session-results__chevron {\n  color: #c7c7cc !important;\n  transition: color 0.2s ease !important;\n  flex-shrink: 0 !important;\n  font-size: 20px !important;\n}\n\n/* Inline Sequences/Rounds Preview in TrainingSessionResultsDialog */\n.player-session-results__ex-sequences-preview {\n  margin-top: 12px !important;\n  padding: 10px 14px !important;\n  border-radius: 12px !important;\n  background: var(--border-color) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 8px !important;\n  width: 100% !important;\n  transition: background 0.3s ease !important;\n}\n\n.player-session-results__sequence-preview-item {\n  display: flex !important;\n  align-items: center !important;\n  gap: 10px !important;\n  font-size: 13px !important;\n  color: var(--text-color) !important;\n  width: 100% !important;\n}\n\n.player-session-results__seq-dot {\n  width: 6px !important;\n  height: 6px !important;\n  border-radius: 50% !important;\n  background-color: var(--brand-primary, #0877BC) !important;\n  flex-shrink: 0 !important;\n}\n\n.player-session-results__seq-dot--kot {\n  background-color: #FFCC00 !important;\n}\n\n.player-session-results__seq-text {\n  flex: 1 !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  text-align: left !important;\n  color: var(--text-color) !important;\n  font-weight: 500 !important;\n}\n\n.player-session-results__seq-dur {\n  font-size: 11px !important;\n  color: var(--text-secondary) !important;\n  background: var(--surface-color) !important;\n  padding: 2px 6px !important;\n  border-radius: 4px !important;\n  font-family: monospace !important;\n  font-weight: 600 !important;\n  transition: background 0.3s ease, color 0.3s ease !important;\n}\n\n/* Micro-Screen Responsive Tuning for 320px screens */\n@media (max-width: 400px) {\n  .player-exercise-details__tabs {\n    padding: 2px !important;\n    border-radius: 10px !important;\n    gap: 2px !important;\n  }\n  .player-exercise-details__tab {\n    padding: 6px 4px !important;\n    font-size: 11px !important;\n    letter-spacing: -0.2px !important;\n  }\n}\n\n/* Nested exercise sheet — slides above session results dialog */\n.player-session-results__backdrop--nested {\n  z-index: 10050 !important;\n  background: rgba(0, 0, 0, 0.42) !important;\n  backdrop-filter: blur(10px) !important;\n  -webkit-backdrop-filter: blur(10px) !important;\n  align-items: flex-end !important;\n  padding: 0 !important;\n}\n\n.light-mode .player-session-results__backdrop--nested {\n  background: rgba(0, 0, 0, 0.32) !important;\n}\n\n.player-session-results__sheet--fullwidth,\n.player-session-results__sheet--nested {\n  max-width: 100% !important;\n  width: 100% !important;\n  border-radius: 24px 24px 0 0 !important;\n  min-height: 78vh !important;\n  max-height: calc(\n    100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px)\n  ) !important;\n}\n\n.player-session-results__body--nested {\n  padding: 8px 20px 28px !important;\n  overflow-y: auto !important;\n}\n\n.player-session-results__content--nested {\n  height: 100% !important;\n}\n\n/* Full-page results route — dialog UI without app Header; body scrolls */\n.player-session-results__page-shell {\n  width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.player-session-results__sheet--page {\n  position: relative !important;\n  flex: 1 1 auto !important;\n  width: 100% !important;\n  max-width: none !important;\n  min-height: 0 !important;\n  height: 100% !important;\n  max-height: none !important;\n  border-radius: 0 !important;\n  animation: none !important;\n  margin-top: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n  overflow: hidden !important;\n  padding-top: env(safe-area-inset-top, 0px) !important;\n}\n\n.player-session-results__sheet--page .player-session-results__content {\n  height: 100% !important;\n  min-height: 0 !important;\n  overflow: hidden !important;\n}\n\n.player-session-results__sheet--page .player-session-results__body {\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  overflow-y: auto !important;\n  -webkit-overflow-scrolling: touch !important;\n}\n\n.player-session-results__coach-hint {\n  margin: 0 0 16px !important;\n  padding: 12px 14px !important;\n  border-radius: 12px !important;\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) !important;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15) !important;\n  color: var(--text-secondary) !important;\n  font-size: 0.82rem !important;\n  font-weight: 600 !important;\n  line-height: 1.4 !important;\n}\n\n.player-session-results__ex-card--disabled {\n  cursor: default !important;\n}\n\n.player-session-results__ex-card--disabled:hover {\n  border-color: var(--border-color) !important;\n  box-shadow: none !important;\n}\n\n/* ==========================================================================\n   Reorganized KOT Match Card\n   ========================================================================== */\n.kot-match-card__line-row {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  width: 100% !important;\n  gap: 12px !important;\n  margin-bottom: 0 !important; /* Managed by parent gap */\n  flex-wrap: nowrap !important; /* Forces Left + Right items on a single line */\n  box-sizing: border-box !important;\n}\n\n.kot-match-card__line-row--4 {\n  margin-bottom: 0 !important;\n}\n\n.kot-match-card__video-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 10px 12px !important;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent) !important;\n  border-radius: 12px !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color)) !important;\n  color: var(--brand-primary, #0877bc) !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  cursor: pointer !important;\n  transition: background 0.15s ease, transform 0.1s ease, border-color 0.15s ease !important;\n}\n\n.kot-match-card__video-btn:hover {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 16%, var(--surface-color)) !important;\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, transparent) !important;\n}\n\n.kot-match-card__video-btn:active {\n  transform: scale(0.985) !important;\n}\n\n.kot-match-card__video-btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc) !important;\n  outline-offset: 2px !important;\n}\n\n.kot-match-card__video-btn-icon {\n  flex-shrink: 0 !important;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n.kot-match-card__video-btn-label {\n  flex: 1 !important;\n  text-align: left !important;\n}\n\n.kot-match-card__round-label {\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  text-transform: uppercase !important;\n  color: var(--brand-primary, #0877bc) !important;\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 12%, var(--surface-color)) !important;\n  padding: 4px 10px !important;\n  border-radius: 8px !important;\n  letter-spacing: 0.02em !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__opponent-vs {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  min-width: 0 !important;\n  flex: 1 !important;\n}\n\n.kot-match-card__opponent-vs-prefix {\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  color: var(--text-secondary) !important;\n  text-transform: uppercase !important;\n  flex-shrink: 0 !important;\n}\n\n.kot-match-card__opponent-vs-name {\n  font-size: 16px !important;\n  font-weight: 900 !important;\n  color: var(--text-color) !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__opponent-ranking {\n  font-size: 11px !important;\n  font-weight: 800 !important;\n  text-transform: uppercase !important;\n  color: var(--brand-secondary, #46528b) !important;\n  background: color-mix(in srgb, var(--brand-secondary, #46528b) 12%, var(--surface-color)) !important;\n  border: 1px solid color-mix(in srgb, var(--brand-secondary, #46528b) 22%, transparent) !important;\n  padding: 3px 9px !important;\n  border-radius: 999px !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n}\n\n.kot-match-card__score-container {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  min-width: 0 !important;\n}\n\n.kot-match-card__score-title {\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  color: var(--text-secondary) !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.04em !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__score-display {\n  font-size: 20px !important;\n  font-weight: 900 !important;\n  color: var(--text-color) !important;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__points-container {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  flex-shrink: 0 !important;\n}\n\n.kot-match-card__points-title {\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  color: var(--text-secondary) !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.04em !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__points-badge-new {\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  color: #15803d !important;\n  background: rgba(52, 199, 89, 0.12) !important;\n  border: 1px solid rgba(52, 199, 89, 0.2) !important;\n  padding: 4px 10px !important;\n  border-radius: 8px !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__points-badge-new--loss {\n  color: #b91c1c !important;\n  background: rgba(255, 69, 58, 0.12) !important;\n  border-color: rgba(255, 69, 58, 0.2) !important;\n}\n\n.kot-match-card__points-badge-new--none {\n  color: var(--text-secondary) !important;\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  border-color: var(--border-color) !important;\n}\n\n.kot-match-card__outcome-pill {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 4px !important;\n  padding: 4px 10px !important;\n  border-radius: 999px !important;\n  font-size: 10px !important;\n  font-weight: 800 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n}\n\n.kot-match-card__outcome-pill--win {\n  color: #15803d !important;\n  background: rgba(52, 199, 89, 0.16) !important;\n  border: 1px solid rgba(52, 199, 89, 0.28) !important;\n}\n\n.kot-match-card__outcome-pill--loss {\n  color: #b91c1c !important;\n  background: rgba(255, 69, 58, 0.12) !important;\n  border: 1px solid rgba(255, 69, 58, 0.22) !important;\n}\n\n.kot-match-card__outcome-pill--pending {\n  color: #b45309 !important;\n  background: rgba(255, 149, 0, 0.12) !important;\n  border: 1px solid rgba(255, 149, 0, 0.22) !important;\n}\n\n.kot-match-card__outcome-pill--abandoned,\n.kot-match-card__outcome-pill--unknown {\n  color: var(--text-secondary) !important;\n  background: var(--border-color) !important;\n  border: 1px solid var(--border-color) !important;\n}\n\n/* Row 4 Video Highlights Specifics */\n.kot-match-card__video-left-label {\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  color: var(--brand-primary, #0877bc) !important;\n  transition: color 0.2s ease !important;\n  white-space: nowrap !important;\n}\n\n.kot-match-card__line-row--no-video .kot-match-card__video-left-label {\n  color: var(--text-secondary) !important;\n  opacity: 0.75 !important;\n}\n\n.kot-match-card__video-right-status {\n  display: flex !important;\n  align-items: center !important;\n  gap: 6px !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n}\n\n.kot-match-card__video-ready-text {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n.kot-match-card__video-play-icon {\n  color: var(--brand-primary, #0877bc) !important;\n}\n\n.kot-match-card__video-pending-text {\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n}\n\n.kot-match-card__video-off-icon {\n  color: var(--text-secondary) !important;\n  opacity: 0.7 !important;\n}\n\n/* Card Hover Interactions */\n.kot-match-card--has-video:hover {\n  transform: translateY(-2px) !important;\n  box-shadow: 0 6px 18px var(--shadow-color) !important;\n  border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color)) !important;\n}\n\n.kot-match-card--has-video:hover .kot-match-card__video-left-label {\n  color: color-mix(in srgb, var(--brand-primary, #0877bc) 80%, white) !important;\n}\n\n/* Message bubble sub-row (at the bottom of cards) */\n.kot-match-card__message-bubble {\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  color: var(--text-secondary) !important;\n  background: color-mix(in srgb, var(--text-color) 4%, var(--surface-color)) !important;\n  padding: 6px 10px !important;\n  border-radius: 8px !important;\n  text-align: left !important;\n  border: 1px solid var(--border-color) !important;\n  margin-top: 10px !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n}\n\n/* ==========================================================================\n   INTERACTIVE AUTO-EVALUATIONS, FEEDBACK HUBS, & VIDEOS REQUESTS PANEL\n   ========================================================================== */\n\n/* 1. Video Request Control Panel */\n.video-request-panel {\n  position: relative;\n  background: rgba(30, 41, 59, 0.45) !important;\n  backdrop-filter: blur(12px) !important;\n  -webkit-backdrop-filter: blur(12px) !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  border-radius: 12px !important;\n  padding: 16px 20px !important;\n  margin-bottom: 24px !important;\n  overflow: hidden !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;\n}\n\n.video-request-panel__glow {\n  position: absolute !important;\n  top: -50px !important;\n  left: -50px !important;\n  width: 150px !important;\n  height: 150px !important;\n  background: radial-gradient(circle, rgba(10, 132, 255, 0.15) 0%, transparent 70%) !important;\n  pointer-events: none !important;\n}\n\n.video-request-panel__content {\n  position: relative !important;\n  z-index: 1 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 14px !important;\n}\n\n@media (min-width: 640px) {\n  .video-request-panel__content {\n    flex-direction: row !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n  }\n}\n\n.video-request-panel__header-section {\n  flex: 1 !important;\n}\n\n.video-request-panel__title {\n  font-size: 14px !important;\n  font-weight: 800 !important;\n  color: #f8fafc !important;\n  margin: 0 0 4px 0 !important;\n  letter-spacing: 0.01em !important;\n}\n\n.video-request-panel__subtitle {\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  color: #94a3b8 !important;\n  margin: 0 !important;\n  line-height: 1.4 !important;\n}\n\n.video-request-panel__actions {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 10px !important;\n}\n\n.video-request-panel__btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-family: inherit !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  padding: 8px 14px !important;\n  border-radius: 8px !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  white-space: nowrap !important;\n}\n\n.video-request-panel__btn:disabled {\n  opacity: 0.5 !important;\n  cursor: not-allowed !important;\n}\n\n.video-request-panel__btn--exercise {\n  background: rgba(10, 132, 255, 0.1) !important;\n  color: #0A84FF !important;\n  border: 1px solid rgba(10, 132, 255, 0.25) !important;\n}\n\n.video-request-panel__btn--exercise:hover:not(:disabled) {\n  background: rgba(10, 132, 255, 0.2) !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(10, 132, 255, 0.15) !important;\n}\n\n.video-request-panel__btn--session {\n  background: rgba(139, 92, 246, 0.1) !important;\n  color: #a78bfa !important;\n  border: 1px solid rgba(139, 92, 246, 0.25) !important;\n}\n\n.video-request-panel__btn--session:hover:not(:disabled) {\n  background: rgba(139, 92, 246, 0.2) !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15) !important;\n}\n\n.video-request-panel__status {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 6px 12px !important;\n  border-radius: 6px !important;\n  font-size: 11px !important;\n  font-weight: 600 !important;\n  width: 100% !important;\n}\n\n@media (min-width: 640px) {\n  .video-request-panel__status {\n    width: auto !important;\n    margin-top: 0 !important;\n  }\n}\n\n.video-request-panel__status--success {\n  background: rgba(16, 185, 129, 0.12) !important;\n  color: #10b981 !important;\n  border: 1px solid rgba(16, 185, 129, 0.2) !important;\n}\n\n.video-request-panel__status--error {\n  background: rgba(239, 68, 68, 0.12) !important;\n  color: #ef4444 !important;\n  border: 1px solid rgba(239, 68, 68, 0.2) !important;\n}\n\n.video-request-panel__status-dot {\n  width: 6px !important;\n  height: 6px !important;\n  border-radius: 999px !important;\n  background-color: currentColor !important;\n}\n\n.video-request-panel__status-msg {\n  margin: 0 !important;\n}\n\n/* 2. Interactive Star Picker & RPE Pills */\n.player-exercise-details__star-btn {\n  background: none !important;\n  border: none !important;\n  padding: 0 !important;\n  margin-right: 4px !important;\n  cursor: pointer !important;\n  outline: none !important;\n  transition: transform 0.15s ease !important;\n}\n\n.player-exercise-details__star-btn:hover {\n  transform: scale(1.2) !important;\n}\n\n.player-exercise-details__interactive-star {\n  color: rgba(255, 255, 255, 0.15) !important;\n  font-size: 28px !important;\n  transition: color 0.15s ease, filter 0.15s ease !important;\n}\n\n.player-exercise-details__interactive-star--filled {\n  color: #fbbf24 !important;\n  filter: drop-shadow(0 0 6px rgba(251, 191, 36, 0.4)) !important;\n}\n\n.player-exercise-details__interactive-label {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: #fbbf24 !important;\n  margin-left: 12px !important;\n}\n\n.player-exercise-details__rpe-pill-picker {\n  display: grid !important;\n  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)) !important;\n  gap: 10px !important;\n  margin-top: 10px !important;\n}\n\n.player-exercise-details__rpe-pill-picker-btn {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 10px 8px !important;\n  border-radius: 10px !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  background: rgba(255, 255, 255, 0.02) !important;\n  color: #94a3b8 !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.player-exercise-details__rpe-pill-picker-btn:hover {\n  background: rgba(255, 255, 255, 0.05) !important;\n  border-color: rgba(255, 255, 255, 0.15) !important;\n  transform: translateY(-1px) !important;\n}\n\n.player-exercise-details__rpe-pill-picker-btn--active {\n  background: rgba(10, 132, 255, 0.12) !important;\n  border-color: rgba(10, 132, 255, 0.4) !important;\n  color: #0A84FF !important;\n  box-shadow: 0 4px 12px rgba(10, 132, 255, 0.1) !important;\n}\n\n.player-exercise-details__rpe-pill-picker-btn--active .rpe-pill-val {\n  color: #0A84FF !important;\n}\n\n.rpe-pill-val {\n  font-size: 16px !important;\n  font-weight: 900 !important;\n  color: #f8fafc !important;\n  margin-bottom: 2px !important;\n}\n\n.rpe-pill-label {\n  font-size: 9px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.03em !important;\n  text-align: center !important;\n}\n\n/* 3. Audio & Voice Recorder Pane */\n.voice-recorder-ui {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 12px 0 !important;\n}\n\n.voice-recorder-ui__recording-card {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  gap: 12px !important;\n  padding: 16px !important;\n  background: rgba(239, 68, 68, 0.04) !important;\n  border: 1px solid rgba(239, 68, 68, 0.15) !important;\n  border-radius: 12px !important;\n  width: 100% !important;\n  max-width: 320px !important;\n  box-sizing: border-box !important;\n}\n\n.voice-recorder-ui__mic-indicator {\n  width: 48px !important;\n  height: 48px !important;\n  border-radius: 999px !important;\n  background: #ef4444 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  position: relative !important;\n}\n\n.voice-recorder-ui__mic-indicator::after {\n  content: \"\" !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 999px !important;\n  background: rgba(239, 68, 68, 0.4) !important;\n  z-index: 0 !important;\n}\n\n.voice-recorder-ui__mic-indicator--pulsing::after {\n  animation: pulseRed 1.5s infinite ease-out !important;\n}\n\n@keyframes pulseRed {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n  100% {\n    transform: scale(1.6);\n    opacity: 0;\n  }\n}\n\n.voice-recorder-ui__timer {\n  font-size: 20px !important;\n  font-weight: 800 !important;\n  color: #ef4444 !important;\n  font-family: monospace !important;\n  letter-spacing: 0.05em !important;\n}\n\n.voice-recorder-ui__btn {\n  font-family: inherit !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  padding: 8px 16px !important;\n  border-radius: 8px !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n}\n\n.voice-recorder-ui__btn--stop {\n  background: #ef4444 !important;\n  color: #fff !important;\n}\n\n.voice-recorder-ui__btn--stop:hover {\n  background: #dc2626 !important;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.25) !important;\n}\n\n.voice-recorder-ui__btn--start {\n  background: rgba(255, 255, 255, 0.04) !important;\n  color: #f8fafc !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  padding: 12px 24px !important;\n}\n\n.voice-recorder-ui__btn--start:hover {\n  background: rgba(255, 255, 255, 0.08) !important;\n  border-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.mic-dot {\n  width: 8px !important;\n  height: 8px !important;\n  border-radius: 999px !important;\n  background: #ef4444 !important;\n}\n\n.voice-recorder-ui__preview-card {\n  width: 100% !important;\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.preview-card-title {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #94a3b8 !important;\n  text-transform: uppercase !important;\n  margin: 0 0 10px 0 !important;\n  letter-spacing: 0.03em !important;\n}\n\n.voice-recorder-ui__audio-preview {\n  width: 100% !important;\n  height: 40px !important;\n  outline: none !important;\n  margin-bottom: 12px !important;\n}\n\n.voice-recorder-ui__preview-actions {\n  display: flex !important;\n  gap: 10px !important;\n}\n\n.voice-recorder-ui__btn--reset {\n  background: rgba(255, 255, 255, 0.04) !important;\n  color: #94a3b8 !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n}\n\n.voice-recorder-ui__btn--reset:hover {\n  background: rgba(255, 255, 255, 0.08) !important;\n  color: #f8fafc !important;\n}\n\n/* 4. Video Selector Dropzone & Details */\n.video-uploader-dropzone {\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.video-uploader-dropzone__label {\n  cursor: pointer !important;\n  display: block !important;\n}\n\n.video-uploader-dropzone__inner {\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 24px 16px !important;\n  border: 2px dashed rgba(255, 255, 255, 0.1) !important;\n  border-radius: 12px !important;\n  background: rgba(0, 0, 0, 0.15) !important;\n  text-align: center !important;\n  transition: all 0.2s ease !important;\n}\n\n.video-uploader-dropzone__inner:hover {\n  border-color: rgba(10, 132, 255, 0.4) !important;\n  background: rgba(10, 132, 255, 0.02) !important;\n}\n\n.video-uploader-dropzone__icon {\n  color: #94a3b8 !important;\n  margin-bottom: 10px !important;\n}\n\n.video-uploader-dropzone__text-main {\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  color: #f8fafc !important;\n  margin-bottom: 4px !important;\n}\n\n.video-uploader-dropzone__text-sub {\n  font-size: 10px !important;\n  font-weight: 500 !important;\n  color: #64748b !important;\n}\n\n.video-uploader-preview-card {\n  display: flex !important;\n  flex-direction: column !important;\n}\n\n.video-selected-details {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 10px 14px !important;\n  background: rgba(10, 132, 255, 0.05) !important;\n  border: 1px solid rgba(10, 132, 255, 0.15) !important;\n  border-radius: 8px !important;\n  margin-bottom: 12px !important;\n}\n\n.video-selected-filename {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  color: #f8fafc !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  flex: 1 !important;\n}\n\n.video-selected-filesize {\n  font-size: 11px !important;\n  font-weight: 500 !important;\n  color: #64748b !important;\n  flex-shrink: 0 !important;\n}\n\n.video-uploader-preview-actions {\n  display: flex !important;\n  margin-bottom: 12px !important;\n}\n\n/* 5. Coach Hub Tabs & Card Layouts */\n.coach-feedback-hub__tabs {\n  scrollbar-width: none !important;\n}\n\n.coach-feedback-hub__tabs::-webkit-scrollbar {\n  display: none !important;\n}\n\n.coach-feedback-hub__tab {\n  display: flex !important;\n  align-items: center !important;\n  font-family: inherit !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #94a3b8 !important;\n  background: none !important;\n  border: none !important;\n  padding: 6px 12px !important;\n  border-radius: 6px !important;\n  cursor: pointer !important;\n  transition: all 0.15s ease !important;\n  white-space: nowrap !important;\n}\n\n.coach-feedback-hub__tab:hover {\n  color: #f8fafc !important;\n  background: rgba(255, 255, 255, 0.04) !important;\n}\n\n.coach-feedback-hub__tab--active {\n  color: #0A84FF !important;\n  background: rgba(10, 132, 255, 0.08) !important;\n}\n\n.coach-feedback-hub__submit-btn {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-family: inherit !important;\n  font-size: 13px !important;\n  font-weight: 700 !important;\n  width: 100% !important;\n  padding: 10px 16px !important;\n  border-radius: 8px !important;\n  background: #0A84FF !important;\n  color: #fff !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.coach-feedback-hub__submit-btn:hover:not(:disabled) {\n  background: #0070e3 !important;\n  box-shadow: 0 4px 14px rgba(10, 132, 255, 0.25) !important;\n}\n\n.coach-feedback-hub__submit-btn:disabled {\n  background: rgba(255, 255, 255, 0.03) !important;\n  color: #475569 !important;\n  cursor: not-allowed !important;\n}\n\n/* Feedback hub textareas */\n.feedback-hub-pane__textarea {\n  width: 100% !important;\n  padding: 12px !important;\n  border-radius: 8px !important;\n  border: 1px solid rgba(255, 255, 255, 0.08) !important;\n  background: rgba(0, 0, 0, 0.15) !important;\n  color: #fff !important;\n  outline: none !important;\n  font-size: 13px !important;\n  font-family: inherit !important;\n  resize: vertical !important;\n  box-sizing: border-box !important;\n}\n\n.feedback-hub-pane__textarea:focus {\n  border-color: rgba(10, 132, 255, 0.3) !important;\n}\n\n/* General clean margins and sections */\n.coach-eval-section-title {\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  color: #64748b !important;\n  margin: 0 0 12px 0 !important;\n}\n\n.coach-player-eval-empty {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  padding: 10px 14px !important;\n  background: rgba(255, 255, 255, 0.02) !important;\n  border: 1px solid rgba(255, 255, 255, 0.05) !important;\n  border-radius: 8px !important;\n}\n\n.coach-player-eval-empty p {\n  margin: 0 !important;\n  font-size: 12px !important;\n  color: #64748b !important;\n  font-weight: 600 !important;\n}\n\n.info-dot {\n  width: 6px !important;\n  height: 6px !important;\n  border-radius: 999px !important;\n  background-color: #64748b !important;\n}\n\n.coach-player-eval-card {\n  padding: 14px 16px !important;\n  background: rgba(255, 255, 255, 0.02) !important;\n  border: 1px solid rgba(255, 255, 255, 0.06) !important;\n  border-radius: 10px !important;\n}\n\n.coach-player-eval-metric {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n}\n\n.metric-label {\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  color: #94a3b8 !important;\n  width: 80px !important;\n}\n\n@keyframes slideInUp {\n  from {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.player-exercise-details__video-coverage {\n  margin: 0 0 14px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877BC) 24%, var(--border-color));\n  background: color-mix(in srgb, var(--brand-primary, #0877BC) 6%, var(--surface-color));\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.player-exercise-details__video-coverage p {\n  margin: 0 0 6px;\n}\n\n.player-exercise-details__video-coverage p:last-child {\n  margin-bottom: 0;\n}\n\n.player-exercise-details__video-coverage-meta {\n  opacity: 0.85;\n}\n\n.player-exercise-details__video-coverage-warn {\n  color: #b45309;\n}\n\n.player-exercise-details__seq-video-groups {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.player-exercise-details__seq-video-group {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.player-exercise-details__seq-video-group-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text-color);\n}\n\n.player-exercise-details__seq-video-missing {\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px dashed var(--border-color);\n  color: color-mix(in srgb, var(--text-color) 70%, transparent);\n  font-size: 13px;\n}\n\n.session-palmares {\n  margin: 0 0 16px;\n  border-radius: 18px;\n  overflow: hidden;\n  background: #07101f;\n  min-height: 280px;\n  color: #fff;\n}\n\n.session-palmares__preparing {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 220px;\n  padding: 24px 16px;\n  text-align: center;\n}\n\n.session-palmares__preparing p {\n  margin: 0;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.86);\n}\n\n.session-palmares__board {\n  padding: 20px 16px 16px;\n}\n\n.session-palmares__title {\n  margin: 0 0 16px;\n  text-align: center;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.session-palmares__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.session-palmares__row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.session-palmares__row.is-highlight {\n  outline: 2px solid #f5c518;\n}\n\n.session-palmares__rank {\n  width: 48px;\n  font-weight: 800;\n}\n\n.session-palmares__name {\n  flex: 1;\n  font-weight: 650;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.session-palmares__value {\n  font-weight: 800;\n}\n\n.session-palmares__row.is-pb .session-palmares__value {\n  color: #f5c518;\n}\n\n.session-palmares__reel {\n  position: relative;\n  background: #000;\n  min-height: 360px;\n  max-height: 70vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.session-palmares__video {\n  width: 100%;\n  max-height: 70vh;\n  object-fit: cover;\n  background: #000;\n}\n\n.session-palmares__badge {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.45);\n  font-weight: 800;\n  font-size: 15px;\n}\n\n.session-palmares__missing {\n  padding: 48px 16px;\n  text-align: center;\n  font-weight: 700;\n}\n\n/* ==========================================================================\n   Desktop PC results workspace (session + exercise + session-summary)\n   Goal: keep the HR curve on-screen, a stable visual frame, and a scannable\n   two-pane layout so users are not lost in a mobile-style vertical stack.\n   ========================================================================== */\n\n@media (min-width: 768px) {\n  .player-session-results__handle {\n    display: none !important;\n  }\n\n  .player-session-results__backdrop {\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 28px 32px !important;\n    background: rgba(15, 23, 42, 0.42) !important;\n  }\n\n  .player-session-results__backdrop--nested {\n    align-items: center !important;\n    justify-content: center !important;\n    padding: 28px 32px !important;\n    background: rgba(15, 23, 42, 0.5) !important;\n    backdrop-filter: blur(14px) !important;\n    -webkit-backdrop-filter: blur(14px) !important;\n  }\n\n  .light-mode .player-session-results__backdrop,\n  .light-mode .player-session-results__backdrop--nested {\n    background: rgba(15, 23, 42, 0.28) !important;\n  }\n\n  .player-session-results__sheet:not(.player-session-results__sheet--page),\n  .player-session-results__sheet--nested,\n  .player-session-results__sheet--fullwidth {\n    width: min(1120px, calc(100vw - 64px)) !important;\n    max-width: min(1120px, calc(100vw - 64px)) !important;\n    min-height: 0 !important;\n    height: min(88vh, 920px) !important;\n    max-height: min(88vh, 920px) !important;\n    border-radius: 20px !important;\n    border: 1px solid var(--border-color) !important;\n    box-shadow:\n      0 24px 64px rgba(15, 23, 42, 0.22),\n      0 2px 8px rgba(15, 23, 42, 0.08) !important;\n    animation: resultsDesktopDialogIn 0.32s cubic-bezier(0.25, 1, 0.5, 1) !important;\n  }\n\n  .player-session-results__close {\n    position: relative !important;\n    top: auto !important;\n    right: auto !important;\n    width: 36px !important;\n    height: 36px !important;\n    background: rgba(120, 120, 128, 0.16) !important;\n    border: 1px solid rgba(120, 120, 128, 0.22) !important;\n  }\n\n  .player-session-results__header {\n    padding: 14px 28px 14px 24px !important;\n    background: color-mix(in srgb, var(--surface-color) 88%, transparent) !important;\n    backdrop-filter: blur(16px) !important;\n    -webkit-backdrop-filter: blur(16px) !important;\n  }\n\n  .player-session-results__header-top {\n    margin-bottom: 2px !important;\n    min-height: 28px !important;\n  }\n\n  .player-session-results__title-new {\n    font-size: 18px !important;\n    letter-spacing: -0.35px !important;\n  }\n\n  .player-session-results__subtitle-new,\n  .player-session-results__subtitle-meta {\n    font-size: 13px !important;\n    margin-top: 2px !important;\n  }\n\n  .player-session-results__body,\n  .player-session-results__body--nested {\n    padding: 16px 24px 24px !important;\n  }\n\n  .player-exercise-details__tabs {\n    position: sticky !important;\n    top: -16px !important;\n    z-index: 8 !important;\n    margin: -4px -24px 16px !important;\n    padding: 10px 24px 0 !important;\n    background: var(--bg-color) !important;\n  }\n\n  .player-exercise-details__tab {\n    padding: 10px 8px !important;\n    font-size: 13px !important;\n  }\n}\n\n@keyframes resultsDesktopDialogIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.985);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@media (min-width: 900px) {\n  .player-session-results__page-shell {\n    max-width: 1180px;\n    padding: 0 20px;\n  }\n\n  .player-session-results__sheet--page {\n    border-radius: 0 !important;\n    overflow: hidden !important;\n  }\n\n  .player-session-results__workspace:has(\n      .session-training-summary,\n      .session-training-summary--tappable\n    ) {\n    display: grid;\n    grid-template-columns: minmax(292px, 360px) minmax(0, 1fr);\n    gap: 20px;\n    align-items: start;\n  }\n\n  .player-session-results__workspace:has(\n      .session-training-summary,\n      .session-training-summary--tappable\n    )\n    > .session-training-summary,\n  .player-session-results__workspace:has(\n      .session-training-summary,\n      .session-training-summary--tappable\n    )\n    > .session-training-summary--tappable {\n    position: sticky;\n    top: 0;\n    max-height: calc(88vh - 132px);\n    overflow-y: auto;\n    margin-bottom: 0;\n    scrollbar-width: thin;\n  }\n\n  .player-session-results__workspace-main {\n    min-width: 0;\n  }\n\n  .player-session-results__ex-card-body {\n    padding: 12px 14px 12px 16px !important;\n    gap: 8px !important;\n  }\n\n  .player-session-results__ex-name {\n    font-size: 15px !important;\n  }\n\n  .player-session-results__ex-hr-summary-card {\n    padding: 8px 6px !important;\n  }\n\n  .player-exercise-details__hr-section > .player-exercise-details__section-title {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border: 0;\n  }\n\n  .player-exercise-details__hr-dashboard {\n    display: grid;\n    grid-template-columns: minmax(0, 1.55fr) minmax(280px, 0.92fr);\n    grid-template-areas:\n      \"metrics metrics\"\n      \"chart zones\";\n    gap: 14px 16px;\n    align-items: start;\n  }\n\n  .player-exercise-details__hr-dashboard-metrics {\n    grid-area: metrics;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 12px;\n    align-items: stretch;\n  }\n\n  .player-exercise-details__hr-dashboard-metrics > :only-child {\n    grid-column: 1 / -1;\n  }\n\n  .player-exercise-details__hr-dashboard-metrics\n    .player-exercise-details__hr-summary-card {\n    margin-bottom: 0 !important;\n    padding: 10px 10px !important;\n    gap: 8px !important;\n  }\n\n  .player-exercise-details__hr-dashboard-metrics\n    .player-exercise-details__default-metrics-card {\n    margin: 0 !important;\n    min-width: 196px;\n    max-width: 240px;\n    align-self: stretch;\n  }\n\n  .player-exercise-details__hr-dashboard-chart {\n    grid-area: chart;\n    min-width: 0;\n    align-self: start;\n  }\n\n  .player-exercise-details__hr-dashboard-zones {\n    grid-area: zones;\n    min-width: 0;\n    align-self: start;\n  }\n\n  .player-exercise-details__hr-dashboard-zones\n    .player-exercise-details__hr-zones-card {\n    margin: 0;\n    padding: 14px !important;\n  }\n\n  .player-exercise-details__hr-curve-card,\n  .player-exercise-details__hr-curve-card--desktop {\n    margin-bottom: 0 !important;\n    padding: 8px 12px 6px !important;\n    gap: 4px !important;\n    box-sizing: border-box;\n  }\n\n  .player-exercise-details__hr-summary-card--session {\n    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;\n  }\n\n  .player-exercise-details__hr-curve-header {\n    font-size: 13px !important;\n  }\n\n  .player-exercise-details__hr-role-hint {\n    font-size: 10px !important;\n    line-height: 1.3 !important;\n  }\n\n  .player-exercise-details__hr-curve-chart,\n  .player-exercise-details__hr-svg {\n    max-height: 220px !important;\n  }\n\n  .player-exercise-details__hr-svg {\n    width: 100% !important;\n    height: auto !important;\n  }\n\n  .player-exercise-details__zone-list {\n    gap: 8px !important;\n    margin-top: 8px !important;\n  }\n\n  .player-exercise-details__zone-row {\n    gap: 4px !important;\n  }\n\n  .player-exercise-details__perf-seq-grid {\n    display: grid !important;\n    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;\n    gap: 12px !important;\n  }\n\n  .player-exercise-details__perf-seq-card {\n    padding: 12px !important;\n  }\n}\n\n@media (min-width: 1100px) {\n  .player-session-results__sheet:not(.player-session-results__sheet--page),\n  .player-session-results__sheet--nested,\n  .player-session-results__sheet--fullwidth {\n    width: min(1180px, calc(100vw - 72px)) !important;\n    max-width: min(1180px, calc(100vw - 72px)) !important;\n  }\n\n  .player-exercise-details__hr-summary-card--session {\n    grid-template-columns: repeat(6, minmax(0, 1fr)) !important;\n  }\n}\n\n@media (min-width: 900px) and (max-height: 820px) {\n  .player-exercise-details__hr-curve-chart,\n  .player-exercise-details__hr-svg {\n    max-height: 176px !important;\n  }\n\n  .player-session-results__workspace:has(\n      .session-training-summary,\n      .session-training-summary--tappable\n    )\n    > .session-training-summary,\n  .player-session-results__workspace:has(\n      .session-training-summary,\n      .session-training-summary--tappable\n    )\n    > .session-training-summary--tappable {\n    max-height: calc(88vh - 112px);\n  }\n}\n\n\n\n/* Coach tool results (chrono / counter) on the exercise Perf tab */\n.exercise-tool-results {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.exercise-tool-results__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 10px;\n}\n\n.exercise-tool-results__card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 14px;\n  background: var(--surface-color);\n  border: 1px solid var(--border-color);\n}\n\n.exercise-tool-results__icon {\n  color: var(--brand-primary, #0877bc);\n  font-size: 26px !important;\n}\n\n.exercise-tool-results__text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.exercise-tool-results__label {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--text-secondary);\n}\n\n.exercise-tool-results__value {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--text-color);\n  font-variant-numeric: tabular-nums;\n}\n\n.exercise-tool-results__video-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, var(--surface-color));\n  color: var(--brand-primary, #0877bc);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
